import tt, { createContext as rs, useMemo as is, useState as ye, useCallback as Tt, useEffect as xe, useContext as Se, useRef as We, forwardRef as Do, createElement as sr } from "react";
const os = {
  xpertKey: "edx",
  chatApi: {
    endpoint: "https://xpert-platform-services-api.prod.ai.2u.com/xpert/chat",
    payloadParams: null
  },
  primaryColor: "#0E3639",
  disclaimer: {
    text: "Before we get started, just a reminder that this chat is AI generated, mistakes are possible. By using it you agree that edX may create a record of this chat. Your personal data will be used as described in our",
    privacyPolicyLink: "https://www.edx.org/edx-privacy-policy"
  },
  userTracking: {
    enabled: !0,
    prefix: "edx",
    payloadParams: null
  },
  webExperimentation: {
    enabled: !0,
    experimentName: "xpertChatbotExperiment"
  },
  launchButton: {
    message: null,
    animatedGraduate: {
      enabled: !0,
      delayMs: 7e3
    },
    style: {
      backgroundColor: "#0E3639",
      padding: "15px 25px",
      iconWidth: "5rem",
      bottom: "1rem",
      right: "1.5rem",
      zIndex: "99999",
      animatedGraduateExperiment: {
        backgroundColor: "transparent",
        border: "none",
        borderRadius: 0,
        padding: 0,
        iconWidth: "4.5rem",
        bottom: "1rem",
        right: "1.5rem",
        zIndex: "99999"
      },
      mobile: {
        backgroundColor: "#0E3639",
        padding: "15px 25px",
        iconWidth: "5rem",
        bottom: "5rem",
        right: "1.5rem",
        zIndex: "99999",
        animatedGraduateExperiment: {
          backgroundColor: "transparent",
          border: "none",
          borderRadius: 0,
          padding: 0,
          iconWidth: "4.5rem",
          bottom: "5rem",
          right: "1.5rem",
          zIndex: "99999"
        }
      }
    }
  },
  proactiveMessage: {
    enabled: !0,
    textPrefix: "Hi!",
    showEmoji: !0,
    text: "I'm Xpert, an AI assistant to help you find things.",
    delayMs: 4e3,
    style: {
      bottom: "6.75rem",
      right: "1.75rem",
      zIndex: "99999",
      animatedGraduateExperiment: {
        bottom: "7.5rem",
        right: "2rem",
        zIndex: "99999"
      },
      mobile: {
        bottom: "10.75rem",
        right: "1.75rem",
        zIndex: "99999",
        animatedGraduateExperiment: {
          bottom: "11.5rem",
          right: "2rem",
          zIndex: "99999"
        }
      }
    }
  },
  conversationScreen: {
    header: {
      logo: {
        type: "edx",
        style: {
          width: "7rem",
          marginLeft: "1.5rem"
        }
      },
      container: {
        style: {
          background: "linear-gradient(to left, rgb(58, 101, 108) 0px, rgb(0, 29, 34))"
        }
      }
    },
    systemMessage: null,
    prompts: null,
    userMessageBubble: null,
    conversationHistory: {
      enabled: !0
    },
    maintenanceBanner: {
      enabled: !0,
      header: "Planned Maintenance",
      text: "Xpert Chat will undergo maintenance on Aug. 15 at 7 AM EDT (~1hr). If needed, you may contact edX support through [Help Center](https://support.edx.org/hc/en-us)",
      endDateTime: "2024-08-15T12:00:00Z"
    },
    liveChat: {
      enabled: !1,
      sourceCode: null,
      options: null
    }
  }
}, as = {
  xpertKey: "speech-emerson",
  chatApi: {
    endpoint: "https://xpert-platform-services-api.prod.ai.2u.com/xpert/admissions",
    payloadParams: null
  },
  primaryColor: "#542291",
  disclaimer: {
    text: "Before we get started, just a reminder that this chat is AI generated, mistakes are possible. By using it you agree that edX may create a record of this chat. Your personal data will be used as described in our",
    privacyPolicyLink: "https://speech.emerson.edu/legal/privacy-policy/"
  },
  userTracking: {
    enabled: !0,
    prefix: "speech.emerson",
    payloadParams: null
  },
  webExperimentation: {
    enabled: !0,
    experimentName: "xpertChatbotExperiment"
  },
  launchButton: {
    message: null,
    animatedGraduate: null,
    style: {
      backgroundColor: "#542291",
      padding: "12px",
      paddingBottom: "8px",
      iconWidth: "2rem",
      bottom: "1rem",
      right: "1.5rem",
      zIndex: "99999",
      mobile: {
        backgroundColor: "#542291",
        padding: "12px",
        paddingBottom: "8px",
        iconWidth: "2rem",
        bottom: "5rem",
        right: "1.52rem",
        zIndex: "99999"
      }
    }
  },
  proactiveMessage: {
    enabled: !0,
    textPrefix: "Hi!",
    showEmoji: !0,
    text: `I'm Xpert your friendly AI assistant. Need information on Speech@Emerson? You can ask me something like, "How do I apply?"`,
    delayMs: 0,
    style: {
      bottom: "6.5rem",
      right: "1.45rem",
      zIndex: "99999",
      mobile: {
        bottom: "10.5rem",
        right: "1.35rem",
        zIndex: "99999"
      }
    }
  },
  conversationScreen: {
    header: {
      logo: {
        type: "default",
        style: {
          width: "5rem",
          backgroundColor: "#F0CC00"
        }
      },
      container: null
    },
    systemMessage: null,
    prompts: [
      { id: 1, text: "What's the application process?" },
      { id: 2, text: "When's the application Deadline?" },
      { id: 3, text: "I want to speak with an Advisor" }
    ],
    userMessageBubble: {
      style: {
        backgroundColor: "#F0CC00",
        color: "#000000"
      }
    },
    conversationHistory: {
      enabled: !1
    },
    maintenanceBanner: {
      enabled: !0,
      header: "Planned Maintenance",
      text: "On Aug. 15 at 7AM EDT (~1 hr), Xpert Chat will be unavailable for maintenance. Thanks for your patience!",
      endDateTime: "2024-08-15T12:00:00Z"
    },
    liveChat: {
      enabled: !1,
      sourceCode: null,
      options: null
    }
  }
}, ls = {
  xpertKey: "get-smarter",
  chatApi: {
    endpoint: "https://xpert-platform-services-api.prod.ai.2u.com/xpert/omnichannel",
    payloadParams: {
      use_case: "GET_SMARTER",
      tags: ["live_agent"]
    }
  },
  primaryColor: "#E31A82",
  disclaimer: {
    text: "Before we get started, just a reminder that this chat is AI generated, mistakes are possible. By using it you agree that GetSmarter may create a record of this chat. Your personal data will be used as described in our",
    privacyPolicyLink: "https://www.getsmarter.com/privacy-policy"
  },
  userTracking: {
    enabled: !0,
    prefix: "get.smarter",
    payloadParams: null
  },
  webExperimentation: {
    enabled: !1,
    experimentName: null
  },
  launchButton: {
    message: null,
    animatedGraduate: null,
    style: {
      backgroundColor: "#E31A82",
      padding: "0.75rem",
      paddingBottom: "0.5rem",
      iconWidth: "2rem",
      bottom: "1rem",
      right: "1.5rem",
      zIndex: "99999",
      mobile: {
        backgroundColor: "#E31A82",
        padding: "0.75rem",
        paddingBottom: "0.5rem",
        iconWidth: "2rem",
        bottom: "5rem",
        right: "1.52rem",
        zIndex: "99999"
      }
    }
  },
  proactiveMessage: {
    enabled: !0,
    textPrefix: null,
    showEmoji: !0,
    text: "Got questions about billing, registration, or payment options? I'm here to help!",
    delayMs: 0,
    style: {
      bottom: "6.5rem",
      right: "1.45rem",
      zIndex: "99999",
      mobile: {
        bottom: "10.5rem",
        right: "1.35rem",
        zIndex: "99999"
      }
    }
  },
  conversationScreen: {
    header: {
      logo: {
        type: "default",
        style: {
          width: "5rem",
          backgroundColor: "#082135",
          color: "#FFFFFF"
        }
      },
      container: null
    },
    systemMessage: "Hi there! 👋 I'm Xpert, what can I help you with? I'm available to answer questions about things like billing, registration, and payment options.",
    prompts: null,
    userMessageBubble: {
      style: {
        backgroundColor: "#E31A82",
        color: "#FFFFFF"
      }
    },
    conversationHistory: {
      enabled: !1
    },
    maintenanceBanner: {
      enabled: !0,
      header: "Planned Maintenance",
      text: "On Aug. 15 at 7AM EDT (~1 hr), Xpert Chat will be unavailable for maintenance. You may still connect with a live agent by selecting the button below.",
      endDateTime: "2024-08-15T12:00:00Z"
    },
    liveChat: {
      enabled: !0,
      sourceCode: "https://live-chat.ps.five9.com/Five9ChatPlugin.js",
      options: {
        appId: "2U Inc",
        configId: "Exec-Ed | Titan Main Flow_Xpert"
      }
    }
  }
}, ss = {
  xpertKey: "degrees-canvas-support",
  chatApi: {
    endpoint: "https://xpert-platform-services-api.prod.ai.2u.com/xpert/omnichannel",
    payloadParams: {
      use_case: "Canvas_Student",
      tags: ["live_agent"]
    }
  },
  primaryColor: "#193d77",
  disclaimer: {
    text: "Before we get started, just a reminder that this chat is AI generated, mistakes are possible. By using it you agree that 2U may create a record of this chat. Your personal data will be used as described in our",
    privacyPolicyLink: "https://essential.2u.com/privacy-policy"
  },
  userTracking: {
    enabled: !0,
    prefix: "degrees.canvas.support",
    payloadParams: null
  },
  webExperimentation: {
    enabled: !1,
    experimentName: null
  },
  launchButton: {
    message: null,
    animatedGraduate: null,
    style: {
      backgroundColor: "#193d77",
      padding: "0.75rem",
      paddingBottom: "0.5rem",
      iconWidth: "2rem",
      bottom: "1rem",
      right: "1.5rem",
      zIndex: "99999",
      mobile: {
        backgroundColor: "#193d77",
        padding: "0.75rem",
        paddingBottom: "0.5rem",
        iconWidth: "2rem",
        bottom: "5rem",
        right: "1.52rem",
        zIndex: "99999"
      }
    }
  },
  proactiveMessage: {
    enabled: !1
  },
  conversationScreen: {
    header: {
      logo: {
        type: "default",
        style: {
          width: "5rem",
          backgroundColor: "#193d77",
          color: "#FFFFFF"
        }
      },
      container: null
    },
    systemMessage: "Hi there! 👋 I'm Xpert, what can I help you with? I'm available to answer questions about technical issues, navigating the Digital Campus, or using Digital Campus features.",
    prompts: null,
    userMessageBubble: {
      style: {
        backgroundColor: "#193d77",
        color: "#FFFFFF"
      }
    },
    conversationHistory: {
      enabled: !1
    },
    maintenanceBanner: {
      enabled: !0,
      header: "Planned Maintenance",
      text: "On Aug. 15 at 7AM EDT (~1 hr), Xpert Chat will be unavailable for maintenance. You may still connect with a live agent by selecting the button below.",
      endDateTime: "2024-08-15T12:00:00Z"
    },
    liveChat: {
      enabled: !0,
      sourceCode: "https://live-chat.ps.five9.com/Five9ChatPlugin.js",
      options: {
        appId: "2U Inc",
        configId: "Degree | Support_Main_Flow_Xpert"
      }
    }
  }
}, us = {
  xpertKey: "degrees-moodle-support",
  chatApi: {
    endpoint: "https://xpert-platform-services-api.prod.ai.2u.com/xpert/omnichannel",
    payloadParams: {
      use_case: "Moodle_Student",
      tags: ["live_agent"]
    }
  },
  primaryColor: "#193d77",
  disclaimer: {
    text: "Before we get started, just a reminder that this chat is AI generated, mistakes are possible. By using it you agree that 2U may create a record of this chat. Your personal data will be used as described in our",
    privacyPolicyLink: "https://essential.2u.com/privacy-policy"
  },
  userTracking: {
    enabled: !0,
    prefix: "degrees.moodle.support",
    payloadParams: null
  },
  webExperimentation: {
    enabled: !1,
    experimentName: null
  },
  launchButton: {
    message: null,
    animatedGraduate: null,
    style: {
      backgroundColor: "#193d77",
      padding: "0.75rem",
      paddingBottom: "0.5rem",
      iconWidth: "2rem",
      bottom: "1rem",
      right: "1.5rem",
      zIndex: "99999",
      mobile: {
        backgroundColor: "#193d77",
        padding: "0.75rem",
        paddingBottom: "0.5rem",
        iconWidth: "2rem",
        bottom: "5rem",
        right: "1.52rem",
        zIndex: "99999"
      }
    }
  },
  proactiveMessage: {
    enabled: !1
  },
  conversationScreen: {
    header: {
      logo: {
        type: "default",
        style: {
          width: "5rem",
          backgroundColor: "#193d77",
          color: "#FFFFFF"
        }
      },
      container: null
    },
    systemMessage: "Hi there! 👋 I'm Xpert, what can I help you with? I'm available to answer questions about technical issues, navigating the Digital Campus, or using Digital Campus features.",
    prompts: null,
    userMessageBubble: {
      style: {
        backgroundColor: "#193d77",
        color: "#FFFFFF"
      }
    },
    conversationHistory: {
      enabled: !1
    },
    maintenanceBanner: {
      enabled: !0,
      header: "Planned Maintenance",
      text: "On Aug. 15 at 7AM EDT (~1 hr), Xpert Chat will be unavailable for maintenance. You may still connect with a live agent by selecting the button below.",
      endDateTime: "2024-08-15T12:00:00Z"
    },
    liveChat: {
      enabled: !0,
      sourceCode: "https://live-chat.ps.five9.com/Five9ChatPlugin.js",
      options: {
        appId: "2U Inc",
        configId: "Degree | Support_Main_Flow_Xpert"
      }
    }
  }
};
var en = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function rt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function No(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var Io = { exports: {} }, Vt = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var hi = Object.getOwnPropertySymbols, cs = Object.prototype.hasOwnProperty, ps = Object.prototype.propertyIsEnumerable;
function fs(e) {
  if (e == null)
    throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e);
}
function ds() {
  try {
    if (!Object.assign)
      return !1;
    var e = new String("abc");
    if (e[5] = "de", Object.getOwnPropertyNames(e)[0] === "5")
      return !1;
    for (var t = {}, n = 0; n < 10; n++)
      t["_" + String.fromCharCode(n)] = n;
    var r = Object.getOwnPropertyNames(t).map(function(o) {
      return t[o];
    });
    if (r.join("") !== "0123456789")
      return !1;
    var i = {};
    return "abcdefghijklmnopqrst".split("").forEach(function(o) {
      i[o] = o;
    }), Object.keys(Object.assign({}, i)).join("") === "abcdefghijklmnopqrst";
  } catch {
    return !1;
  }
}
ds();
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hs = tt, ko = 60103;
Vt.Fragment = 60107;
if (typeof Symbol == "function" && Symbol.for) {
  var gi = Symbol.for;
  ko = gi("react.element"), Vt.Fragment = gi("react.fragment");
}
var gs = hs.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, ms = Object.prototype.hasOwnProperty, ys = { key: !0, ref: !0, __self: !0, __source: !0 };
function jo(e, t, n) {
  var r, i = {}, o = null, a = null;
  n !== void 0 && (o = "" + n), t.key !== void 0 && (o = "" + t.key), t.ref !== void 0 && (a = t.ref);
  for (r in t)
    ms.call(t, r) && !ys.hasOwnProperty(r) && (i[r] = t[r]);
  if (e && e.defaultProps)
    for (r in t = e.defaultProps, t)
      i[r] === void 0 && (i[r] = t[r]);
  return { $$typeof: ko, type: e, key: o, ref: a, props: i, _owner: gs.current };
}
Vt.jsx = jo;
Vt.jsxs = jo;
Io.exports = Vt;
var v = Io.exports;
/*! js-cookie v3.0.5 | MIT */
function tn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      e[r] = n[r];
  }
  return e;
}
var Ms = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function ur(e, t) {
  function n(i, o, a) {
    if (!(typeof document > "u")) {
      a = tn({}, t, a), typeof a.expires == "number" && (a.expires = new Date(Date.now() + a.expires * 864e5)), a.expires && (a.expires = a.expires.toUTCString()), i = encodeURIComponent(i).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var l = "";
      for (var s in a)
        a[s] && (l += "; " + s, a[s] !== !0 && (l += "=" + a[s].split(";")[0]));
      return document.cookie = i + "=" + e.write(o, i) + l;
    }
  }
  function r(i) {
    if (!(typeof document > "u" || arguments.length && !i)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], a = {}, l = 0; l < o.length; l++) {
        var s = o[l].split("="), u = s.slice(1).join("=");
        try {
          var c = decodeURIComponent(s[0]);
          if (a[c] = e.read(u, c), i === c)
            break;
        } catch {
        }
      }
      return i ? a[i] : a;
    }
  }
  return Object.create(
    {
      set: n,
      get: r,
      remove: function(i, o) {
        n(
          i,
          "",
          tn({}, o, {
            expires: -1
          })
        );
      },
      withAttributes: function(i) {
        return ur(this.converter, tn({}, this.attributes, i));
      },
      withConverter: function(i) {
        return ur(tn({}, this.converter, i), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var Ne = ur(Ms, { path: "/" }), Eo = { exports: {} }, bs = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED", xs = bs, ws = xs;
function Co() {
}
function Ao() {
}
Ao.resetWarningCache = Co;
var vs = function() {
  function e(r, i, o, a, l, s) {
    if (s !== ws) {
      var u = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      throw u.name = "Invariant Violation", u;
    }
  }
  e.isRequired = e;
  function t() {
    return e;
  }
  var n = {
    array: e,
    bigint: e,
    bool: e,
    func: e,
    number: e,
    object: e,
    string: e,
    symbol: e,
    any: e,
    arrayOf: t,
    element: e,
    elementType: e,
    instanceOf: t,
    node: e,
    objectOf: t,
    oneOf: t,
    oneOfType: t,
    shape: t,
    exact: t,
    checkPropTypes: Ao,
    resetWarningCache: Co
  };
  return n.PropTypes = n, n;
};
Eo.exports = vs();
var B = Eo.exports;
const N = /* @__PURE__ */ rt(B);
var dn = { exports: {} };
dn.exports;
(function(e, t) {
  var n = 200, r = "__lodash_hash_undefined__", i = 800, o = 16, a = 9007199254740991, l = "[object Arguments]", s = "[object Array]", u = "[object AsyncFunction]", c = "[object Boolean]", p = "[object Date]", m = "[object Error]", f = "[object Function]", T = "[object GeneratorFunction]", x = "[object Map]", k = "[object Number]", M = "[object Null]", z = "[object Object]", E = "[object Proxy]", _ = "[object RegExp]", U = "[object Set]", b = "[object String]", L = "[object Undefined]", $ = "[object WeakMap]", W = "[object ArrayBuffer]", K = "[object DataView]", A = "[object Float32Array]", w = "[object Float64Array]", j = "[object Int8Array]", O = "[object Int16Array]", F = "[object Int32Array]", Q = "[object Uint8Array]", V = "[object Uint8ClampedArray]", q = "[object Uint16Array]", X = "[object Uint32Array]", g = /[\\^$.*+?()[\]{}|]/g, he = /^\[object .+?Constructor\]$/, Me = /^(?:0|[1-9]\d*)$/, h = {};
  h[A] = h[w] = h[j] = h[O] = h[F] = h[Q] = h[V] = h[q] = h[X] = !0, h[l] = h[s] = h[W] = h[c] = h[K] = h[p] = h[m] = h[f] = h[x] = h[k] = h[z] = h[_] = h[U] = h[b] = h[$] = !1;
  var ge = typeof en == "object" && en && en.Object === Object && en, ke = typeof self == "object" && self && self.Object === Object && self, re = ge || ke || Function("return this")(), we = t && !t.nodeType && t, ve = we && !0 && e && !e.nodeType && e, Ue = ve && ve.exports === we, ze = Ue && ge.process, Xe = function() {
    try {
      var d = ve && ve.require && ve.require("util").types;
      return d || ze && ze.binding && ze.binding("util");
    } catch {
    }
  }(), at = Xe && Xe.isTypedArray;
  function kt(d, y, D) {
    switch (D.length) {
      case 0:
        return d.call(y);
      case 1:
        return d.call(y, D[0]);
      case 2:
        return d.call(y, D[0], D[1]);
      case 3:
        return d.call(y, D[0], D[1], D[2]);
    }
    return d.apply(y, D);
  }
  function jt(d, y) {
    for (var D = -1, P = Array(d); ++D < d; )
      P[D] = y(D);
    return P;
  }
  function Et(d) {
    return function(y) {
      return d(y);
    };
  }
  function Ke(d, y) {
    return d == null ? void 0 : d[y];
  }
  function mt(d, y) {
    return function(D) {
      return d(y(D));
    };
  }
  var lt = Array.prototype, yt = Function.prototype, R = Object.prototype, ee = re["__core-js_shared__"], me = yt.toString, le = R.hasOwnProperty, Qe = function() {
    var d = /[^.]+$/.exec(ee && ee.keys && ee.keys.IE_PROTO || "");
    return d ? "Symbol(src)_1." + d : "";
  }(), $e = R.toString, Mt = me.call(Object), I = RegExp(
    "^" + me.call(le).replace(g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), S = Ue ? re.Buffer : void 0, Y = re.Symbol, J = re.Uint8Array, oe = S ? S.allocUnsafe : void 0, Te = mt(Object.getPrototypeOf, Object), Ye = Object.create, He = R.propertyIsEnumerable, st = lt.splice, je = Y ? Y.toStringTag : void 0, ue = function() {
    try {
      var d = Un(Object, "defineProperty");
      return d({}, "", {}), d;
    } catch {
    }
  }(), Ct = S ? S.isBuffer : void 0, Le = Math.max, nl = Date.now, ri = Un(re, "Map"), At = Un(Object, "create"), rl = function() {
    function d() {
    }
    return function(y) {
      if (!ct(y))
        return {};
      if (Ye)
        return Ye(y);
      d.prototype = y;
      var D = new d();
      return d.prototype = void 0, D;
    };
  }();
  function ut(d) {
    var y = -1, D = d == null ? 0 : d.length;
    for (this.clear(); ++y < D; ) {
      var P = d[y];
      this.set(P[0], P[1]);
    }
  }
  function il() {
    this.__data__ = At ? At(null) : {}, this.size = 0;
  }
  function ol(d) {
    var y = this.has(d) && delete this.__data__[d];
    return this.size -= y ? 1 : 0, y;
  }
  function al(d) {
    var y = this.__data__;
    if (At) {
      var D = y[d];
      return D === r ? void 0 : D;
    }
    return le.call(y, d) ? y[d] : void 0;
  }
  function ll(d) {
    var y = this.__data__;
    return At ? y[d] !== void 0 : le.call(y, d);
  }
  function sl(d, y) {
    var D = this.__data__;
    return this.size += this.has(d) ? 0 : 1, D[d] = At && y === void 0 ? r : y, this;
  }
  ut.prototype.clear = il, ut.prototype.delete = ol, ut.prototype.get = al, ut.prototype.has = ll, ut.prototype.set = sl;
  function Ze(d) {
    var y = -1, D = d == null ? 0 : d.length;
    for (this.clear(); ++y < D; ) {
      var P = d[y];
      this.set(P[0], P[1]);
    }
  }
  function ul() {
    this.__data__ = [], this.size = 0;
  }
  function cl(d) {
    var y = this.__data__, D = Zt(y, d);
    if (D < 0)
      return !1;
    var P = y.length - 1;
    return D == P ? y.pop() : st.call(y, D, 1), --this.size, !0;
  }
  function pl(d) {
    var y = this.__data__, D = Zt(y, d);
    return D < 0 ? void 0 : y[D][1];
  }
  function fl(d) {
    return Zt(this.__data__, d) > -1;
  }
  function dl(d, y) {
    var D = this.__data__, P = Zt(D, d);
    return P < 0 ? (++this.size, D.push([d, y])) : D[P][1] = y, this;
  }
  Ze.prototype.clear = ul, Ze.prototype.delete = cl, Ze.prototype.get = pl, Ze.prototype.has = fl, Ze.prototype.set = dl;
  function bt(d) {
    var y = -1, D = d == null ? 0 : d.length;
    for (this.clear(); ++y < D; ) {
      var P = d[y];
      this.set(P[0], P[1]);
    }
  }
  function hl() {
    this.size = 0, this.__data__ = {
      hash: new ut(),
      map: new (ri || Ze)(),
      string: new ut()
    };
  }
  function gl(d) {
    var y = Kt(this, d).delete(d);
    return this.size -= y ? 1 : 0, y;
  }
  function ml(d) {
    return Kt(this, d).get(d);
  }
  function yl(d) {
    return Kt(this, d).has(d);
  }
  function Ml(d, y) {
    var D = Kt(this, d), P = D.size;
    return D.set(d, y), this.size += D.size == P ? 0 : 1, this;
  }
  bt.prototype.clear = hl, bt.prototype.delete = gl, bt.prototype.get = ml, bt.prototype.has = yl, bt.prototype.set = Ml;
  function xt(d) {
    var y = this.__data__ = new Ze(d);
    this.size = y.size;
  }
  function bl() {
    this.__data__ = new Ze(), this.size = 0;
  }
  function xl(d) {
    var y = this.__data__, D = y.delete(d);
    return this.size = y.size, D;
  }
  function wl(d) {
    return this.__data__.get(d);
  }
  function vl(d) {
    return this.__data__.has(d);
  }
  function Tl(d, y) {
    var D = this.__data__;
    if (D instanceof Ze) {
      var P = D.__data__;
      if (!ri || P.length < n - 1)
        return P.push([d, y]), this.size = ++D.size, this;
      D = this.__data__ = new bt(P);
    }
    return D.set(d, y), this.size = D.size, this;
  }
  xt.prototype.clear = bl, xt.prototype.delete = xl, xt.prototype.get = wl, xt.prototype.has = vl, xt.prototype.set = Tl;
  function Dl(d, y) {
    var D = Hn(d), P = !D && Yn(d), ne = !D && !P && si(d), se = !D && !P && !ne && ci(d), fe = D || P || ne || se, te = fe ? jt(d.length, String) : [], de = te.length;
    for (var _e in d)
      (y || le.call(d, _e)) && !(fe && // Safari 9 has enumerable `arguments.length` in strict mode.
      (_e == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      ne && (_e == "offset" || _e == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      se && (_e == "buffer" || _e == "byteLength" || _e == "byteOffset") || // Skip index properties.
      ai(_e, de))) && te.push(_e);
    return te;
  }
  function Rn(d, y, D) {
    (D !== void 0 && !Jt(d[y], D) || D === void 0 && !(y in d)) && Bn(d, y, D);
  }
  function Nl(d, y, D) {
    var P = d[y];
    (!(le.call(d, y) && Jt(P, D)) || D === void 0 && !(y in d)) && Bn(d, y, D);
  }
  function Zt(d, y) {
    for (var D = d.length; D--; )
      if (Jt(d[D][0], y))
        return D;
    return -1;
  }
  function Bn(d, y, D) {
    y == "__proto__" && ue ? ue(d, y, {
      configurable: !0,
      enumerable: !0,
      value: D,
      writable: !0
    }) : d[y] = D;
  }
  var Il = Rl();
  function Xt(d) {
    return d == null ? d === void 0 ? L : M : je && je in Object(d) ? Bl(d) : ql(d);
  }
  function ii(d) {
    return St(d) && Xt(d) == l;
  }
  function kl(d) {
    if (!ct(d) || Hl(d))
      return !1;
    var y = qn(d) ? I : he;
    return y.test(Zl(d));
  }
  function jl(d) {
    return St(d) && ui(d.length) && !!h[Xt(d)];
  }
  function El(d) {
    if (!ct(d))
      return $l(d);
    var y = li(d), D = [];
    for (var P in d)
      P == "constructor" && (y || !le.call(d, P)) || D.push(P);
    return D;
  }
  function oi(d, y, D, P, ne) {
    d !== y && Il(y, function(se, fe) {
      if (ne || (ne = new xt()), ct(se))
        Cl(d, y, fe, D, oi, P, ne);
      else {
        var te = P ? P(Qn(d, fe), se, fe + "", d, y, ne) : void 0;
        te === void 0 && (te = se), Rn(d, fe, te);
      }
    }, pi);
  }
  function Cl(d, y, D, P, ne, se, fe) {
    var te = Qn(d, D), de = Qn(y, D), _e = fe.get(de);
    if (_e) {
      Rn(d, D, _e);
      return;
    }
    var Ee = se ? se(te, de, D + "", d, y, fe) : void 0, Ot = Ee === void 0;
    if (Ot) {
      var Vn = Hn(de), Wn = !Vn && si(de), di = !Vn && !Wn && ci(de);
      Ee = de, Vn || Wn || di ? Hn(te) ? Ee = te : Xl(te) ? Ee = _l(te) : Wn ? (Ot = !1, Ee = Ol(de, !0)) : di ? (Ot = !1, Ee = Ll(de, !0)) : Ee = [] : Kl(de) || Yn(de) ? (Ee = te, Yn(te) ? Ee = Jl(te) : (!ct(te) || qn(te)) && (Ee = Ul(de))) : Ot = !1;
    }
    Ot && (fe.set(de, Ee), ne(Ee, de, P, se, fe), fe.delete(de)), Rn(d, D, Ee);
  }
  function Al(d, y) {
    return Wl(Vl(d, y, fi), d + "");
  }
  var Sl = ue ? function(d, y) {
    return ue(d, "toString", {
      configurable: !0,
      enumerable: !1,
      value: ts(y),
      writable: !0
    });
  } : fi;
  function Ol(d, y) {
    if (y)
      return d.slice();
    var D = d.length, P = oe ? oe(D) : new d.constructor(D);
    return d.copy(P), P;
  }
  function zl(d) {
    var y = new d.constructor(d.byteLength);
    return new J(y).set(new J(d)), y;
  }
  function Ll(d, y) {
    var D = y ? zl(d.buffer) : d.buffer;
    return new d.constructor(D, d.byteOffset, d.length);
  }
  function _l(d, y) {
    var D = -1, P = d.length;
    for (y || (y = Array(P)); ++D < P; )
      y[D] = d[D];
    return y;
  }
  function Fl(d, y, D, P) {
    var ne = !D;
    D || (D = {});
    for (var se = -1, fe = y.length; ++se < fe; ) {
      var te = y[se], de = P ? P(D[te], d[te], te, D, d) : void 0;
      de === void 0 && (de = d[te]), ne ? Bn(D, te, de) : Nl(D, te, de);
    }
    return D;
  }
  function Pl(d) {
    return Al(function(y, D) {
      var P = -1, ne = D.length, se = ne > 1 ? D[ne - 1] : void 0, fe = ne > 2 ? D[2] : void 0;
      for (se = d.length > 3 && typeof se == "function" ? (ne--, se) : void 0, fe && Ql(D[0], D[1], fe) && (se = ne < 3 ? void 0 : se, ne = 1), y = Object(y); ++P < ne; ) {
        var te = D[P];
        te && d(y, te, P, se);
      }
      return y;
    });
  }
  function Rl(d) {
    return function(y, D, P) {
      for (var ne = -1, se = Object(y), fe = P(y), te = fe.length; te--; ) {
        var de = fe[d ? te : ++ne];
        if (D(se[de], de, se) === !1)
          break;
      }
      return y;
    };
  }
  function Kt(d, y) {
    var D = d.__data__;
    return Yl(y) ? D[typeof y == "string" ? "string" : "hash"] : D.map;
  }
  function Un(d, y) {
    var D = Ke(d, y);
    return kl(D) ? D : void 0;
  }
  function Bl(d) {
    var y = le.call(d, je), D = d[je];
    try {
      d[je] = void 0;
      var P = !0;
    } catch {
    }
    var ne = $e.call(d);
    return P && (y ? d[je] = D : delete d[je]), ne;
  }
  function Ul(d) {
    return typeof d.constructor == "function" && !li(d) ? rl(Te(d)) : {};
  }
  function ai(d, y) {
    var D = typeof d;
    return y = y ?? a, !!y && (D == "number" || D != "symbol" && Me.test(d)) && d > -1 && d % 1 == 0 && d < y;
  }
  function Ql(d, y, D) {
    if (!ct(D))
      return !1;
    var P = typeof y;
    return (P == "number" ? $n(D) && ai(y, D.length) : P == "string" && y in D) ? Jt(D[y], d) : !1;
  }
  function Yl(d) {
    var y = typeof d;
    return y == "string" || y == "number" || y == "symbol" || y == "boolean" ? d !== "__proto__" : d === null;
  }
  function Hl(d) {
    return !!Qe && Qe in d;
  }
  function li(d) {
    var y = d && d.constructor, D = typeof y == "function" && y.prototype || R;
    return d === D;
  }
  function $l(d) {
    var y = [];
    if (d != null)
      for (var D in Object(d))
        y.push(D);
    return y;
  }
  function ql(d) {
    return $e.call(d);
  }
  function Vl(d, y, D) {
    return y = Le(y === void 0 ? d.length - 1 : y, 0), function() {
      for (var P = arguments, ne = -1, se = Le(P.length - y, 0), fe = Array(se); ++ne < se; )
        fe[ne] = P[y + ne];
      ne = -1;
      for (var te = Array(y + 1); ++ne < y; )
        te[ne] = P[ne];
      return te[y] = D(fe), kt(d, this, te);
    };
  }
  function Qn(d, y) {
    if (!(y === "constructor" && typeof d[y] == "function") && y != "__proto__")
      return d[y];
  }
  var Wl = Gl(Sl);
  function Gl(d) {
    var y = 0, D = 0;
    return function() {
      var P = nl(), ne = o - (P - D);
      if (D = P, ne > 0) {
        if (++y >= i)
          return arguments[0];
      } else
        y = 0;
      return d.apply(void 0, arguments);
    };
  }
  function Zl(d) {
    if (d != null) {
      try {
        return me.call(d);
      } catch {
      }
      try {
        return d + "";
      } catch {
      }
    }
    return "";
  }
  function Jt(d, y) {
    return d === y || d !== d && y !== y;
  }
  var Yn = ii(function() {
    return arguments;
  }()) ? ii : function(d) {
    return St(d) && le.call(d, "callee") && !He.call(d, "callee");
  }, Hn = Array.isArray;
  function $n(d) {
    return d != null && ui(d.length) && !qn(d);
  }
  function Xl(d) {
    return St(d) && $n(d);
  }
  var si = Ct || ns;
  function qn(d) {
    if (!ct(d))
      return !1;
    var y = Xt(d);
    return y == f || y == T || y == u || y == E;
  }
  function ui(d) {
    return typeof d == "number" && d > -1 && d % 1 == 0 && d <= a;
  }
  function ct(d) {
    var y = typeof d;
    return d != null && (y == "object" || y == "function");
  }
  function St(d) {
    return d != null && typeof d == "object";
  }
  function Kl(d) {
    if (!St(d) || Xt(d) != z)
      return !1;
    var y = Te(d);
    if (y === null)
      return !0;
    var D = le.call(y, "constructor") && y.constructor;
    return typeof D == "function" && D instanceof D && me.call(D) == Mt;
  }
  var ci = at ? Et(at) : jl;
  function Jl(d) {
    return Fl(d, pi(d));
  }
  function pi(d) {
    return $n(d) ? Dl(d, !0) : El(d);
  }
  var es = Pl(function(d, y, D) {
    oi(d, y, D);
  });
  function ts(d) {
    return function() {
      return d;
    };
  }
  function fi(d) {
    return d;
  }
  function ns() {
    return !1;
  }
  e.exports = es;
})(dn, dn.exports);
var Ts = dn.exports;
const So = /* @__PURE__ */ rt(Ts), Ds = {
  xpertKey: "exec-ed-ss-olc-moodle",
  chatApi: {
    endpoint: "https://xpert-platform-services-api.prod.ai.2u.com/xpert/omnichannel",
    payloadParams: {
      use_case: "LOG_OUT"
    }
  },
  primaryColor: "#E31A82",
  disclaimer: {
    text: "Before we get started, just a reminder that this chat is AI generated, mistakes are possible. By using it you agree that GetSmarter may create a record of this chat. Your personal data will be used as described in our",
    privacyPolicyLink: "https://www.getsmarter.com/privacy-policy"
  },
  userTracking: {
    enabled: !0,
    prefix: "exec.ed.ss.olc.moodle",
    payloadParams: null
  },
  webExperimentation: {
    enabled: !1,
    experimentName: null
  },
  launchButton: {
    animatedGraduate: null,
    message: {
      enabled: !0,
      text: "Chat to us",
      style: {
        color: "#E31A82",
        right: "1.5rem",
        fontFamily: "system-ui",
        mobile: {
          color: "#E31A82",
          right: "1.50rem",
          fontFamily: "system-ui"
        }
      }
    },
    style: {
      backgroundColor: "#E31A82",
      padding: "0.75rem",
      paddingBottom: "0.5rem",
      iconWidth: "2rem",
      bottom: "1rem",
      right: "1.5rem",
      zIndex: "99999",
      mobile: {
        backgroundColor: "#E31A82",
        padding: "0.75rem",
        paddingBottom: "0.5rem",
        iconWidth: "2rem",
        bottom: "5rem",
        right: "1.52rem",
        zIndex: "99999"
      }
    }
  },
  proactiveMessage: {
    enabled: !0,
    textPrefix: null,
    showEmoji: !1,
    text: "Got questions about billing, registration, or payment options? I'm here to help!",
    delayMs: 0,
    style: {
      bottom: "6.5rem",
      right: "1.45rem",
      zIndex: "99999",
      mobile: {
        bottom: "10.5rem",
        right: "1.35rem",
        zIndex: "99999"
      }
    }
  },
  conversationScreen: {
    header: {
      logo: {
        type: "default",
        style: {
          width: "5rem",
          backgroundColor: "#082135",
          color: "#FFFFFF"
        }
      },
      container: null
    },
    systemMessage: "Hi there! I'm Xpert, what can I help you with? I'm available to answer questions about things like billing, registration, and payment options.",
    prompts: null,
    userMessageBubble: {
      style: {
        backgroundColor: "#E31A82",
        color: "#FFFFFF"
      }
    },
    conversationHistory: {
      enabled: !1
    },
    maintenanceBanner: {
      enabled: !0,
      header: "Planned Maintenance",
      text: "On Aug. 15 at 7AM EDT (~1 hr), Xpert Chat will be unavailable for maintenance. You may still connect with a live agent by selecting the button below.",
      endDateTime: "2024-08-15T12:00:00Z"
    },
    liveChat: {
      enabled: !0,
      sourceCode: "https://live-chat.ps.five9.com/Five9ChatPlugin.js",
      options: {
        appId: "2U Inc",
        configId: "Exec-Ed | OLC Logged Out_Xpert"
      }
    }
  }
}, Ns = {
  edx: os,
  "get-smarter": ls,
  "speech-emerson": as,
  "exec-ed-ss-olc-moodle": Ds,
  "degrees-canvas-support": ss,
  "degrees-moodle-support": us
}, Is = (e, t = {}) => {
  if (!e && (!t || Object.keys(t).length === 0))
    throw new Error("xpertKey or configurations is required");
  const n = Ns[e] || {};
  return So(n, t);
}, ks = Is, Oo = rs({}), zo = ({
  children: e,
  configurations: t = null,
  xpertKey: n = null
}) => {
  const r = is(
    () => ks(n, t),
    [t, n]
  );
  return /* @__PURE__ */ v.jsx(Oo.Provider, { value: { ...r }, children: e });
};
zo.propTypes = {
  children: B.element.isRequired,
  xpertKey: B.string.isRequired,
  configurations: B.shape({
    xpertKey: B.string,
    chatApi: B.shape({
      endpoint: B.string.isRequired,
      payloadParams: B.string
    }).isRequired,
    primaryColor: B.string.isRequired,
    disclaimer: B.shape({
      text: B.string.isRequired,
      privacyPolicyLink: B.string.isRequired
    }).isRequired,
    userTracking: B.shape({
      enabled: B.bool.isRequired,
      prefix: B.string.isRequired,
      payloadParams: B.object
    }).isRequired,
    webExperimentation: B.shape({
      enabled: B.bool.isRequired,
      experimentName: B.string
    }).isRequired,
    launchButton: B.shape({
      style: B.shape({}).isRequired,
      animatedGraduate: B.shape({
        enabled: B.bool.isRequired,
        delayMs: B.number
      }),
      message: B.shape({
        enabled: B.bool.isRequired,
        text: B.string
      })
    }).isRequired,
    proactiveMessage: B.shape({
      enabled: B.bool.isRequired,
      textPrefix: B.string,
      text: B.string,
      delayMs: B.number.isRequired,
      style: B.shape({}).isRequired
    }).isRequired,
    conversationScreen: B.shape({
      header: B.shape({
        logo: B.shape({
          type: B.string.isRequired,
          style: B.shape({})
        }).isRequired,
        container: B.shape({
          style: B.shape({}).isRequired
        })
      }),
      systemMessage: B.string.isRequired,
      prompts: B.arrayOf(
        B.shape({
          id: B.number.isRequired,
          text: B.string.isRequired
        })
      ),
      userMessageBubble: B.shape({
        style: B.shape({}).isRequired
      }),
      conversationHistory: B.shape({
        enabled: B.bool.isRequired
      }).isRequired,
      maintenanceBanner: B.shape({
        enabled: B.bool,
        text: B.string,
        endDateTime: B.string
      }),
      liveChat: B.shape({
        enabled: B.bool.isRequired,
        sourceCode: B.string,
        options: B.shape({})
      })
    }).isRequired
  })
};
const Oe = Oo;
var Lo = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var o = "", a = 0; a < arguments.length; a++) {
        var l = arguments[a];
        l && (o = i(o, r(l)));
      }
      return o;
    }
    function r(o) {
      if (typeof o == "string" || typeof o == "number")
        return o;
      if (typeof o != "object")
        return "";
      if (Array.isArray(o))
        return n.apply(null, o);
      if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
        return o.toString();
      var a = "";
      for (var l in o)
        t.call(o, l) && o[l] && (a = i(a, l));
      return a;
    }
    function i(o, a) {
      return a ? o ? o + " " + a : o + a : o;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(Lo);
var js = Lo.exports;
const _o = /* @__PURE__ */ rt(js), Es = 576, Cs = (e) => {
  const [t, n] = ye(), r = Tt(() => {
    n(
      window.matchMedia(
        `(max-width: ${e || Es}px)`
      ).matches
    );
  }, [e]);
  return xe(() => (r(), window.addEventListener("resize", r), () => window.removeEventListener("resize", r)), [r]), t;
}, it = Cs, As = 991;
function wn({
  label: e,
  className: t,
  onClick: n,
  style: r,
  children: i,
  ...o
}) {
  const a = it(As);
  return /* @__PURE__ */ v.jsx(
    "button",
    {
      id: "xpert_chatbot__floating-action-btn",
      tabIndex: 0,
      type: "button",
      "aria-label": e,
      className: _o(
        {
          "xpert_chatbot__floating-action-btn__icon": !a,
          "xpert_chatbot__floating-action-btn__icon--mobile": a
        },
        t
      ),
      style: r,
      onClick: n,
      ...o,
      children: i
    }
  );
}
wn.propTypes = {
  label: N.string.isRequired,
  onClick: N.func.isRequired,
  children: N.node.isRequired,
  className: N.string,
  style: N.shape()
};
wn.defaultProps = {
  className: "",
  style: {}
};
const zt = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iNDgiPjxwYXRoIGQ9Ik0yODEtMjQwcS0xNCAwLTI3LjUtMTRUMjQwLTI4MnYtOThoNTAwdi0zNDBoMTAwcTE0IDAgMjcgMTR0MTMgMjl2NTk2TDcyMS0yNDBIMjgxWk04MC0yODB2LTU1OHEwLTE0IDEzLTI4dDI3LTE0aDUxOXExNSAwIDI4IDEzLjV0MTMgMjguNXYzNTZxMCAxNC0xMyAyOHQtMjggMTRIMjQwTDgwLTI4MFptNTQwLTIyMHYtMzIwSDE0MHYzMjBoNDgwWm0tNDgwIDB2LTMyMCAzMjBaIiBmaWxsPSIjRkZGRkZGIi8+PC9zdmc+", Fo = "data:image/svg+xml;base64,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", Ss = 991, Os = {
  edx: Fo,
  "speech-emerson": zt,
  "get-smarter": zt,
  "exec-ed-ss-olc-moodle": zt,
  "degrees-canvas-support": zt,
  "degrees-moodle-support": zt
}, jr = ({ handleFloatingActionButtonClick: e }) => {
  var i, o;
  const { xpertKey: t, launchButton: n } = Se(Oe), r = it(Ss);
  return /* @__PURE__ */ v.jsx(
    wn,
    {
      onClick: e,
      label: "Open XPERT Chatbot",
      style: r ? { ...(i = n.style) == null ? void 0 : i.mobile } : { ...n.style },
      "aria-haspopup": "dialog",
      "aria-expanded": open,
      className: "xpert-chatbot-button",
      children: /* @__PURE__ */ v.jsx(
        "img",
        {
          "data-ot-ignore": "",
          className: "xpert-chatbot-button__logo optanon-category-C0001",
          src: Os[t],
          alt: "xpert logo",
          "aria-hidden": !0,
          style: { width: (o = n.style) == null ? void 0 : o.iconWidth }
        }
      )
    }
  );
};
jr.propTypes = {
  handleFloatingActionButtonClick: N.func
};
jr.defaultProps = {
  handleFloatingActionButtonClick: null
};
const zs = jr;
const Ls = 991, _s = 1500, Fs = `The parent container is wider than the chatbot launch button it contains so that the animated graduate 
eyes follow your mouse when you hover near it.`, Er = ({
  handleFloatingActionButtonClick: e
}) => {
  var m, f, T, x, k, M, z;
  const { xpertKey: t, launchButton: n } = Se(Oe), r = !Ne.get(
    `${t}-proactive-message-xpert-chatbot`
  ), i = We(null), o = We(!1), a = r ? (m = n.animatedGraduate) == null ? void 0 : m.delayMs : ((f = n.animatedGraduate) == null ? void 0 : f.delayMs) * 2, [l, s] = ye(!1), u = it(Ls);
  xe(() => {
    const _ = setTimeout(
      () => {
        s(!0);
      },
      a
    );
    return () => {
      clearTimeout(_);
    };
  }, [a]), xe(() => {
    const E = (_) => {
      const U = window.matchMedia(
        `(max-width: ${_s}px)`
      ).matches, b = window.devicePixelRatio > 1.5;
      if (!(o != null && o.current) || U || b)
        return;
      i.current.querySelectorAll(
        ".xpert_chatbot__animated_graduate__pupil"
      ).forEach(($) => {
        const W = $.getBoundingClientRect(), K = (_.pageX - window.scrollX - W.left) / 30 / 16 + "rem", A = (_.pageY - window.scrollY - W.top) / 30 / 16 + "rem";
        $.style.transform = "translate3d(" + K + "," + A + ", 0rem)";
      });
    };
    return window.addEventListener("mousemove", E), () => {
      window.removeEventListener("mousemove", E);
    };
  }, []);
  const c = () => {
    o.current = !0;
  }, p = () => {
    o.current = !1;
  };
  return /* @__PURE__ */ v.jsxs(
    "div",
    {
      role: "region",
      "aria-label": "eyes follow mouse region",
      className: "xpert_chatbot__animated_graduate__eyes_follow_mouse_region",
      onMouseEnter: c,
      onMouseLeave: p,
      children: [
        /* @__PURE__ */ v.jsx("div", { className: "xpert_chatbot__a11y-sr-only", children: Fs }),
        /* @__PURE__ */ v.jsx(
          wn,
          {
            onClick: e,
            label: "Open XPERT Chatbot",
            className: "xpert-chatbot-button__animated_graduate__launch-button",
            style: u ? { ...(x = (T = n.style) == null ? void 0 : T.mobile) == null ? void 0 : x.animatedGraduateExperiment } : { ...(k = n.style) == null ? void 0 : k.animatedGraduateExperiment },
            "aria-haspopup": "dialog",
            "aria-expanded": open,
            children: /* @__PURE__ */ v.jsx("div", { ref: i, children: /* @__PURE__ */ v.jsxs(
              "svg",
              {
                style: {
                  width: (z = (M = n.style) == null ? void 0 : M.animatedGraduateExperiment) == null ? void 0 : z.iconWidth
                },
                viewBox: "0 0 61 73",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "xpert_chatbot__animated_graduate",
                children: [
                  /* @__PURE__ */ v.jsx(
                    "path",
                    {
                      d: "M28.7098 11.9636C29.3493 11.5582 30.1637 11.5523 30.8091 11.9482L57.7788 28.4938C59.0325 29.2629 59.0425 31.081 57.7974 31.8639L29.379 49.733C28.6963 50.1623 27.8215 50.1355 27.1663 49.6652L2.38715 31.8772C1.24528 31.0575 1.29468 29.343 2.48186 28.5904L28.7098 11.9636Z",
                      fill: "black",
                      className: "xpert_chatbot__animated_graduate__cap"
                    }
                  ),
                  /* @__PURE__ */ v.jsx(
                    "path",
                    {
                      fillRule: "evenodd",
                      clipRule: "evenodd",
                      d: "M21.8201 27.1885C14.1513 27.1885 7.9346 33.4052 7.9346 41.074V50.9922C7.9346 58.6609 14.1513 64.8777 21.8201 64.8777H35.0918L37.872 70.8969C38.5813 72.4328 40.7642 72.4328 41.4736 70.8969L44.6842 63.9458C49.8764 61.9358 53.5584 56.894 53.5584 50.9922V41.074C53.5584 33.4052 47.3416 27.1885 39.6729 27.1885H21.8201Z",
                      fill: "#4AB699",
                      className: "xpert_chatbot__animated_graduate__face"
                    }
                  ),
                  /* @__PURE__ */ v.jsx(
                    "circle",
                    {
                      className: `xpert_chatbot__animated_graduate__eyeball ${l ? "xpert_chatbot__animated_graduate__eyeball_blink" : ""}`,
                      cx: "34.7137",
                      cy: "44.0494",
                      r: "6.94275",
                      fill: "white"
                    }
                  ),
                  /* @__PURE__ */ v.jsx(
                    "mask",
                    {
                      id: "mask0_2271_69",
                      maskUnits: "userSpaceOnUse",
                      x: "27",
                      y: "37",
                      width: "15",
                      height: "14",
                      children: /* @__PURE__ */ v.jsx("circle", { cx: "34.7137", cy: "44.0494", r: "6.94275", fill: "white" })
                    }
                  ),
                  /* @__PURE__ */ v.jsx("g", { mask: "url(#mask0_2271_69)", children: /* @__PURE__ */ v.jsx(
                    "circle",
                    {
                      role: "img",
                      "aria-label": "Left pupil that follows the mouse cursor",
                      className: `xpert_chatbot__animated_graduate__pupil ${l ? "xpert_chatbot__animated_graduate__pupil_blink" : ""}`,
                      cx: "30.7465",
                      cy: "44.0494",
                      r: "4.9591",
                      fill: "black"
                    }
                  ) }),
                  /* @__PURE__ */ v.jsx(
                    "circle",
                    {
                      className: `xpert_chatbot__animated_graduate__eyeball ${l ? "xpert_chatbot__animated_graduate__eyeball_blink" : ""}`,
                      cx: "18.8446",
                      cy: "44.0494",
                      r: "6.94275",
                      fill: "white"
                    }
                  ),
                  /* @__PURE__ */ v.jsx(
                    "mask",
                    {
                      id: "mask1_2271_69",
                      maskUnits: "userSpaceOnUse",
                      x: "11",
                      y: "37",
                      width: "15",
                      height: "14",
                      children: /* @__PURE__ */ v.jsx("circle", { cx: "18.8446", cy: "44.0494", r: "6.94275", fill: "white" })
                    }
                  ),
                  /* @__PURE__ */ v.jsx("g", { mask: "url(#mask1_2271_69)", children: /* @__PURE__ */ v.jsx(
                    "circle",
                    {
                      role: "img",
                      "aria-label": "Right pupil that follows the mouse cursor",
                      className: `xpert_chatbot__animated_graduate__pupil ${l ? "xpert_chatbot__animated_graduate__pupil_blink" : ""}`,
                      cx: "14.8773",
                      cy: "44.0494",
                      r: "4.9591",
                      fill: "black"
                    }
                  ) }),
                  /* @__PURE__ */ v.jsx(
                    "circle",
                    {
                      className: `xpert_chatbot__animated_graduate__mouth ${l ? "xpert_chatbot__animated_graduate__mouth_move" : ""}`,
                      cx: "28.7628",
                      cy: "55.9513",
                      r: "2.97546",
                      fill: "#5DE3C0"
                    }
                  ),
                  /* @__PURE__ */ v.jsx(
                    "circle",
                    {
                      className: `xpert_chatbot__animated_graduate__mouth ${l ? "xpert_chatbot__animated_graduate__mouth_move" : ""}`,
                      cx: "36.6973",
                      cy: "55.9513",
                      r: "2.97546",
                      fill: "#5DE3C0"
                    }
                  ),
                  /* @__PURE__ */ v.jsx(
                    "circle",
                    {
                      className: `xpert_chatbot__animated_graduate__mouth ${l ? "xpert_chatbot__animated_graduate__mouth_move" : ""}`,
                      cx: "20.8282",
                      cy: "55.9513",
                      r: "2.97546",
                      fill: "#5DE3C0"
                    }
                  ),
                  /* @__PURE__ */ v.jsx(
                    "path",
                    {
                      className: "xpert_chatbot__animated_graduate__cap_tassel",
                      d: "M4.95914 32.6434V31.1557H1.98367V32.6434H4.95914ZM1.98367 49.5044C1.98367 50.326 2.64975 50.9921 3.47141 50.9921C4.29306 50.9921 4.95914 50.326 4.95914 49.5044H1.98367ZM1.98367 32.6434L1.98367 49.5044H4.95914L4.95914 32.6434H1.98367Z",
                      fill: "black"
                    }
                  )
                ]
              }
            ) })
          }
        )
      ]
    }
  );
};
Er.propTypes = {
  handleFloatingActionButtonClick: N.func
};
Er.defaultProps = {
  handleFloatingActionButtonClick: null
};
const Ps = Er;
const Rs = 991, Bs = () => {
  var n;
  const e = it(Rs), { launchButton: t } = Se(Oe);
  return (n = t.message) != null && n.enabled ? /* @__PURE__ */ v.jsx(
    "div",
    {
      role: "alert",
      "aria-live": "assertive",
      "aria-label": t == null ? void 0 : t.message.text,
      className: "xpert_chatbot__launch-button-message",
      style: e ? { ...t.message.style.mobile } : { ...t.message.style },
      children: t.message.text
    }
  ) : null;
}, Us = Bs;
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var Po = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], hn = /* @__PURE__ */ Po.join(","), Ro = typeof Element > "u", dt = Ro ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, gn = !Ro && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, mn = function e(t, n) {
  var r;
  n === void 0 && (n = !0);
  var i = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert"), o = i === "" || i === "true", a = o || n && t && e(t.parentNode);
  return a;
}, Qs = function(t) {
  var n, r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return r === "" || r === "true";
}, Bo = function(t, n, r) {
  if (mn(t))
    return [];
  var i = Array.prototype.slice.apply(t.querySelectorAll(hn));
  return n && dt.call(t, hn) && i.unshift(t), i = i.filter(r), i;
}, Uo = function e(t, n, r) {
  for (var i = [], o = Array.from(t); o.length; ) {
    var a = o.shift();
    if (!mn(a, !1))
      if (a.tagName === "SLOT") {
        var l = a.assignedElements(), s = l.length ? l : a.children, u = e(s, !0, r);
        r.flatten ? i.push.apply(i, u) : i.push({
          scopeParent: a,
          candidates: u
        });
      } else {
        var c = dt.call(a, hn);
        c && r.filter(a) && (n || !t.includes(a)) && i.push(a);
        var p = a.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(a), m = !mn(p, !1) && (!r.shadowRootFilter || r.shadowRootFilter(a));
        if (p && m) {
          var f = e(p === !0 ? a.children : p.children, !0, r);
          r.flatten ? i.push.apply(i, f) : i.push({
            scopeParent: a,
            candidates: f
          });
        } else
          o.unshift.apply(o, a.children);
      }
  }
  return i;
}, Qo = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, et = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || Qs(t)) && !Qo(t) ? 0 : t.tabIndex;
}, Ys = function(t, n) {
  var r = et(t);
  return r < 0 && n && !Qo(t) ? 0 : r;
}, Hs = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, Yo = function(t) {
  return t.tagName === "INPUT";
}, $s = function(t) {
  return Yo(t) && t.type === "hidden";
}, qs = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, Vs = function(t, n) {
  for (var r = 0; r < t.length; r++)
    if (t[r].checked && t[r].form === n)
      return t[r];
}, Ws = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || gn(t), r = function(l) {
    return n.querySelectorAll('input[type="radio"][name="' + l + '"]');
  }, i;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    i = r(window.CSS.escape(t.name));
  else
    try {
      i = r(t.name);
    } catch (a) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
    }
  var o = Vs(i, t.form);
  return !o || o === t;
}, Gs = function(t) {
  return Yo(t) && t.type === "radio";
}, Zs = function(t) {
  return Gs(t) && !Ws(t);
}, Xs = function(t) {
  var n, r = t && gn(t), i = (n = r) === null || n === void 0 ? void 0 : n.host, o = !1;
  if (r && r !== t) {
    var a, l, s;
    for (o = !!((a = i) !== null && a !== void 0 && (l = a.ownerDocument) !== null && l !== void 0 && l.contains(i) || t != null && (s = t.ownerDocument) !== null && s !== void 0 && s.contains(t)); !o && i; ) {
      var u, c, p;
      r = gn(i), i = (u = r) === null || u === void 0 ? void 0 : u.host, o = !!((c = i) !== null && c !== void 0 && (p = c.ownerDocument) !== null && p !== void 0 && p.contains(i));
    }
  }
  return o;
}, mi = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, i = n.height;
  return r === 0 && i === 0;
}, Ks = function(t, n) {
  var r = n.displayCheck, i = n.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var o = dt.call(t, "details>summary:first-of-type"), a = o ? t.parentElement : t;
  if (dt.call(a, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || r === "legacy-full") {
    if (typeof i == "function") {
      for (var l = t; t; ) {
        var s = t.parentElement, u = gn(t);
        if (s && !s.shadowRoot && i(s) === !0)
          return mi(t);
        t.assignedSlot ? t = t.assignedSlot : !s && u !== t.ownerDocument ? t = u.host : t = s;
      }
      t = l;
    }
    if (Xs(t))
      return !t.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return mi(t);
  return !1;
}, Js = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var i = n.children.item(r);
          if (i.tagName === "LEGEND")
            return dt.call(n, "fieldset[disabled] *") ? !0 : !i.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, yn = function(t, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  mn(n) || $s(n) || Ks(n, t) || // For a details element with a summary, the summary element gets the focus
  qs(n) || Js(n));
}, cr = function(t, n) {
  return !(Zs(n) || et(n) < 0 || !yn(t, n));
}, eu = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, tu = function e(t) {
  var n = [], r = [];
  return t.forEach(function(i, o) {
    var a = !!i.scopeParent, l = a ? i.scopeParent : i, s = Ys(l, a), u = a ? e(i.candidates) : l;
    s === 0 ? a ? n.push.apply(n, u) : n.push(l) : r.push({
      documentOrder: o,
      tabIndex: s,
      item: i,
      isScope: a,
      content: u
    });
  }), r.sort(Hs).reduce(function(i, o) {
    return o.isScope ? i.push.apply(i, o.content) : i.push(o.content), i;
  }, []).concat(n);
}, Ho = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = Uo([t], n.includeContainer, {
    filter: cr.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: eu
  }) : r = Bo(t, n.includeContainer, cr.bind(null, n)), tu(r);
}, $o = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = Uo([t], n.includeContainer, {
    filter: yn.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : r = Bo(t, n.includeContainer, yn.bind(null, n)), r;
}, pt = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return dt.call(t, hn) === !1 ? !1 : cr(n, t);
}, nu = /* @__PURE__ */ Po.concat("iframe").join(","), sn = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return dt.call(t, nu) === !1 ? !1 : yn(n, t);
};
const ru = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  focusable: $o,
  getTabIndex: et,
  isFocusable: sn,
  isTabbable: pt,
  tabbable: Ho
}, Symbol.toStringTag, { value: "Module" }));
/*!
* focus-trap 7.5.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function yi(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Mi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? yi(Object(n), !0).forEach(function(r) {
      iu(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : yi(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function iu(e, t, n) {
  return t = au(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function ou(e, t) {
  if (typeof e != "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function au(e) {
  var t = ou(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var bi = {
  activateTrap: function(t, n) {
    if (t.length > 0) {
      var r = t[t.length - 1];
      r !== n && r.pause();
    }
    var i = t.indexOf(n);
    i === -1 || t.splice(i, 1), t.push(n);
  },
  deactivateTrap: function(t, n) {
    var r = t.indexOf(n);
    r !== -1 && t.splice(r, 1), t.length > 0 && t[t.length - 1].unpause();
  }
}, lu = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, su = function(t) {
  return (t == null ? void 0 : t.key) === "Escape" || (t == null ? void 0 : t.key) === "Esc" || (t == null ? void 0 : t.keyCode) === 27;
}, Bt = function(t) {
  return (t == null ? void 0 : t.key) === "Tab" || (t == null ? void 0 : t.keyCode) === 9;
}, uu = function(t) {
  return Bt(t) && !t.shiftKey;
}, cu = function(t) {
  return Bt(t) && t.shiftKey;
}, xi = function(t) {
  return setTimeout(t, 0);
}, wi = function(t, n) {
  var r = -1;
  return t.every(function(i, o) {
    return n(i) ? (r = o, !1) : !0;
  }), r;
}, Lt = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  return typeof t == "function" ? t.apply(void 0, r) : t;
}, nn = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, pu = [], fu = function(t, n) {
  var r = (n == null ? void 0 : n.document) || document, i = (n == null ? void 0 : n.trapStack) || pu, o = Mi({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: uu,
    isKeyBackward: cu
  }, n), a = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, l, s = function(w, j, O) {
    return w && w[j] !== void 0 ? w[j] : o[O || j];
  }, u = function(w, j) {
    var O = typeof (j == null ? void 0 : j.composedPath) == "function" ? j.composedPath() : void 0;
    return a.containerGroups.findIndex(function(F) {
      var Q = F.container, V = F.tabbableNodes;
      return Q.contains(w) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (O == null ? void 0 : O.includes(Q)) || V.find(function(q) {
        return q === w;
      });
    });
  }, c = function(w) {
    var j = o[w];
    if (typeof j == "function") {
      for (var O = arguments.length, F = new Array(O > 1 ? O - 1 : 0), Q = 1; Q < O; Q++)
        F[Q - 1] = arguments[Q];
      j = j.apply(void 0, F);
    }
    if (j === !0 && (j = void 0), !j) {
      if (j === void 0 || j === !1)
        return j;
      throw new Error("`".concat(w, "` was specified but was not a node, or did not return a node"));
    }
    var V = j;
    if (typeof j == "string" && (V = r.querySelector(j), !V))
      throw new Error("`".concat(w, "` as selector refers to no known node"));
    return V;
  }, p = function() {
    var w = c("initialFocus");
    if (w === !1)
      return !1;
    if (w === void 0 || !sn(w, o.tabbableOptions))
      if (u(r.activeElement) >= 0)
        w = r.activeElement;
      else {
        var j = a.tabbableGroups[0], O = j && j.firstTabbableNode;
        w = O || c("fallbackFocus");
      }
    if (!w)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return w;
  }, m = function() {
    if (a.containerGroups = a.containers.map(function(w) {
      var j = Ho(w, o.tabbableOptions), O = $o(w, o.tabbableOptions), F = j.length > 0 ? j[0] : void 0, Q = j.length > 0 ? j[j.length - 1] : void 0, V = O.find(function(g) {
        return pt(g);
      }), q = O.slice().reverse().find(function(g) {
        return pt(g);
      }), X = !!j.find(function(g) {
        return et(g) > 0;
      });
      return {
        container: w,
        tabbableNodes: j,
        focusableNodes: O,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: X,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: F,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: Q,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: V,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: q,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(he) {
          var Me = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, h = j.indexOf(he);
          return h < 0 ? Me ? O.slice(O.indexOf(he) + 1).find(function(ge) {
            return pt(ge);
          }) : O.slice(0, O.indexOf(he)).reverse().find(function(ge) {
            return pt(ge);
          }) : j[h + (Me ? 1 : -1)];
        }
      };
    }), a.tabbableGroups = a.containerGroups.filter(function(w) {
      return w.tabbableNodes.length > 0;
    }), a.tabbableGroups.length <= 0 && !c("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (a.containerGroups.find(function(w) {
      return w.posTabIndexesFound;
    }) && a.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, f = function A(w) {
    var j = w.activeElement;
    if (j)
      return j.shadowRoot && j.shadowRoot.activeElement !== null ? A(j.shadowRoot) : j;
  }, T = function A(w) {
    if (w !== !1 && w !== f(document)) {
      if (!w || !w.focus) {
        A(p());
        return;
      }
      w.focus({
        preventScroll: !!o.preventScroll
      }), a.mostRecentlyFocusedNode = w, lu(w) && w.select();
    }
  }, x = function(w) {
    var j = c("setReturnFocus", w);
    return j || (j === !1 ? !1 : w);
  }, k = function(w) {
    var j = w.target, O = w.event, F = w.isBackward, Q = F === void 0 ? !1 : F;
    j = j || nn(O), m();
    var V = null;
    if (a.tabbableGroups.length > 0) {
      var q = u(j, O), X = q >= 0 ? a.containerGroups[q] : void 0;
      if (q < 0)
        Q ? V = a.tabbableGroups[a.tabbableGroups.length - 1].lastTabbableNode : V = a.tabbableGroups[0].firstTabbableNode;
      else if (Q) {
        var g = wi(a.tabbableGroups, function(re) {
          var we = re.firstTabbableNode;
          return j === we;
        });
        if (g < 0 && (X.container === j || sn(j, o.tabbableOptions) && !pt(j, o.tabbableOptions) && !X.nextTabbableNode(j, !1)) && (g = q), g >= 0) {
          var he = g === 0 ? a.tabbableGroups.length - 1 : g - 1, Me = a.tabbableGroups[he];
          V = et(j) >= 0 ? Me.lastTabbableNode : Me.lastDomTabbableNode;
        } else
          Bt(O) || (V = X.nextTabbableNode(j, !1));
      } else {
        var h = wi(a.tabbableGroups, function(re) {
          var we = re.lastTabbableNode;
          return j === we;
        });
        if (h < 0 && (X.container === j || sn(j, o.tabbableOptions) && !pt(j, o.tabbableOptions) && !X.nextTabbableNode(j)) && (h = q), h >= 0) {
          var ge = h === a.tabbableGroups.length - 1 ? 0 : h + 1, ke = a.tabbableGroups[ge];
          V = et(j) >= 0 ? ke.firstTabbableNode : ke.firstDomTabbableNode;
        } else
          Bt(O) || (V = X.nextTabbableNode(j));
      }
    } else
      V = c("fallbackFocus");
    return V;
  }, M = function(w) {
    var j = nn(w);
    if (!(u(j, w) >= 0)) {
      if (Lt(o.clickOutsideDeactivates, w)) {
        l.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: o.returnFocusOnDeactivate
        });
        return;
      }
      Lt(o.allowOutsideClick, w) || w.preventDefault();
    }
  }, z = function(w) {
    var j = nn(w), O = u(j, w) >= 0;
    if (O || j instanceof Document)
      O && (a.mostRecentlyFocusedNode = j);
    else {
      w.stopImmediatePropagation();
      var F, Q = !0;
      if (a.mostRecentlyFocusedNode)
        if (et(a.mostRecentlyFocusedNode) > 0) {
          var V = u(a.mostRecentlyFocusedNode), q = a.containerGroups[V].tabbableNodes;
          if (q.length > 0) {
            var X = q.findIndex(function(g) {
              return g === a.mostRecentlyFocusedNode;
            });
            X >= 0 && (o.isKeyForward(a.recentNavEvent) ? X + 1 < q.length && (F = q[X + 1], Q = !1) : X - 1 >= 0 && (F = q[X - 1], Q = !1));
          }
        } else
          a.containerGroups.some(function(g) {
            return g.tabbableNodes.some(function(he) {
              return et(he) > 0;
            });
          }) || (Q = !1);
      else
        Q = !1;
      Q && (F = k({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: a.mostRecentlyFocusedNode,
        isBackward: o.isKeyBackward(a.recentNavEvent)
      })), T(F || a.mostRecentlyFocusedNode || p());
    }
    a.recentNavEvent = void 0;
  }, E = function(w) {
    var j = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    a.recentNavEvent = w;
    var O = k({
      event: w,
      isBackward: j
    });
    O && (Bt(w) && w.preventDefault(), T(O));
  }, _ = function(w) {
    if (su(w) && Lt(o.escapeDeactivates, w) !== !1) {
      w.preventDefault(), l.deactivate();
      return;
    }
    (o.isKeyForward(w) || o.isKeyBackward(w)) && E(w, o.isKeyBackward(w));
  }, U = function(w) {
    var j = nn(w);
    u(j, w) >= 0 || Lt(o.clickOutsideDeactivates, w) || Lt(o.allowOutsideClick, w) || (w.preventDefault(), w.stopImmediatePropagation());
  }, b = function() {
    if (a.active)
      return bi.activateTrap(i, l), a.delayInitialFocusTimer = o.delayInitialFocus ? xi(function() {
        T(p());
      }) : T(p()), r.addEventListener("focusin", z, !0), r.addEventListener("mousedown", M, {
        capture: !0,
        passive: !1
      }), r.addEventListener("touchstart", M, {
        capture: !0,
        passive: !1
      }), r.addEventListener("click", U, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", _, {
        capture: !0,
        passive: !1
      }), l;
  }, L = function() {
    if (a.active)
      return r.removeEventListener("focusin", z, !0), r.removeEventListener("mousedown", M, !0), r.removeEventListener("touchstart", M, !0), r.removeEventListener("click", U, !0), r.removeEventListener("keydown", _, !0), l;
  }, $ = function(w) {
    var j = w.some(function(O) {
      var F = Array.from(O.removedNodes);
      return F.some(function(Q) {
        return Q === a.mostRecentlyFocusedNode;
      });
    });
    j && T(p());
  }, W = typeof window < "u" && "MutationObserver" in window ? new MutationObserver($) : void 0, K = function() {
    W && (W.disconnect(), a.active && !a.paused && a.containers.map(function(w) {
      W.observe(w, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return l = {
    get active() {
      return a.active;
    },
    get paused() {
      return a.paused;
    },
    activate: function(w) {
      if (a.active)
        return this;
      var j = s(w, "onActivate"), O = s(w, "onPostActivate"), F = s(w, "checkCanFocusTrap");
      F || m(), a.active = !0, a.paused = !1, a.nodeFocusedBeforeActivation = r.activeElement, j == null || j();
      var Q = function() {
        F && m(), b(), K(), O == null || O();
      };
      return F ? (F(a.containers.concat()).then(Q, Q), this) : (Q(), this);
    },
    deactivate: function(w) {
      if (!a.active)
        return this;
      var j = Mi({
        onDeactivate: o.onDeactivate,
        onPostDeactivate: o.onPostDeactivate,
        checkCanReturnFocus: o.checkCanReturnFocus
      }, w);
      clearTimeout(a.delayInitialFocusTimer), a.delayInitialFocusTimer = void 0, L(), a.active = !1, a.paused = !1, K(), bi.deactivateTrap(i, l);
      var O = s(j, "onDeactivate"), F = s(j, "onPostDeactivate"), Q = s(j, "checkCanReturnFocus"), V = s(j, "returnFocus", "returnFocusOnDeactivate");
      O == null || O();
      var q = function() {
        xi(function() {
          V && T(x(a.nodeFocusedBeforeActivation)), F == null || F();
        });
      };
      return V && Q ? (Q(x(a.nodeFocusedBeforeActivation)).then(q, q), this) : (q(), this);
    },
    pause: function(w) {
      if (a.paused || !a.active)
        return this;
      var j = s(w, "onPause"), O = s(w, "onPostPause");
      return a.paused = !0, j == null || j(), L(), K(), O == null || O(), this;
    },
    unpause: function(w) {
      if (!a.paused || !a.active)
        return this;
      var j = s(w, "onUnpause"), O = s(w, "onPostUnpause");
      return a.paused = !1, j == null || j(), m(), b(), K(), O == null || O(), this;
    },
    updateContainerElements: function(w) {
      var j = [].concat(w).filter(Boolean);
      return a.containers = j.map(function(O) {
        return typeof O == "string" ? r.querySelector(O) : O;
      }), a.active && m(), K(), this;
    }
  }, l.updateContainerElements(t), l;
};
const du = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createFocusTrap: fu
}, Symbol.toStringTag, { value: "Module" })), hu = /* @__PURE__ */ No(du), gu = /* @__PURE__ */ No(ru);
function Dt(e) {
  "@babel/helpers - typeof";
  return Dt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Dt(e);
}
function mu(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function vi(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, qo(r.key), r);
  }
}
function yu(e, t, n) {
  return t && vi(e.prototype, t), n && vi(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Mu(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && pr(e, t);
}
function pr(e, t) {
  return pr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, pr(e, t);
}
function bu(e) {
  var t = wu();
  return function() {
    var r = Mn(e), i;
    if (t) {
      var o = Mn(this).constructor;
      i = Reflect.construct(r, arguments, o);
    } else
      i = r.apply(this, arguments);
    return xu(this, i);
  };
}
function xu(e, t) {
  if (t && (Dt(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Rt(e);
}
function Rt(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function wu() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Mn(e) {
  return Mn = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Mn(e);
}
function vu(e, t, n) {
  return t = qo(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function qo(e) {
  var t = Tu(e, "string");
  return Dt(t) === "symbol" ? t : String(t);
}
function Tu(e, t) {
  if (Dt(e) !== "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Dt(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var rn = tt, H = B, Du = hu, Nu = Du.createFocusTrap, Iu = gu, ku = Iu.isFocusable, Cr = /* @__PURE__ */ function(e) {
  Mu(n, e);
  var t = bu(n);
  function n(r) {
    var i;
    mu(this, n), i = t.call(this, r), vu(Rt(i), "getNodeForOption", function(l) {
      var s, u = (s = this.internalOptions[l]) !== null && s !== void 0 ? s : this.originalOptions[l];
      if (typeof u == "function") {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), m = 1; m < c; m++)
          p[m - 1] = arguments[m];
        u = u.apply(void 0, p);
      }
      if (u === !0 && (u = void 0), !u) {
        if (u === void 0 || u === !1)
          return u;
        throw new Error("`".concat(l, "` was specified but was not a node, or did not return a node"));
      }
      var f = u;
      if (typeof u == "string") {
        var T;
        if (f = (T = this.getDocument()) === null || T === void 0 ? void 0 : T.querySelector(u), !f)
          throw new Error("`".concat(l, "` as selector refers to no known node"));
      }
      return f;
    }), i.handleDeactivate = i.handleDeactivate.bind(Rt(i)), i.handlePostDeactivate = i.handlePostDeactivate.bind(Rt(i)), i.handleClickOutsideDeactivates = i.handleClickOutsideDeactivates.bind(Rt(i)), i.internalOptions = {
      // We need to hijack the returnFocusOnDeactivate option,
      // because React can move focus into the element before we arrived at
      // this lifecycle hook (e.g. with autoFocus inputs). So the component
      // captures the previouslyFocusedElement in componentWillMount,
      // then (optionally) returns focus to it in componentWillUnmount.
      returnFocusOnDeactivate: !1,
      // the rest of these are also related to deactivation of the trap, and we
      //  need to use them and control them as well
      checkCanReturnFocus: null,
      onDeactivate: i.handleDeactivate,
      onPostDeactivate: i.handlePostDeactivate,
      // we need to special-case this setting as well so that we can know if we should
      //  NOT return focus if the trap gets auto-deactivated as the result of an
      //  outside click (otherwise, we'll always think we should return focus because
      //  of how we manage that flag internally here)
      clickOutsideDeactivates: i.handleClickOutsideDeactivates
    }, i.originalOptions = {
      // because of the above `internalOptions`, we maintain our own flag for
      //  this option, and default it to `true` because that's focus-trap's default
      returnFocusOnDeactivate: !0,
      // because of the above `internalOptions`, we keep these separate since
      //  they're part of the deactivation process which we configure (internally) to
      //  be shared between focus-trap and focus-trap-react
      onDeactivate: null,
      onPostDeactivate: null,
      checkCanReturnFocus: null,
      // the user's setting, defaulted to false since focus-trap defaults this to false
      clickOutsideDeactivates: !1
    };
    var o = r.focusTrapOptions;
    for (var a in o)
      if (Object.prototype.hasOwnProperty.call(o, a)) {
        if (a === "returnFocusOnDeactivate" || a === "onDeactivate" || a === "onPostDeactivate" || a === "checkCanReturnFocus" || a === "clickOutsideDeactivates") {
          i.originalOptions[a] = o[a];
          continue;
        }
        i.internalOptions[a] = o[a];
      }
    return i.outsideClick = null, i.focusTrapElements = r.containerElements || [], i.updatePreviousElement(), i;
  }
  return yu(n, [{
    key: "getDocument",
    value: function() {
      return this.props.focusTrapOptions.document || (typeof document < "u" ? document : void 0);
    }
  }, {
    key: "getReturnFocusNode",
    value: function() {
      var i = this.getNodeForOption("setReturnFocus", this.previouslyFocusedElement);
      return i || (i === !1 ? !1 : this.previouslyFocusedElement);
    }
    /** Update the previously focused element with the currently focused element. */
  }, {
    key: "updatePreviousElement",
    value: function() {
      var i = this.getDocument();
      i && (this.previouslyFocusedElement = i.activeElement);
    }
  }, {
    key: "deactivateTrap",
    value: function() {
      !this.focusTrap || !this.focusTrap.active || this.focusTrap.deactivate({
        // NOTE: we never let the trap return the focus since we do that ourselves
        returnFocus: !1,
        // we'll call this in our own post deactivate handler so make sure the trap doesn't
        //  do it prematurely
        checkCanReturnFocus: null,
        // let it call the user's original deactivate handler, if any, instead of
        //  our own which calls back into this function
        onDeactivate: this.originalOptions.onDeactivate
        // NOTE: for post deactivate, don't specify anything so that it calls the
        //  onPostDeactivate handler specified on `this.internalOptions`
        //  which will always be our own `handlePostDeactivate()` handler, which
        //  will finish things off by calling the user's provided onPostDeactivate
        //  handler, if any, at the right time
        // onPostDeactivate: NOTHING
      });
    }
  }, {
    key: "handleClickOutsideDeactivates",
    value: function(i) {
      var o = typeof this.originalOptions.clickOutsideDeactivates == "function" ? this.originalOptions.clickOutsideDeactivates.call(null, i) : this.originalOptions.clickOutsideDeactivates;
      return o && (this.outsideClick = {
        target: i.target,
        allowDeactivation: o
      }), o;
    }
  }, {
    key: "handleDeactivate",
    value: function() {
      this.originalOptions.onDeactivate && this.originalOptions.onDeactivate.call(null), this.deactivateTrap();
    }
  }, {
    key: "handlePostDeactivate",
    value: function() {
      var i = this, o = function() {
        var l = i.getReturnFocusNode(), s = !!// did the consumer allow it?
        (i.originalOptions.returnFocusOnDeactivate && // can we actually focus the node?
        l !== null && l !== void 0 && l.focus && // was there an outside click that allowed deactivation?
        (!i.outsideClick || // did the consumer allow deactivation when the outside node was clicked?
        i.outsideClick.allowDeactivation && // is the outside node NOT focusable (implying that it did NOT receive focus
        //  as a result of the click-through) -- in which case do NOT restore focus
        //  to `returnFocusNode` because focus should remain on the outside node
        !ku(i.outsideClick.target, i.internalOptions.tabbableOptions))), u = i.internalOptions.preventScroll, c = u === void 0 ? !1 : u;
        s && l.focus({
          preventScroll: c
        }), i.originalOptions.onPostDeactivate && i.originalOptions.onPostDeactivate.call(null), i.outsideClick = null;
      };
      this.originalOptions.checkCanReturnFocus ? this.originalOptions.checkCanReturnFocus.call(null, this.getReturnFocusNode()).then(o, o) : o();
    }
  }, {
    key: "setupFocusTrap",
    value: function() {
      if (this.focusTrap)
        this.props.active && !this.focusTrap.active && (this.focusTrap.activate(), this.props.paused && this.focusTrap.pause());
      else {
        var i = this.focusTrapElements.some(Boolean);
        i && (this.focusTrap = this.props._createFocusTrap(this.focusTrapElements, this.internalOptions), this.props.active && this.focusTrap.activate(), this.props.paused && this.focusTrap.pause());
      }
    }
  }, {
    key: "componentDidMount",
    value: function() {
      this.props.active && this.setupFocusTrap();
    }
  }, {
    key: "componentDidUpdate",
    value: function(i) {
      if (this.focusTrap) {
        i.containerElements !== this.props.containerElements && this.focusTrap.updateContainerElements(this.props.containerElements);
        var o = !i.active && this.props.active, a = i.active && !this.props.active, l = !i.paused && this.props.paused, s = i.paused && !this.props.paused;
        if (o && (this.updatePreviousElement(), this.focusTrap.activate()), a) {
          this.deactivateTrap();
          return;
        }
        l && this.focusTrap.pause(), s && this.focusTrap.unpause();
      } else
        i.containerElements !== this.props.containerElements && (this.focusTrapElements = this.props.containerElements), this.props.active && (this.updatePreviousElement(), this.setupFocusTrap());
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.deactivateTrap();
    }
  }, {
    key: "render",
    value: function() {
      var i = this, o = this.props.children ? rn.Children.only(this.props.children) : void 0;
      if (o) {
        if (o.type && o.type === rn.Fragment)
          throw new Error("A focus-trap cannot use a Fragment as its child container. Try replacing it with a <div> element.");
        var a = function(u) {
          var c = i.props.containerElements;
          o && (typeof o.ref == "function" ? o.ref(u) : o.ref && (o.ref.current = u)), i.focusTrapElements = c || [u];
        }, l = rn.cloneElement(o, {
          ref: a
        });
        return l;
      }
      return null;
    }
  }]), n;
}(rn.Component), _t = typeof Element > "u" ? Function : Element;
Cr.propTypes = {
  active: H.bool,
  paused: H.bool,
  focusTrapOptions: H.shape({
    document: H.object,
    onActivate: H.func,
    onPostActivate: H.func,
    checkCanFocusTrap: H.func,
    onPause: H.func,
    onPostPause: H.func,
    onUnpause: H.func,
    onPostUnpause: H.func,
    onDeactivate: H.func,
    onPostDeactivate: H.func,
    checkCanReturnFocus: H.func,
    initialFocus: H.oneOfType([H.instanceOf(_t), H.string, H.bool, H.func]),
    fallbackFocus: H.oneOfType([
      H.instanceOf(_t),
      H.string,
      // NOTE: does not support `false` as value (or return value from function)
      H.func
    ]),
    escapeDeactivates: H.oneOfType([H.bool, H.func]),
    clickOutsideDeactivates: H.oneOfType([H.bool, H.func]),
    returnFocusOnDeactivate: H.bool,
    setReturnFocus: H.oneOfType([H.instanceOf(_t), H.string, H.bool, H.func]),
    allowOutsideClick: H.oneOfType([H.bool, H.func]),
    preventScroll: H.bool,
    tabbableOptions: H.shape({
      displayCheck: H.oneOf(["full", "legacy-full", "non-zero-area", "none"]),
      getShadowRoot: H.oneOfType([H.bool, H.func])
    }),
    trapStack: H.array,
    isKeyForward: H.func,
    isKeyBackward: H.func
  }),
  containerElements: H.arrayOf(H.instanceOf(_t)),
  // DOM element ONLY
  children: H.oneOfType([
    H.element,
    // React element
    H.instanceOf(_t)
    // DOM element
  ])
  // NOTE: _createFocusTrap is internal, for testing purposes only, so we don't
  //  specify it here. It's expected to be set to the function returned from
  //  require('focus-trap'), or one with a compatible interface.
};
Cr.defaultProps = {
  active: !0,
  paused: !1,
  focusTrapOptions: {},
  _createFocusTrap: Nu
};
var ju = Cr;
const Eu = /* @__PURE__ */ rt(ju);
const Cu = 991;
function Ar({
  style: e,
  className: t,
  children: n,
  isNormalSize: r,
  isMounted: i
}) {
  const o = it(Cu), a = We(null);
  return /* @__PURE__ */ v.jsx(
    Eu,
    {
      focusTrapOptions: {
        clickOutsideDeactivates: !0,
        tabbableOptions: {
          displayCheck: void 0
        }
      },
      children: /* @__PURE__ */ v.jsx(
        "div",
        {
          ref: a,
          tabIndex: -1,
          role: "dialog",
          "aria-modal": !0,
          className: _o(
            {
              "xpert_chatbot__floating-popup": !o,
              "xpert_chatbot__floating-popup--mobile": o,
              "xpert_chatbot__floating-popup--expand-size": i && !r && !o,
              "xpert_chatbot__floating-popup--return-to-normal-size": i && r && !o
            },
            t
          ),
          style: e,
          children: n
        }
      )
    }
  );
}
Ar.propTypes = {
  children: N.node.isRequired,
  style: N.shape(),
  isMounted: N.bool,
  className: N.string,
  isNormalSize: N.bool
};
Ar.defaultProps = {
  style: {},
  className: "",
  isNormalSize: !0,
  isMounted: !1
};
const Vo = Object.freeze(
  {
    left: 0,
    top: 0,
    width: 16,
    height: 16
  }
), bn = Object.freeze({
  rotate: 0,
  vFlip: !1,
  hFlip: !1
}), Sr = Object.freeze({
  ...Vo,
  ...bn
}), fr = Object.freeze({
  ...Sr,
  body: "",
  hidden: !1
});
function Au(e, t) {
  const n = {};
  !e.hFlip != !t.hFlip && (n.hFlip = !0), !e.vFlip != !t.vFlip && (n.vFlip = !0);
  const r = ((e.rotate || 0) + (t.rotate || 0)) % 4;
  return r && (n.rotate = r), n;
}
function Ti(e, t) {
  const n = Au(e, t);
  for (const r in fr)
    r in bn ? r in e && !(r in n) && (n[r] = bn[r]) : r in t ? n[r] = t[r] : r in e && (n[r] = e[r]);
  return n;
}
function Su(e, t) {
  const n = e.icons, r = e.aliases || /* @__PURE__ */ Object.create(null), i = /* @__PURE__ */ Object.create(null);
  function o(a) {
    if (n[a])
      return i[a] = [];
    if (!(a in i)) {
      i[a] = null;
      const l = r[a] && r[a].parent, s = l && o(l);
      s && (i[a] = [l].concat(s));
    }
    return i[a];
  }
  return (t || Object.keys(n).concat(Object.keys(r))).forEach(o), i;
}
function Ou(e, t, n) {
  const r = e.icons, i = e.aliases || /* @__PURE__ */ Object.create(null);
  let o = {};
  function a(l) {
    o = Ti(
      r[l] || i[l],
      o
    );
  }
  return a(t), n.forEach(a), Ti(e, o);
}
function Wo(e, t) {
  const n = [];
  if (typeof e != "object" || typeof e.icons != "object")
    return n;
  e.not_found instanceof Array && e.not_found.forEach((i) => {
    t(i, null), n.push(i);
  });
  const r = Su(e);
  for (const i in r) {
    const o = r[i];
    o && (t(i, Ou(e, i, o)), n.push(i));
  }
  return n;
}
const Ut = /^[a-z0-9]+(-[a-z0-9]+)*$/, vn = (e, t, n, r = "") => {
  const i = e.split(":");
  if (e.slice(0, 1) === "@") {
    if (i.length < 2 || i.length > 3)
      return null;
    r = i.shift().slice(1);
  }
  if (i.length > 3 || !i.length)
    return null;
  if (i.length > 1) {
    const l = i.pop(), s = i.pop(), u = {
      // Allow provider without '@': "provider:prefix:name"
      provider: i.length > 0 ? i[0] : r,
      prefix: s,
      name: l
    };
    return t && !un(u) ? null : u;
  }
  const o = i[0], a = o.split("-");
  if (a.length > 1) {
    const l = {
      provider: r,
      prefix: a.shift(),
      name: a.join("-")
    };
    return t && !un(l) ? null : l;
  }
  if (n && r === "") {
    const l = {
      provider: r,
      prefix: "",
      name: o
    };
    return t && !un(l, n) ? null : l;
  }
  return null;
}, un = (e, t) => e ? !!((e.provider === "" || e.provider.match(Ut)) && (t && e.prefix === "" || e.prefix.match(Ut)) && e.name.match(Ut)) : !1, zu = {
  provider: "",
  aliases: {},
  not_found: {},
  ...Vo
};
function Gn(e, t) {
  for (const n in t)
    if (n in e && typeof e[n] != typeof t[n])
      return !1;
  return !0;
}
function Go(e) {
  if (typeof e != "object" || e === null)
    return null;
  const t = e;
  if (typeof t.prefix != "string" || !e.icons || typeof e.icons != "object" || !Gn(e, zu))
    return null;
  const n = t.icons;
  for (const i in n) {
    const o = n[i];
    if (!i.match(Ut) || typeof o.body != "string" || !Gn(
      o,
      fr
    ))
      return null;
  }
  const r = t.aliases || /* @__PURE__ */ Object.create(null);
  for (const i in r) {
    const o = r[i], a = o.parent;
    if (!i.match(Ut) || typeof a != "string" || !n[a] && !r[a] || !Gn(
      o,
      fr
    ))
      return null;
  }
  return t;
}
const Di = /* @__PURE__ */ Object.create(null);
function Lu(e, t) {
  return {
    provider: e,
    prefix: t,
    icons: /* @__PURE__ */ Object.create(null),
    missing: /* @__PURE__ */ new Set()
  };
}
function ht(e, t) {
  const n = Di[e] || (Di[e] = /* @__PURE__ */ Object.create(null));
  return n[t] || (n[t] = Lu(e, t));
}
function Or(e, t) {
  return Go(t) ? Wo(t, (n, r) => {
    r ? e.icons[n] = r : e.missing.add(n);
  }) : [];
}
function _u(e, t, n) {
  try {
    if (typeof n.body == "string")
      return e.icons[t] = { ...n }, !0;
  } catch {
  }
  return !1;
}
let $t = !1;
function Zo(e) {
  return typeof e == "boolean" && ($t = e), $t;
}
function Ni(e) {
  const t = typeof e == "string" ? vn(e, !0, $t) : e;
  if (t) {
    const n = ht(t.provider, t.prefix), r = t.name;
    return n.icons[r] || (n.missing.has(r) ? null : void 0);
  }
}
function Fu(e, t) {
  const n = vn(e, !0, $t);
  if (!n)
    return !1;
  const r = ht(n.provider, n.prefix);
  return _u(r, n.name, t);
}
function Pu(e, t) {
  if (typeof e != "object")
    return !1;
  if (typeof t != "string" && (t = e.provider || ""), $t && !t && !e.prefix) {
    let i = !1;
    return Go(e) && (e.prefix = "", Wo(e, (o, a) => {
      a && Fu(o, a) && (i = !0);
    })), i;
  }
  const n = e.prefix;
  if (!un({
    provider: t,
    prefix: n,
    name: "a"
  }))
    return !1;
  const r = ht(t, n);
  return !!Or(r, e);
}
const Xo = Object.freeze({
  width: null,
  height: null
}), Ko = Object.freeze({
  // Dimensions
  ...Xo,
  // Transformations
  ...bn
}), Ru = /(-?[0-9.]*[0-9]+[0-9.]*)/g, Bu = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function Ii(e, t, n) {
  if (t === 1)
    return e;
  if (n = n || 100, typeof e == "number")
    return Math.ceil(e * t * n) / n;
  if (typeof e != "string")
    return e;
  const r = e.split(Ru);
  if (r === null || !r.length)
    return e;
  const i = [];
  let o = r.shift(), a = Bu.test(o);
  for (; ; ) {
    if (a) {
      const l = parseFloat(o);
      isNaN(l) ? i.push(o) : i.push(Math.ceil(l * t * n) / n);
    } else
      i.push(o);
    if (o = r.shift(), o === void 0)
      return i.join("");
    a = !a;
  }
}
function Uu(e, t = "defs") {
  let n = "";
  const r = e.indexOf("<" + t);
  for (; r >= 0; ) {
    const i = e.indexOf(">", r), o = e.indexOf("</" + t);
    if (i === -1 || o === -1)
      break;
    const a = e.indexOf(">", o);
    if (a === -1)
      break;
    n += e.slice(i + 1, o).trim(), e = e.slice(0, r).trim() + e.slice(a + 1);
  }
  return {
    defs: n,
    content: e
  };
}
function Qu(e, t) {
  return e ? "<defs>" + e + "</defs>" + t : t;
}
function Yu(e, t, n) {
  const r = Uu(e);
  return Qu(r.defs, t + r.content + n);
}
const Hu = (e) => e === "unset" || e === "undefined" || e === "none";
function $u(e, t) {
  const n = {
    ...Sr,
    ...e
  }, r = {
    ...Ko,
    ...t
  }, i = {
    left: n.left,
    top: n.top,
    width: n.width,
    height: n.height
  };
  let o = n.body;
  [n, r].forEach((x) => {
    const k = [], M = x.hFlip, z = x.vFlip;
    let E = x.rotate;
    M ? z ? E += 2 : (k.push(
      "translate(" + (i.width + i.left).toString() + " " + (0 - i.top).toString() + ")"
    ), k.push("scale(-1 1)"), i.top = i.left = 0) : z && (k.push(
      "translate(" + (0 - i.left).toString() + " " + (i.height + i.top).toString() + ")"
    ), k.push("scale(1 -1)"), i.top = i.left = 0);
    let _;
    switch (E < 0 && (E -= Math.floor(E / 4) * 4), E = E % 4, E) {
      case 1:
        _ = i.height / 2 + i.top, k.unshift(
          "rotate(90 " + _.toString() + " " + _.toString() + ")"
        );
        break;
      case 2:
        k.unshift(
          "rotate(180 " + (i.width / 2 + i.left).toString() + " " + (i.height / 2 + i.top).toString() + ")"
        );
        break;
      case 3:
        _ = i.width / 2 + i.left, k.unshift(
          "rotate(-90 " + _.toString() + " " + _.toString() + ")"
        );
        break;
    }
    E % 2 === 1 && (i.left !== i.top && (_ = i.left, i.left = i.top, i.top = _), i.width !== i.height && (_ = i.width, i.width = i.height, i.height = _)), k.length && (o = Yu(
      o,
      '<g transform="' + k.join(" ") + '">',
      "</g>"
    ));
  });
  const a = r.width, l = r.height, s = i.width, u = i.height;
  let c, p;
  a === null ? (p = l === null ? "1em" : l === "auto" ? u : l, c = Ii(p, s / u)) : (c = a === "auto" ? s : a, p = l === null ? Ii(c, u / s) : l === "auto" ? u : l);
  const m = {}, f = (x, k) => {
    Hu(k) || (m[x] = k.toString());
  };
  f("width", c), f("height", p);
  const T = [i.left, i.top, s, u];
  return m.viewBox = T.join(" "), {
    attributes: m,
    viewBox: T,
    body: o
  };
}
const qu = /\sid="(\S+)"/g, Vu = "IconifyId" + Date.now().toString(16) + (Math.random() * 16777216 | 0).toString(16);
let Wu = 0;
function Gu(e, t = Vu) {
  const n = [];
  let r;
  for (; r = qu.exec(e); )
    n.push(r[1]);
  if (!n.length)
    return e;
  const i = "suffix" + (Math.random() * 16777216 | Date.now()).toString(16);
  return n.forEach((o) => {
    const a = typeof t == "function" ? t(o) : t + (Wu++).toString(), l = o.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    e = e.replace(
      // Allowed characters before id: [#;"]
      // Allowed characters after id: [)"], .[a-z]
      new RegExp('([#;"])(' + l + ')([")]|\\.[a-z])', "g"),
      "$1" + a + i + "$3"
    );
  }), e = e.replace(new RegExp(i, "g"), ""), e;
}
const dr = /* @__PURE__ */ Object.create(null);
function Zu(e, t) {
  dr[e] = t;
}
function hr(e) {
  return dr[e] || dr[""];
}
function zr(e) {
  let t;
  if (typeof e.resources == "string")
    t = [e.resources];
  else if (t = e.resources, !(t instanceof Array) || !t.length)
    return null;
  return {
    // API hosts
    resources: t,
    // Root path
    path: e.path || "/",
    // URL length limit
    maxURL: e.maxURL || 500,
    // Timeout before next host is used.
    rotate: e.rotate || 750,
    // Timeout before failing query.
    timeout: e.timeout || 5e3,
    // Randomise default API end point.
    random: e.random === !0,
    // Start index
    index: e.index || 0,
    // Receive data after time out (used if time out kicks in first, then API module sends data anyway).
    dataAfterTimeout: e.dataAfterTimeout !== !1
  };
}
const Lr = /* @__PURE__ */ Object.create(null), Ft = [
  "https://api.simplesvg.com",
  "https://api.unisvg.com"
], cn = [];
for (; Ft.length > 0; )
  Ft.length === 1 || Math.random() > 0.5 ? cn.push(Ft.shift()) : cn.push(Ft.pop());
Lr[""] = zr({
  resources: ["https://api.iconify.design"].concat(cn)
});
function Xu(e, t) {
  const n = zr(t);
  return n === null ? !1 : (Lr[e] = n, !0);
}
function _r(e) {
  return Lr[e];
}
const Ku = () => {
  let e;
  try {
    if (e = fetch, typeof e == "function")
      return e;
  } catch {
  }
};
let ki = Ku();
function Ju(e, t) {
  const n = _r(e);
  if (!n)
    return 0;
  let r;
  if (!n.maxURL)
    r = 0;
  else {
    let i = 0;
    n.resources.forEach((a) => {
      i = Math.max(i, a.length);
    });
    const o = t + ".json?icons=";
    r = n.maxURL - i - n.path.length - o.length;
  }
  return r;
}
function ec(e) {
  return e === 404;
}
const tc = (e, t, n) => {
  const r = [], i = Ju(e, t), o = "icons";
  let a = {
    type: o,
    provider: e,
    prefix: t,
    icons: []
  }, l = 0;
  return n.forEach((s, u) => {
    l += s.length + 1, l >= i && u > 0 && (r.push(a), a = {
      type: o,
      provider: e,
      prefix: t,
      icons: []
    }, l = s.length), a.icons.push(s);
  }), r.push(a), r;
};
function nc(e) {
  if (typeof e == "string") {
    const t = _r(e);
    if (t)
      return t.path;
  }
  return "/";
}
const rc = (e, t, n) => {
  if (!ki) {
    n("abort", 424);
    return;
  }
  let r = nc(t.provider);
  switch (t.type) {
    case "icons": {
      const o = t.prefix, l = t.icons.join(","), s = new URLSearchParams({
        icons: l
      });
      r += o + ".json?" + s.toString();
      break;
    }
    case "custom": {
      const o = t.uri;
      r += o.slice(0, 1) === "/" ? o.slice(1) : o;
      break;
    }
    default:
      n("abort", 400);
      return;
  }
  let i = 503;
  ki(e + r).then((o) => {
    const a = o.status;
    if (a !== 200) {
      setTimeout(() => {
        n(ec(a) ? "abort" : "next", a);
      });
      return;
    }
    return i = 501, o.json();
  }).then((o) => {
    if (typeof o != "object" || o === null) {
      setTimeout(() => {
        o === 404 ? n("abort", o) : n("next", i);
      });
      return;
    }
    setTimeout(() => {
      n("success", o);
    });
  }).catch(() => {
    n("next", i);
  });
}, ic = {
  prepare: tc,
  send: rc
};
function oc(e) {
  const t = {
    loaded: [],
    missing: [],
    pending: []
  }, n = /* @__PURE__ */ Object.create(null);
  e.sort((i, o) => i.provider !== o.provider ? i.provider.localeCompare(o.provider) : i.prefix !== o.prefix ? i.prefix.localeCompare(o.prefix) : i.name.localeCompare(o.name));
  let r = {
    provider: "",
    prefix: "",
    name: ""
  };
  return e.forEach((i) => {
    if (r.name === i.name && r.prefix === i.prefix && r.provider === i.provider)
      return;
    r = i;
    const o = i.provider, a = i.prefix, l = i.name, s = n[o] || (n[o] = /* @__PURE__ */ Object.create(null)), u = s[a] || (s[a] = ht(o, a));
    let c;
    l in u.icons ? c = t.loaded : a === "" || u.missing.has(l) ? c = t.missing : c = t.pending;
    const p = {
      provider: o,
      prefix: a,
      name: l
    };
    c.push(p);
  }), t;
}
function Jo(e, t) {
  e.forEach((n) => {
    const r = n.loaderCallbacks;
    r && (n.loaderCallbacks = r.filter((i) => i.id !== t));
  });
}
function ac(e) {
  e.pendingCallbacksFlag || (e.pendingCallbacksFlag = !0, setTimeout(() => {
    e.pendingCallbacksFlag = !1;
    const t = e.loaderCallbacks ? e.loaderCallbacks.slice(0) : [];
    if (!t.length)
      return;
    let n = !1;
    const r = e.provider, i = e.prefix;
    t.forEach((o) => {
      const a = o.icons, l = a.pending.length;
      a.pending = a.pending.filter((s) => {
        if (s.prefix !== i)
          return !0;
        const u = s.name;
        if (e.icons[u])
          a.loaded.push({
            provider: r,
            prefix: i,
            name: u
          });
        else if (e.missing.has(u))
          a.missing.push({
            provider: r,
            prefix: i,
            name: u
          });
        else
          return n = !0, !0;
        return !1;
      }), a.pending.length !== l && (n || Jo([e], o.id), o.callback(
        a.loaded.slice(0),
        a.missing.slice(0),
        a.pending.slice(0),
        o.abort
      ));
    });
  }));
}
let lc = 0;
function sc(e, t, n) {
  const r = lc++, i = Jo.bind(null, n, r);
  if (!t.pending.length)
    return i;
  const o = {
    id: r,
    icons: t,
    callback: e,
    abort: i
  };
  return n.forEach((a) => {
    (a.loaderCallbacks || (a.loaderCallbacks = [])).push(o);
  }), i;
}
function uc(e, t = !0, n = !1) {
  const r = [];
  return e.forEach((i) => {
    const o = typeof i == "string" ? vn(i, t, n) : i;
    o && r.push(o);
  }), r;
}
var cc = {
  resources: [],
  index: 0,
  timeout: 2e3,
  rotate: 750,
  random: !1,
  dataAfterTimeout: !1
};
function pc(e, t, n, r) {
  const i = e.resources.length, o = e.random ? Math.floor(Math.random() * i) : e.index;
  let a;
  if (e.random) {
    let b = e.resources.slice(0);
    for (a = []; b.length > 1; ) {
      const L = Math.floor(Math.random() * b.length);
      a.push(b[L]), b = b.slice(0, L).concat(b.slice(L + 1));
    }
    a = a.concat(b);
  } else
    a = e.resources.slice(o).concat(e.resources.slice(0, o));
  const l = Date.now();
  let s = "pending", u = 0, c, p = null, m = [], f = [];
  typeof r == "function" && f.push(r);
  function T() {
    p && (clearTimeout(p), p = null);
  }
  function x() {
    s === "pending" && (s = "aborted"), T(), m.forEach((b) => {
      b.status === "pending" && (b.status = "aborted");
    }), m = [];
  }
  function k(b, L) {
    L && (f = []), typeof b == "function" && f.push(b);
  }
  function M() {
    return {
      startTime: l,
      payload: t,
      status: s,
      queriesSent: u,
      queriesPending: m.length,
      subscribe: k,
      abort: x
    };
  }
  function z() {
    s = "failed", f.forEach((b) => {
      b(void 0, c);
    });
  }
  function E() {
    m.forEach((b) => {
      b.status === "pending" && (b.status = "aborted");
    }), m = [];
  }
  function _(b, L, $) {
    const W = L !== "success";
    switch (m = m.filter((K) => K !== b), s) {
      case "pending":
        break;
      case "failed":
        if (W || !e.dataAfterTimeout)
          return;
        break;
      default:
        return;
    }
    if (L === "abort") {
      c = $, z();
      return;
    }
    if (W) {
      c = $, m.length || (a.length ? U() : z());
      return;
    }
    if (T(), E(), !e.random) {
      const K = e.resources.indexOf(b.resource);
      K !== -1 && K !== e.index && (e.index = K);
    }
    s = "completed", f.forEach((K) => {
      K($);
    });
  }
  function U() {
    if (s !== "pending")
      return;
    T();
    const b = a.shift();
    if (b === void 0) {
      if (m.length) {
        p = setTimeout(() => {
          T(), s === "pending" && (E(), z());
        }, e.timeout);
        return;
      }
      z();
      return;
    }
    const L = {
      status: "pending",
      resource: b,
      callback: ($, W) => {
        _(L, $, W);
      }
    };
    m.push(L), u++, p = setTimeout(U, e.rotate), n(b, t, L.callback);
  }
  return setTimeout(U), M;
}
function ea(e) {
  const t = {
    ...cc,
    ...e
  };
  let n = [];
  function r() {
    n = n.filter((l) => l().status === "pending");
  }
  function i(l, s, u) {
    const c = pc(
      t,
      l,
      s,
      (p, m) => {
        r(), u && u(p, m);
      }
    );
    return n.push(c), c;
  }
  function o(l) {
    return n.find((s) => l(s)) || null;
  }
  return {
    query: i,
    find: o,
    setIndex: (l) => {
      t.index = l;
    },
    getIndex: () => t.index,
    cleanup: r
  };
}
function ji() {
}
const Zn = /* @__PURE__ */ Object.create(null);
function fc(e) {
  if (!Zn[e]) {
    const t = _r(e);
    if (!t)
      return;
    const n = ea(t), r = {
      config: t,
      redundancy: n
    };
    Zn[e] = r;
  }
  return Zn[e];
}
function dc(e, t, n) {
  let r, i;
  if (typeof e == "string") {
    const o = hr(e);
    if (!o)
      return n(void 0, 424), ji;
    i = o.send;
    const a = fc(e);
    a && (r = a.redundancy);
  } else {
    const o = zr(e);
    if (o) {
      r = ea(o);
      const a = e.resources ? e.resources[0] : "", l = hr(a);
      l && (i = l.send);
    }
  }
  return !r || !i ? (n(void 0, 424), ji) : r.query(t, i, n)().abort;
}
const Ei = "iconify2", qt = "iconify", ta = qt + "-count", Ci = qt + "-version", na = 36e5, hc = 168, gc = 50;
function gr(e, t) {
  try {
    return e.getItem(t);
  } catch {
  }
}
function Fr(e, t, n) {
  try {
    return e.setItem(t, n), !0;
  } catch {
  }
}
function Ai(e, t) {
  try {
    e.removeItem(t);
  } catch {
  }
}
function mr(e, t) {
  return Fr(e, ta, t.toString());
}
function yr(e) {
  return parseInt(gr(e, ta)) || 0;
}
const Tn = {
  local: !0,
  session: !0
}, ra = {
  local: /* @__PURE__ */ new Set(),
  session: /* @__PURE__ */ new Set()
};
let Pr = !1;
function mc(e) {
  Pr = e;
}
let on = typeof window > "u" ? {} : window;
function ia(e) {
  const t = e + "Storage";
  try {
    if (on && on[t] && typeof on[t].length == "number")
      return on[t];
  } catch {
  }
  Tn[e] = !1;
}
function oa(e, t) {
  const n = ia(e);
  if (!n)
    return;
  const r = gr(n, Ci);
  if (r !== Ei) {
    if (r) {
      const l = yr(n);
      for (let s = 0; s < l; s++)
        Ai(n, qt + s.toString());
    }
    Fr(n, Ci, Ei), mr(n, 0);
    return;
  }
  const i = Math.floor(Date.now() / na) - hc, o = (l) => {
    const s = qt + l.toString(), u = gr(n, s);
    if (typeof u == "string") {
      try {
        const c = JSON.parse(u);
        if (typeof c == "object" && typeof c.cached == "number" && c.cached > i && typeof c.provider == "string" && typeof c.data == "object" && typeof c.data.prefix == "string" && // Valid item: run callback
        t(c, l))
          return !0;
      } catch {
      }
      Ai(n, s);
    }
  };
  let a = yr(n);
  for (let l = a - 1; l >= 0; l--)
    o(l) || (l === a - 1 ? (a--, mr(n, a)) : ra[e].add(l));
}
function aa() {
  if (!Pr) {
    mc(!0);
    for (const e in Tn)
      oa(e, (t) => {
        const n = t.data, r = t.provider, i = n.prefix, o = ht(
          r,
          i
        );
        if (!Or(o, n).length)
          return !1;
        const a = n.lastModified || -1;
        return o.lastModifiedCached = o.lastModifiedCached ? Math.min(o.lastModifiedCached, a) : a, !0;
      });
  }
}
function yc(e, t) {
  const n = e.lastModifiedCached;
  if (
    // Matches or newer
    n && n >= t
  )
    return n === t;
  if (e.lastModifiedCached = t, n)
    for (const r in Tn)
      oa(r, (i) => {
        const o = i.data;
        return i.provider !== e.provider || o.prefix !== e.prefix || o.lastModified === t;
      });
  return !0;
}
function Mc(e, t) {
  Pr || aa();
  function n(r) {
    let i;
    if (!Tn[r] || !(i = ia(r)))
      return;
    const o = ra[r];
    let a;
    if (o.size)
      o.delete(a = Array.from(o).shift());
    else if (a = yr(i), a >= gc || !mr(i, a + 1))
      return;
    const l = {
      cached: Math.floor(Date.now() / na),
      provider: e.provider,
      data: t
    };
    return Fr(
      i,
      qt + a.toString(),
      JSON.stringify(l)
    );
  }
  t.lastModified && !yc(e, t.lastModified) || Object.keys(t.icons).length && (t.not_found && (t = Object.assign({}, t), delete t.not_found), n("local") || n("session"));
}
function Si() {
}
function bc(e) {
  e.iconsLoaderFlag || (e.iconsLoaderFlag = !0, setTimeout(() => {
    e.iconsLoaderFlag = !1, ac(e);
  }));
}
function xc(e, t) {
  e.iconsToLoad ? e.iconsToLoad = e.iconsToLoad.concat(t).sort() : e.iconsToLoad = t, e.iconsQueueFlag || (e.iconsQueueFlag = !0, setTimeout(() => {
    e.iconsQueueFlag = !1;
    const { provider: n, prefix: r } = e, i = e.iconsToLoad;
    delete e.iconsToLoad;
    let o;
    if (!i || !(o = hr(n)))
      return;
    o.prepare(n, r, i).forEach((l) => {
      dc(n, l, (s) => {
        if (typeof s != "object")
          l.icons.forEach((u) => {
            e.missing.add(u);
          });
        else
          try {
            const u = Or(
              e,
              s
            );
            if (!u.length)
              return;
            const c = e.pendingIcons;
            c && u.forEach((p) => {
              c.delete(p);
            }), Mc(e, s);
          } catch (u) {
            console.error(u);
          }
        bc(e);
      });
    });
  }));
}
const wc = (e, t) => {
  const n = uc(e, !0, Zo()), r = oc(n);
  if (!r.pending.length) {
    let s = !0;
    return t && setTimeout(() => {
      s && t(
        r.loaded,
        r.missing,
        r.pending,
        Si
      );
    }), () => {
      s = !1;
    };
  }
  const i = /* @__PURE__ */ Object.create(null), o = [];
  let a, l;
  return r.pending.forEach((s) => {
    const { provider: u, prefix: c } = s;
    if (c === l && u === a)
      return;
    a = u, l = c, o.push(ht(u, c));
    const p = i[u] || (i[u] = /* @__PURE__ */ Object.create(null));
    p[c] || (p[c] = []);
  }), r.pending.forEach((s) => {
    const { provider: u, prefix: c, name: p } = s, m = ht(u, c), f = m.pendingIcons || (m.pendingIcons = /* @__PURE__ */ new Set());
    f.has(p) || (f.add(p), i[u][c].push(p));
  }), o.forEach((s) => {
    const { provider: u, prefix: c } = s;
    i[u][c].length && xc(s, i[u][c]);
  }), t ? sc(t, r, o) : Si;
};
function vc(e, t) {
  const n = {
    ...e
  };
  for (const r in t) {
    const i = t[r], o = typeof i;
    r in Xo ? (i === null || i && (o === "string" || o === "number")) && (n[r] = i) : o === typeof n[r] && (n[r] = r === "rotate" ? i % 4 : i);
  }
  return n;
}
const Tc = /[\s,]+/;
function Dc(e, t) {
  t.split(Tc).forEach((n) => {
    switch (n.trim()) {
      case "horizontal":
        e.hFlip = !0;
        break;
      case "vertical":
        e.vFlip = !0;
        break;
    }
  });
}
function Nc(e, t = 0) {
  const n = e.replace(/^-?[0-9.]*/, "");
  function r(i) {
    for (; i < 0; )
      i += 4;
    return i % 4;
  }
  if (n === "") {
    const i = parseInt(e);
    return isNaN(i) ? 0 : r(i);
  } else if (n !== e) {
    let i = 0;
    switch (n) {
      case "%":
        i = 25;
        break;
      case "deg":
        i = 90;
    }
    if (i) {
      let o = parseFloat(e.slice(0, e.length - n.length));
      return isNaN(o) ? 0 : (o = o / i, o % 1 === 0 ? r(o) : 0);
    }
  }
  return t;
}
function Ic(e, t) {
  let n = e.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
  for (const r in t)
    n += " " + r + '="' + t[r] + '"';
  return '<svg xmlns="http://www.w3.org/2000/svg"' + n + ">" + e + "</svg>";
}
function kc(e) {
  return e.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
function jc(e) {
  return "data:image/svg+xml," + kc(e);
}
function Ec(e) {
  return 'url("' + jc(e) + '")';
}
let Qt;
function Cc() {
  try {
    Qt = window.trustedTypes.createPolicy("iconify", {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      createHTML: (e) => e
    });
  } catch {
    Qt = null;
  }
}
function Ac(e) {
  return Qt === void 0 && Cc(), Qt ? Qt.createHTML(e) : e;
}
const la = {
  ...Ko,
  inline: !1
}, Sc = {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  "aria-hidden": !0,
  role: "img"
}, Oc = {
  display: "inline-block"
}, Mr = {
  backgroundColor: "currentColor"
}, sa = {
  backgroundColor: "transparent"
}, Oi = {
  Image: "var(--svg)",
  Repeat: "no-repeat",
  Size: "100% 100%"
}, zi = {
  WebkitMask: Mr,
  mask: Mr,
  background: sa
};
for (const e in zi) {
  const t = zi[e];
  for (const n in Oi)
    t[e + n] = Oi[n];
}
const zc = {
  ...la,
  inline: !0
};
function Li(e) {
  return e + (e.match(/^[-0-9.]+$/) ? "px" : "");
}
const Lc = (e, t, n) => {
  const r = t.inline ? zc : la, i = vc(r, t), o = t.mode || "svg", a = {}, l = t.style || {}, s = {
    ...o === "svg" ? Sc : {}
  };
  if (n) {
    const k = vn(n, !1, !0);
    if (k) {
      const M = ["iconify"], z = [
        "provider",
        "prefix"
      ];
      for (const E of z)
        k[E] && M.push("iconify--" + k[E]);
      s.className = M.join(" ");
    }
  }
  for (let k in t) {
    const M = t[k];
    if (M !== void 0)
      switch (k) {
        case "icon":
        case "style":
        case "children":
        case "onLoad":
        case "mode":
        case "ssr":
          break;
        case "_ref":
          s.ref = M;
          break;
        case "className":
          s[k] = (s[k] ? s[k] + " " : "") + M;
          break;
        case "inline":
        case "hFlip":
        case "vFlip":
          i[k] = M === !0 || M === "true" || M === 1;
          break;
        case "flip":
          typeof M == "string" && Dc(i, M);
          break;
        case "color":
          a.color = M;
          break;
        case "rotate":
          typeof M == "string" ? i[k] = Nc(M) : typeof M == "number" && (i[k] = M);
          break;
        case "ariaHidden":
        case "aria-hidden":
          M !== !0 && M !== "true" && delete s["aria-hidden"];
          break;
        default:
          r[k] === void 0 && (s[k] = M);
      }
  }
  const u = $u(e, i), c = u.attributes;
  if (i.inline && (a.verticalAlign = "-0.125em"), o === "svg") {
    s.style = {
      ...a,
      ...l
    }, Object.assign(s, c);
    let k = 0, M = t.id;
    return typeof M == "string" && (M = M.replace(/-/g, "_")), s.dangerouslySetInnerHTML = {
      __html: Ac(Gu(u.body, M ? () => M + "ID" + k++ : "iconifyReact"))
    }, sr("svg", s);
  }
  const { body: p, width: m, height: f } = e, T = o === "mask" || (o === "bg" ? !1 : p.indexOf("currentColor") !== -1), x = Ic(p, {
    ...c,
    width: m + "",
    height: f + ""
  });
  return s.style = {
    ...a,
    "--svg": Ec(x),
    width: Li(c.width),
    height: Li(c.height),
    ...Oc,
    ...T ? Mr : sa,
    ...l
  }, sr("span", s);
};
Zo(!0);
Zu("", ic);
if (typeof document < "u" && typeof window < "u") {
  aa();
  const e = window;
  if (e.IconifyPreload !== void 0) {
    const t = e.IconifyPreload, n = "Invalid IconifyPreload syntax.";
    typeof t == "object" && t !== null && (t instanceof Array ? t : [t]).forEach((r) => {
      try {
        // Check if item is an object and not null/array
        (typeof r != "object" || r === null || r instanceof Array || // Check for 'icons' and 'prefix'
        typeof r.icons != "object" || typeof r.prefix != "string" || // Add icon set
        !Pu(r)) && console.error(n);
      } catch {
        console.error(n);
      }
    });
  }
  if (e.IconifyProviders !== void 0) {
    const t = e.IconifyProviders;
    if (typeof t == "object" && t !== null)
      for (let n in t) {
        const r = "IconifyProviders[" + n + "] is invalid.";
        try {
          const i = t[n];
          if (typeof i != "object" || !i || i.resources === void 0)
            continue;
          Xu(n, i) || console.error(r);
        } catch {
          console.error(r);
        }
      }
  }
}
function ua(e) {
  const [t, n] = ye(!!e.ssr), [r, i] = ye({});
  function o(f) {
    if (f) {
      const T = e.icon;
      if (typeof T == "object")
        return {
          name: "",
          data: T
        };
      const x = Ni(T);
      if (x)
        return {
          name: T,
          data: x
        };
    }
    return {
      name: ""
    };
  }
  const [a, l] = ye(o(!!e.ssr));
  function s() {
    const f = r.callback;
    f && (f(), i({}));
  }
  function u(f) {
    if (JSON.stringify(a) !== JSON.stringify(f))
      return s(), l(f), !0;
  }
  function c() {
    var f;
    const T = e.icon;
    if (typeof T == "object") {
      u({
        name: "",
        data: T
      });
      return;
    }
    const x = Ni(T);
    if (u({
      name: T,
      data: x
    }))
      if (x === void 0) {
        const k = wc([T], c);
        i({
          callback: k
        });
      } else
        x && ((f = e.onLoad) === null || f === void 0 || f.call(e, T));
  }
  xe(() => (n(!0), s), []), xe(() => {
    t && c();
  }, [e.icon, t]);
  const { name: p, data: m } = a;
  return m ? Lc({
    ...Sr,
    ...m
  }, e, p) : e.children ? e.children : sr("span", {});
}
const nt = Do((e, t) => ua({
  ...e,
  _ref: t
}));
Do((e, t) => ua({
  inline: !0,
  ...e,
  _ref: t
}));
const _c = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9IiNmZmZmZmYiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iNDgiPjxwYXRoIGQ9Ik0xMjAtMTIwdi0zMDBoNjB2MTk4bDU1OC01NThINTQwdi02MGgzMDB2MzAwaC02MHYtMTk4TDIyMi0xODBoMTk4djYwSDEyMFoiLz48L3N2Zz4=", Fc = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9IiNmZmZmZmYiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iNDgiPjxwYXRoIGQ9Ik0zNzAtMjg3aDM2MHYtOTBIMzcwdjkwWk0xODAtMTIwcS0yNCAwLTQyLTE4dC0xOC00MnYtNjAwcTAtMjQgMTgtNDJ0NDItMThoNjAwcTI0IDAgNDIgMTh0MTggNDJ2NjAwcTAgMjQtMTggNDJ0LTQyIDE4SDE4MFptMC02MGg2MDB2LTYwMEgxODB2NjAwWm0wLTYwMHY2MDAtNjAwWiIvPjwvc3ZnPg==", Pc = 991;
function ca({ isNormalSize: e, setIsMounted: t, setIsNormalSize: n }) {
  return it(Pc) ? null : e ? /* @__PURE__ */ v.jsx(
    "button",
    {
      onClick: () => {
        t(!0), n(!1);
      },
      "aria-label": "Expand xpert dialog width",
      style: {
        backgroundColor: "transparent",
        border: "none",
        padding: "0",
        cursor: "pointer"
      },
      className: "xpert-chatbot-popup__header--btn-outline",
      "aria-expanded": !e,
      children: /* @__PURE__ */ v.jsx(
        "img",
        {
          "aria-hidden": !0,
          height: "24px",
          width: "24px",
          src: _c,
          alt: "Expand xpert dialog width icon"
        }
      )
    }
  ) : /* @__PURE__ */ v.jsx(
    "button",
    {
      onClick: () => {
        t(!0), n(!0);
      },
      "aria-label": "Shrink xpert dialog width",
      style: {
        backgroundColor: "transparent",
        border: "none",
        padding: "0",
        cursor: "pointer"
      },
      "aria-expanded": !e,
      children: /* @__PURE__ */ v.jsx(
        "img",
        {
          "aria-hidden": !0,
          height: "24px",
          width: "24px",
          src: Fc,
          alt: "Shrink xpert dialog width icon"
        }
      )
    }
  );
}
ca.propTypes = {
  isNormalSize: N.bool.isRequired,
  setIsMounted: N.func.isRequired,
  setIsNormalSize: N.func.isRequired
};
function pa({
  isNormalSize: e,
  setIsMounted: t,
  setIsNormalSize: n,
  onClose: r,
  isMounted: i
}) {
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx(
      "div",
      {
        style: {
          display: "flex",
          alignItems: "center",
          marginLeft: "auto",
          marginRight: "1rem",
          paddingTop: "1.25rem",
          paddingBottom: "1.25rem"
        },
        children: /* @__PURE__ */ v.jsx(
          ca,
          {
            isMounted: i,
            setIsMounted: t,
            setIsNormalSize: n,
            isNormalSize: e
          }
        )
      }
    ),
    /* @__PURE__ */ v.jsx(
      "button",
      {
        style: {
          backgroundColor: "transparent",
          border: "none",
          padding: "0",
          color: "white",
          marginRight: "1rem",
          cursor: "pointer"
        },
        className: "xpert-chatbot-popup__header--btn-outline",
        onClick: r,
        "aria-label": "Close Xpert dialog",
        type: "button",
        children: /* @__PURE__ */ v.jsx(
          nt,
          {
            icon: "material-symbols:close",
            alt: "Close Xpert dialog",
            style: { fontSize: "1.75rem" }
          }
        )
      }
    )
  ] });
}
pa.propTypes = {
  isNormalSize: N.bool.isRequired,
  setIsMounted: N.func.isRequired,
  setIsNormalSize: N.func.isRequired,
  onClose: N.func.isRequired,
  isMounted: N.bool.isRequired
};
const Rr = ({ backgroundColor: e, textColor: t }) => /* @__PURE__ */ v.jsxs(
  "svg",
  {
    role: "banner",
    width: "77",
    height: "22",
    viewBox: "0 0 77 22",
    fill: "#none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ v.jsx("path", { d: "M0 5 L0 20 L70 20 L70 5 Z", fill: t }),
      /* @__PURE__ */ v.jsx(
        "path",
        {
          fill: e,
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M77 0H0V22H71.5L77 0ZM24.5938 10.2472L23.3324 7.27273H21.2997L23.2642 11.6364L19.7997 16H21.9517L24.2358 13.0213H24.304L25.5994 16H27.6832L25.6932 11.6364L29.0724 7.27273H26.929L24.6619 10.2472H24.5938ZM33.6832 7.27273H30.2401L28.7912 16H30.6364L31.1091 13.1705H32.6562C33.3295 13.1705 33.9233 13.0469 34.4375 12.7997C34.9517 12.5526 35.3693 12.2088 35.6903 11.7685C36.0142 11.3253 36.2244 10.8125 36.321 10.2301C36.4148 9.65057 36.375 9.1392 36.2017 8.69602C36.0312 8.25 35.733 7.90199 35.3068 7.65199C34.8835 7.39915 34.3423 7.27273 33.6832 7.27273ZM31.3561 11.6918H32.6009C32.9588 11.6918 33.2642 11.6307 33.517 11.5085C33.7727 11.3835 33.9759 11.2116 34.1264 10.9929C34.277 10.7713 34.375 10.517 34.4205 10.2301C34.4688 9.9375 34.4531 9.68324 34.3736 9.46733C34.294 9.25142 34.1477 9.08381 33.9347 8.96449C33.7244 8.84233 33.4418 8.78125 33.0866 8.78125H31.8423L31.3561 11.6918ZM43.8903 7.27273H38.0096L36.5607 16H42.4585L42.7141 14.4787H38.6616L39.0025 12.3949H42.7354L42.9911 10.8736H39.2582L39.5991 8.79403H43.6346L43.8903 7.27273ZM48.8004 7.27273H45.3572L43.9084 16H45.7536L46.2704 12.9062H47.6117L48.7536 16H50.7905L49.4991 12.6097C49.5278 12.5981 49.5563 12.5862 49.5845 12.5739C50.0959 12.3494 50.5107 12.0298 50.8288 11.6151C51.1499 11.2003 51.3587 10.7031 51.4553 10.1236C51.549 9.54403 51.5078 9.04119 51.3317 8.61506C51.1584 8.18608 50.8572 7.85511 50.4283 7.62216C50.0021 7.3892 49.4595 7.27273 48.8004 7.27273ZM46.5181 11.4233H47.7692C48.1214 11.4233 48.4226 11.375 48.6726 11.2784C48.9226 11.1818 49.12 11.0369 49.2649 10.8438C49.4126 10.6506 49.5092 10.4105 49.5547 10.1236C49.603 9.83097 49.5859 9.58665 49.5036 9.39062C49.4212 9.19176 49.272 9.04119 49.0561 8.93892C48.8402 8.83381 48.5561 8.78125 48.2038 8.78125H46.9595L46.5181 11.4233ZM52.9702 7.27273L52.7145 8.79403H55.3864L54.1932 16H56.017L57.2102 8.79403H59.8821L60.1378 7.27273H52.9702Z"
        }
      ),
      /* @__PURE__ */ v.jsx("path", {})
    ]
  }
);
Rr.propTypes = {
  backgroundColor: N.string,
  textColor: N.string
};
Rr.defaultProps = {
  backgroundColor: "#F0CC00",
  textColor: "transparent"
};
const Rc = Rr;
const Bc = 991;
function fa({
  isNormalSize: e,
  setIsNormalSize: t,
  isMounted: n,
  setIsMounted: r,
  onClose: i
}) {
  var s, u, c, p, m, f, T, x, k;
  const { primaryColor: o, conversationScreen: a } = Se(Oe), l = it(Bc);
  return /* @__PURE__ */ v.jsxs(
    "div",
    {
      "data-testid": "xpert-conversations-header",
      style: {
        display: "flex",
        alignItems: "center",
        backgroundColor: o,
        ...l && { padding: "0.75rem 0" },
        ...(s = a.header.container) == null ? void 0 : s.style
      },
      children: [
        /* @__PURE__ */ v.jsx(
          "span",
          {
            className: "xpert-chatbot-popup__header_container",
            style: {
              left: 0,
              background: ((c = (u = a.header.container) == null ? void 0 : u.style) == null ? void 0 : c.background) || o
            }
          }
        ),
        ((m = (p = a == null ? void 0 : a.header) == null ? void 0 : p.logo) == null ? void 0 : m.type) === "edx" ? /* @__PURE__ */ v.jsx(
          "img",
          {
            "data-ot-ignore": "",
            className: "xpert-chatbot-popup__logo optanon-category-C0001",
            src: Fo,
            alt: "xpert logo",
            "aria-hidden": !0,
            style: a.header.logo.style
          }
        ) : /* @__PURE__ */ v.jsx(
          Rc,
          {
            backgroundColor: (f = a.header.logo.style) == null ? void 0 : f.backgroundColor,
            textColor: (T = a.header.logo.style) == null ? void 0 : T.color
          }
        ),
        /* @__PURE__ */ v.jsx(
          pa,
          {
            isMounted: n,
            setIsMounted: r,
            setIsNormalSize: t,
            isNormalSize: e,
            onClose: i
          }
        ),
        /* @__PURE__ */ v.jsx(
          "span",
          {
            className: "xpert-chatbot-popup__header_container",
            style: {
              right: 0,
              background: ((k = (x = a.header.container) == null ? void 0 : x.style) == null ? void 0 : k.backgroun) || o
            }
          }
        )
      ]
    }
  );
}
fa.propTypes = {
  isMounted: N.bool.isRequired,
  isNormalSize: N.bool.isRequired,
  setIsMounted: N.func.isRequired,
  setIsNormalSize: N.func.isRequired,
  onClose: N.func.isRequired
};
const _i = ["http", "https", "mailto", "tel"];
function Uc(e) {
  const t = (e || "").trim(), n = t.charAt(0);
  if (n === "#" || n === "/")
    return t;
  const r = t.indexOf(":");
  if (r === -1)
    return t;
  let i = -1;
  for (; ++i < _i.length; ) {
    const o = _i[i];
    if (r === o.length && t.slice(0, o.length).toLowerCase() === o)
      return t;
  }
  return i = t.indexOf("?"), i !== -1 && r > i || (i = t.indexOf("#"), i !== -1 && r > i) ? t : "javascript:void(0)";
}
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var Qc = function(t) {
  return t != null && t.constructor != null && typeof t.constructor.isBuffer == "function" && t.constructor.isBuffer(t);
};
const da = /* @__PURE__ */ rt(Qc);
function Yt(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Fi(e.position) : "start" in e || "end" in e ? Fi(e) : "line" in e || "column" in e ? br(e) : "";
}
function br(e) {
  return Pi(e && e.line) + ":" + Pi(e && e.column);
}
function Fi(e) {
  return br(e && e.start) + "-" + br(e && e.end);
}
function Pi(e) {
  return e && typeof e == "number" ? e : 1;
}
class Pe extends Error {
  /**
   * Create a message for `reason` at `place` from `origin`.
   *
   * When an error is passed in as `reason`, the `stack` is copied.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   *
   *   > 👉 **Note**: you should use markdown.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // To do: next major: expose `undefined` everywhere instead of `null`.
  constructor(t, n, r) {
    const i = [null, null];
    let o = {
      // @ts-expect-error: we always follows the structure of `position`.
      start: { line: null, column: null },
      // @ts-expect-error: "
      end: { line: null, column: null }
    };
    if (super(), typeof n == "string" && (r = n, n = void 0), typeof r == "string") {
      const a = r.indexOf(":");
      a === -1 ? i[1] = r : (i[0] = r.slice(0, a), i[1] = r.slice(a + 1));
    }
    n && ("type" in n || "position" in n ? n.position && (o = n.position) : "start" in n || "end" in n ? o = n : ("line" in n || "column" in n) && (o.start = n)), this.name = Yt(n) || "1:1", this.message = typeof t == "object" ? t.message : t, this.stack = "", typeof t == "object" && t.stack && (this.stack = t.stack), this.reason = this.message, this.fatal, this.line = o.start.line, this.column = o.start.column, this.position = o, this.source = i[0], this.ruleId = i[1], this.file, this.actual, this.expected, this.url, this.note;
  }
}
Pe.prototype.file = "";
Pe.prototype.name = "";
Pe.prototype.reason = "";
Pe.prototype.message = "";
Pe.prototype.stack = "";
Pe.prototype.fatal = null;
Pe.prototype.column = null;
Pe.prototype.line = null;
Pe.prototype.source = null;
Pe.prototype.ruleId = null;
Pe.prototype.position = null;
const qe = { basename: Yc, dirname: Hc, extname: $c, join: qc, sep: "/" };
function Yc(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  Wt(e);
  let n = 0, r = -1, i = e.length, o;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; i--; )
      if (e.charCodeAt(i) === 47) {
        if (o) {
          n = i + 1;
          break;
        }
      } else
        r < 0 && (o = !0, r = i + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  let a = -1, l = t.length - 1;
  for (; i--; )
    if (e.charCodeAt(i) === 47) {
      if (o) {
        n = i + 1;
        break;
      }
    } else
      a < 0 && (o = !0, a = i + 1), l > -1 && (e.charCodeAt(i) === t.charCodeAt(l--) ? l < 0 && (r = i) : (l = -1, r = a));
  return n === r ? r = a : r < 0 && (r = e.length), e.slice(n, r);
}
function Hc(e) {
  if (Wt(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, r;
  for (; --n; )
    if (e.charCodeAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else
      r || (r = !0);
  return t < 0 ? e.charCodeAt(0) === 47 ? "/" : "." : t === 1 && e.charCodeAt(0) === 47 ? "//" : e.slice(0, t);
}
function $c(e) {
  Wt(e);
  let t = e.length, n = -1, r = 0, i = -1, o = 0, a;
  for (; t--; ) {
    const l = e.charCodeAt(t);
    if (l === 47) {
      if (a) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (a = !0, n = t + 1), l === 46 ? i < 0 ? i = t : o !== 1 && (o = 1) : i > -1 && (o = -1);
  }
  return i < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && i === n - 1 && i === r + 1 ? "" : e.slice(i, n);
}
function qc(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    Wt(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : Vc(n);
}
function Vc(e) {
  Wt(e);
  const t = e.charCodeAt(0) === 47;
  let n = Wc(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.charCodeAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function Wc(e, t) {
  let n = "", r = 0, i = -1, o = 0, a = -1, l, s;
  for (; ++a <= e.length; ) {
    if (a < e.length)
      l = e.charCodeAt(a);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(i === a - 1 || o === 1))
        if (i !== a - 1 && o === 2) {
          if (n.length < 2 || r !== 2 || n.charCodeAt(n.length - 1) !== 46 || n.charCodeAt(n.length - 2) !== 46) {
            if (n.length > 2) {
              if (s = n.lastIndexOf("/"), s !== n.length - 1) {
                s < 0 ? (n = "", r = 0) : (n = n.slice(0, s), r = n.length - 1 - n.lastIndexOf("/")), i = a, o = 0;
                continue;
              }
            } else if (n.length > 0) {
              n = "", r = 0, i = a, o = 0;
              continue;
            }
          }
          t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
        } else
          n.length > 0 ? n += "/" + e.slice(i + 1, a) : n = e.slice(i + 1, a), r = a - i - 1;
      i = a, o = 0;
    } else
      l === 46 && o > -1 ? o++ : o = -1;
  }
  return n;
}
function Wt(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const Gc = { cwd: Zc };
function Zc() {
  return "/";
}
function xr(e) {
  return e !== null && typeof e == "object" && // @ts-expect-error: indexable.
  e.href && // @ts-expect-error: indexable.
  e.origin;
}
function Xc(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!xr(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return Kc(e);
}
function Kc(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.charCodeAt(n) === 37 && t.charCodeAt(n + 1) === 50) {
      const r = t.charCodeAt(n + 2);
      if (r === 70 || r === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(t);
}
const Xn = ["history", "path", "basename", "stem", "extname", "dirname"];
class ha {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Buffer` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? typeof t == "string" || Jc(t) ? n = { value: t } : xr(t) ? n = { path: t } : n = t : n = {}, this.data = {}, this.messages = [], this.history = [], this.cwd = Gc.cwd(), this.value, this.stored, this.result, this.map;
    let r = -1;
    for (; ++r < Xn.length; ) {
      const o = Xn[r];
      o in n && n[o] !== void 0 && n[o] !== null && (this[o] = o === "history" ? [...n[o]] : n[o]);
    }
    let i;
    for (i in n)
      Xn.includes(i) || (this[i] = n[i]);
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {string | URL} path
   */
  set path(t) {
    xr(t) && (t = Xc(t)), Jn(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the parent path (example: `'~'`).
   */
  get dirname() {
    return typeof this.path == "string" ? qe.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   */
  set dirname(t) {
    Ri(this.basename, "dirname"), this.path = qe.join(t || "", this.basename);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */
  get basename() {
    return typeof this.path == "string" ? qe.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set basename(t) {
    Jn(t, "basename"), Kn(t, "basename"), this.path = qe.join(this.dirname || "", t);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   */
  get extname() {
    return typeof this.path == "string" ? qe.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */
  set extname(t) {
    if (Kn(t, "extname"), Ri(this.dirname, "extname"), t) {
      if (t.charCodeAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = qe.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */
  get stem() {
    return typeof this.path == "string" ? qe.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set stem(t) {
    Jn(t, "stem"), Kn(t, "stem"), this.path = qe.join(this.dirname || "", t + (this.extname || ""));
  }
  /**
   * Serialize the file.
   *
   * @param {BufferEncoding | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Buffer`
   *   (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return (this.value || "").toString(t || void 0);
  }
  /**
   * Create a warning message associated with the file.
   *
   * Its `fatal` is set to `false` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, r) {
    const i = new Pe(t, n, r);
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Create an info message associated with the file.
   *
   * Its `fatal` is set to `null` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, r) {
    const i = this.message(t, n, r);
    return i.fatal = null, i;
  }
  /**
   * Create a fatal error associated with the file.
   *
   * Its `fatal` is set to `true` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Message.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, r) {
    const i = this.message(t, n, r);
    throw i.fatal = !0, i;
  }
}
function Kn(e, t) {
  if (e && e.includes(qe.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + qe.sep + "`"
    );
}
function Jn(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function Ri(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function Jc(e) {
  return da(e);
}
function Bi(e) {
  if (e)
    throw e;
}
var pn = Object.prototype.hasOwnProperty, ga = Object.prototype.toString, Ui = Object.defineProperty, Qi = Object.getOwnPropertyDescriptor, Yi = function(t) {
  return typeof Array.isArray == "function" ? Array.isArray(t) : ga.call(t) === "[object Array]";
}, Hi = function(t) {
  if (!t || ga.call(t) !== "[object Object]")
    return !1;
  var n = pn.call(t, "constructor"), r = t.constructor && t.constructor.prototype && pn.call(t.constructor.prototype, "isPrototypeOf");
  if (t.constructor && !n && !r)
    return !1;
  var i;
  for (i in t)
    ;
  return typeof i > "u" || pn.call(t, i);
}, $i = function(t, n) {
  Ui && n.name === "__proto__" ? Ui(t, n.name, {
    enumerable: !0,
    configurable: !0,
    value: n.newValue,
    writable: !0
  }) : t[n.name] = n.newValue;
}, qi = function(t, n) {
  if (n === "__proto__")
    if (pn.call(t, n)) {
      if (Qi)
        return Qi(t, n).value;
    } else
      return;
  return t[n];
}, ep = function e() {
  var t, n, r, i, o, a, l = arguments[0], s = 1, u = arguments.length, c = !1;
  for (typeof l == "boolean" && (c = l, l = arguments[1] || {}, s = 2), (l == null || typeof l != "object" && typeof l != "function") && (l = {}); s < u; ++s)
    if (t = arguments[s], t != null)
      for (n in t)
        r = qi(l, n), i = qi(t, n), l !== i && (c && i && (Hi(i) || (o = Yi(i))) ? (o ? (o = !1, a = r && Yi(r) ? r : []) : a = r && Hi(r) ? r : {}, $i(l, { name: n, newValue: e(c, a, i) })) : typeof i < "u" && $i(l, { name: n, newValue: i }));
  return l;
};
const Vi = /* @__PURE__ */ rt(ep);
function wr(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function tp() {
  const e = [], t = { run: n, use: r };
  return t;
  function n(...i) {
    let o = -1;
    const a = i.pop();
    if (typeof a != "function")
      throw new TypeError("Expected function as last argument, not " + a);
    l(null, ...i);
    function l(s, ...u) {
      const c = e[++o];
      let p = -1;
      if (s) {
        a(s);
        return;
      }
      for (; ++p < i.length; )
        (u[p] === null || u[p] === void 0) && (u[p] = i[p]);
      i = u, c ? np(c, l)(...u) : a(null, ...u);
    }
  }
  function r(i) {
    if (typeof i != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + i
      );
    return e.push(i), t;
  }
}
function np(e, t) {
  let n;
  return r;
  function r(...a) {
    const l = e.length > a.length;
    let s;
    l && a.push(i);
    try {
      s = e.apply(this, a);
    } catch (u) {
      const c = (
        /** @type {Error} */
        u
      );
      if (l && n)
        throw c;
      return i(c);
    }
    l || (s && s.then && typeof s.then == "function" ? s.then(o, i) : s instanceof Error ? i(s) : o(s));
  }
  function i(a, ...l) {
    n || (n = !0, t(a, ...l));
  }
  function o(a) {
    i(null, a);
  }
}
const rp = ya().freeze(), ma = {}.hasOwnProperty;
function ya() {
  const e = tp(), t = [];
  let n = {}, r, i = -1;
  return o.data = a, o.Parser = void 0, o.Compiler = void 0, o.freeze = l, o.attachers = t, o.use = s, o.parse = u, o.stringify = c, o.run = p, o.runSync = m, o.process = f, o.processSync = T, o;
  function o() {
    const x = ya();
    let k = -1;
    for (; ++k < t.length; )
      x.use(...t[k]);
    return x.data(Vi(!0, {}, n)), x;
  }
  function a(x, k) {
    return typeof x == "string" ? arguments.length === 2 ? (nr("data", r), n[x] = k, o) : ma.call(n, x) && n[x] || null : x ? (nr("data", r), n = x, o) : n;
  }
  function l() {
    if (r)
      return o;
    for (; ++i < t.length; ) {
      const [x, ...k] = t[i];
      if (k[0] === !1)
        continue;
      k[0] === !0 && (k[0] = void 0);
      const M = x.call(o, ...k);
      typeof M == "function" && e.use(M);
    }
    return r = !0, i = Number.POSITIVE_INFINITY, o;
  }
  function s(x, ...k) {
    let M;
    if (nr("use", r), x != null)
      if (typeof x == "function")
        U(x, ...k);
      else if (typeof x == "object")
        Array.isArray(x) ? _(x) : E(x);
      else
        throw new TypeError("Expected usable value, not `" + x + "`");
    return M && (n.settings = Object.assign(n.settings || {}, M)), o;
    function z(b) {
      if (typeof b == "function")
        U(b);
      else if (typeof b == "object")
        if (Array.isArray(b)) {
          const [L, ...$] = b;
          U(L, ...$);
        } else
          E(b);
      else
        throw new TypeError("Expected usable value, not `" + b + "`");
    }
    function E(b) {
      _(b.plugins), b.settings && (M = Object.assign(M || {}, b.settings));
    }
    function _(b) {
      let L = -1;
      if (b != null)
        if (Array.isArray(b))
          for (; ++L < b.length; ) {
            const $ = b[L];
            z($);
          }
        else
          throw new TypeError("Expected a list of plugins, not `" + b + "`");
    }
    function U(b, L) {
      let $ = -1, W;
      for (; ++$ < t.length; )
        if (t[$][0] === b) {
          W = t[$];
          break;
        }
      W ? (wr(W[1]) && wr(L) && (L = Vi(!0, W[1], L)), W[1] = L) : t.push([...arguments]);
    }
  }
  function u(x) {
    o.freeze();
    const k = Pt(x), M = o.Parser;
    return er("parse", M), Wi(M, "parse") ? new M(String(k), k).parse() : M(String(k), k);
  }
  function c(x, k) {
    o.freeze();
    const M = Pt(k), z = o.Compiler;
    return tr("stringify", z), Gi(x), Wi(z, "compile") ? new z(x, M).compile() : z(x, M);
  }
  function p(x, k, M) {
    if (Gi(x), o.freeze(), !M && typeof k == "function" && (M = k, k = void 0), !M)
      return new Promise(z);
    z(null, M);
    function z(E, _) {
      e.run(x, Pt(k), U);
      function U(b, L, $) {
        L = L || x, b ? _(b) : E ? E(L) : M(null, L, $);
      }
    }
  }
  function m(x, k) {
    let M, z;
    return o.run(x, k, E), Zi("runSync", "run", z), M;
    function E(_, U) {
      Bi(_), M = U, z = !0;
    }
  }
  function f(x, k) {
    if (o.freeze(), er("process", o.Parser), tr("process", o.Compiler), !k)
      return new Promise(M);
    M(null, k);
    function M(z, E) {
      const _ = Pt(x);
      o.run(o.parse(_), _, (b, L, $) => {
        if (b || !L || !$)
          U(b);
        else {
          const W = o.stringify(L, $);
          W == null || (ap(W) ? $.value = W : $.result = W), U(b, $);
        }
      });
      function U(b, L) {
        b || !L ? E(b) : z ? z(L) : k(null, L);
      }
    }
  }
  function T(x) {
    let k;
    o.freeze(), er("processSync", o.Parser), tr("processSync", o.Compiler);
    const M = Pt(x);
    return o.process(M, z), Zi("processSync", "process", k), M;
    function z(E) {
      k = !0, Bi(E);
    }
  }
}
function Wi(e, t) {
  return typeof e == "function" && // Prototypes do exist.
  // type-coverage:ignore-next-line
  e.prototype && // A function with keys in its prototype is probably a constructor.
  // Classes’ prototype methods are not enumerable, so we check if some value
  // exists in the prototype.
  // type-coverage:ignore-next-line
  (ip(e.prototype) || t in e.prototype);
}
function ip(e) {
  let t;
  for (t in e)
    if (ma.call(e, t))
      return !0;
  return !1;
}
function er(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `Parser`");
}
function tr(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `Compiler`");
}
function nr(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Gi(e) {
  if (!wr(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function Zi(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function Pt(e) {
  return op(e) ? e : new ha(e);
}
function op(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function ap(e) {
  return typeof e == "string" || da(e);
}
const lp = {};
function sp(e, t) {
  const n = t || lp, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, i = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return Ma(e, r, i);
}
function Ma(e, t, n) {
  if (up(e)) {
    if ("value" in e)
      return e.type === "html" && !n ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Xi(e.children, t, n);
  }
  return Array.isArray(e) ? Xi(e, t, n) : "";
}
function Xi(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; )
    r[i] = Ma(e[i], t, n);
  return r.join("");
}
function up(e) {
  return !!(e && typeof e == "object");
}
function Ge(e, t, n, r) {
  const i = e.length;
  let o = 0, a;
  if (t < 0 ? t = -t > i ? 0 : i + t : t = t > i ? i : t, n = n > 0 ? n : 0, r.length < 1e4)
    a = Array.from(r), a.unshift(t, n), e.splice(...a);
  else
    for (n && e.splice(t, n); o < r.length; )
      a = r.slice(o, o + 1e4), a.unshift(t, 0), e.splice(...a), o += 1e4, t += 1e4;
}
function Fe(e, t) {
  return e.length > 0 ? (Ge(e, e.length, 0, t), e) : t;
}
const Ki = {}.hasOwnProperty;
function cp(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    pp(t, e[n]);
  return t;
}
function pp(e, t) {
  let n;
  for (n in t) {
    const i = (Ki.call(e, n) ? e[n] : void 0) || (e[n] = {}), o = t[n];
    let a;
    if (o)
      for (a in o) {
        Ki.call(i, a) || (i[a] = []);
        const l = o[a];
        fp(
          // @ts-expect-error Looks like a list.
          i[a],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function fp(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : r).push(t[n]);
  Ge(e, 0, 0, r);
}
const dp = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/, Ve = ot(/[A-Za-z]/), Ae = ot(/[\dA-Za-z]/), hp = ot(/[#-'*+\--9=?A-Z^-~]/);
function vr(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const Tr = ot(/\d/), gp = ot(/[\dA-Fa-f]/), mp = ot(/[!-/:-@[-`{-~]/);
function G(e) {
  return e !== null && e < -2;
}
function Ie(e) {
  return e !== null && (e < 0 || e === 32);
}
function ie(e) {
  return e === -2 || e === -1 || e === 32;
}
const yp = ot(dp), Mp = ot(/\s/);
function ot(e) {
  return t;
  function t(n) {
    return n !== null && e.test(String.fromCharCode(n));
  }
}
function pe(e, t, n, r) {
  const i = r ? r - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return a;
  function a(s) {
    return ie(s) ? (e.enter(n), l(s)) : t(s);
  }
  function l(s) {
    return ie(s) && o++ < i ? (e.consume(s), l) : (e.exit(n), t(s));
  }
}
const bp = {
  tokenize: xp
};
function xp(e) {
  const t = e.attempt(
    this.parser.constructs.contentInitial,
    r,
    i
  );
  let n;
  return t;
  function r(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), pe(e, t, "linePrefix");
  }
  function i(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const s = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = s), n = s, a(l);
  }
  function a(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return G(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), a);
  }
}
const wp = {
  tokenize: vp
}, Ji = {
  tokenize: Tp
};
function vp(e) {
  const t = this, n = [];
  let r = 0, i, o, a;
  return l;
  function l(E) {
    if (r < n.length) {
      const _ = n[r];
      return t.containerState = _[1], e.attempt(
        _[0].continuation,
        s,
        u
      )(E);
    }
    return u(E);
  }
  function s(E) {
    if (r++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, i && z();
      const _ = t.events.length;
      let U = _, b;
      for (; U--; )
        if (t.events[U][0] === "exit" && t.events[U][1].type === "chunkFlow") {
          b = t.events[U][1].end;
          break;
        }
      M(r);
      let L = _;
      for (; L < t.events.length; )
        t.events[L][1].end = Object.assign({}, b), L++;
      return Ge(
        t.events,
        U + 1,
        0,
        t.events.slice(_)
      ), t.events.length = L, u(E);
    }
    return l(E);
  }
  function u(E) {
    if (r === n.length) {
      if (!i)
        return m(E);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return T(E);
      t.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(
      Ji,
      c,
      p
    )(E);
  }
  function c(E) {
    return i && z(), M(r), m(E);
  }
  function p(E) {
    return t.parser.lazy[t.now().line] = r !== n.length, a = t.now().offset, T(E);
  }
  function m(E) {
    return t.containerState = {}, e.attempt(
      Ji,
      f,
      T
    )(E);
  }
  function f(E) {
    return r++, n.push([t.currentConstruct, t.containerState]), m(E);
  }
  function T(E) {
    if (E === null) {
      i && z(), M(0), e.consume(E);
      return;
    }
    return i = i || t.parser.flow(t.now()), e.enter("chunkFlow", {
      contentType: "flow",
      previous: o,
      _tokenizer: i
    }), x(E);
  }
  function x(E) {
    if (E === null) {
      k(e.exit("chunkFlow"), !0), M(0), e.consume(E);
      return;
    }
    return G(E) ? (e.consume(E), k(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, l) : (e.consume(E), x);
  }
  function k(E, _) {
    const U = t.sliceStream(E);
    if (_ && U.push(null), E.previous = o, o && (o.next = E), o = E, i.defineSkip(E.start), i.write(U), t.parser.lazy[E.start.line]) {
      let b = i.events.length;
      for (; b--; )
        if (
          // The token starts before the line ending…
          i.events[b][1].start.offset < a && // …and either is not ended yet…
          (!i.events[b][1].end || // …or ends after it.
          i.events[b][1].end.offset > a)
        )
          return;
      const L = t.events.length;
      let $ = L, W, K;
      for (; $--; )
        if (t.events[$][0] === "exit" && t.events[$][1].type === "chunkFlow") {
          if (W) {
            K = t.events[$][1].end;
            break;
          }
          W = !0;
        }
      for (M(r), b = L; b < t.events.length; )
        t.events[b][1].end = Object.assign({}, K), b++;
      Ge(
        t.events,
        $ + 1,
        0,
        t.events.slice(L)
      ), t.events.length = b;
    }
  }
  function M(E) {
    let _ = n.length;
    for (; _-- > E; ) {
      const U = n[_];
      t.containerState = U[1], U[0].exit.call(t, e);
    }
    n.length = E;
  }
  function z() {
    i.write([null]), o = void 0, i = void 0, t.containerState._closeFlow = void 0;
  }
}
function Tp(e, t, n) {
  return pe(
    e,
    e.attempt(this.parser.constructs.document, t, n),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
function eo(e) {
  if (e === null || Ie(e) || Mp(e))
    return 1;
  if (yp(e))
    return 2;
}
function Br(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const o = e[i].resolveAll;
    o && !r.includes(o) && (t = o(t, n), r.push(o));
  }
  return t;
}
const Dr = {
  name: "attention",
  tokenize: Np,
  resolveAll: Dp
};
function Dp(e, t) {
  let n = -1, r, i, o, a, l, s, u, c;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (r = n; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          s = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const p = Object.assign({}, e[r][1].end), m = Object.assign({}, e[n][1].start);
          to(p, -s), to(m, s), a = {
            type: s > 1 ? "strongSequence" : "emphasisSequence",
            start: p,
            end: Object.assign({}, e[r][1].end)
          }, l = {
            type: s > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, e[n][1].start),
            end: m
          }, o = {
            type: s > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, e[r][1].end),
            end: Object.assign({}, e[n][1].start)
          }, i = {
            type: s > 1 ? "strong" : "emphasis",
            start: Object.assign({}, a.start),
            end: Object.assign({}, l.end)
          }, e[r][1].end = Object.assign({}, a.start), e[n][1].start = Object.assign({}, l.end), u = [], e[r][1].end.offset - e[r][1].start.offset && (u = Fe(u, [
            ["enter", e[r][1], t],
            ["exit", e[r][1], t]
          ])), u = Fe(u, [
            ["enter", i, t],
            ["enter", a, t],
            ["exit", a, t],
            ["enter", o, t]
          ]), u = Fe(
            u,
            Br(
              t.parser.constructs.insideSpan.null,
              e.slice(r + 1, n),
              t
            )
          ), u = Fe(u, [
            ["exit", o, t],
            ["enter", l, t],
            ["exit", l, t],
            ["exit", i, t]
          ]), e[n][1].end.offset - e[n][1].start.offset ? (c = 2, u = Fe(u, [
            ["enter", e[n][1], t],
            ["exit", e[n][1], t]
          ])) : c = 0, Ge(e, r - 1, n - r + 3, u), n = r + u.length - c - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function Np(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, i = eo(r);
  let o;
  return a;
  function a(s) {
    return o = s, e.enter("attentionSequence"), l(s);
  }
  function l(s) {
    if (s === o)
      return e.consume(s), l;
    const u = e.exit("attentionSequence"), c = eo(s), p = !c || c === 2 && i || n.includes(s), m = !i || i === 2 && c || n.includes(r);
    return u._open = !!(o === 42 ? p : p && (i || !m)), u._close = !!(o === 42 ? m : m && (c || !p)), t(s);
  }
}
function to(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const Ip = {
  name: "autolink",
  tokenize: kp
};
function kp(e, t, n) {
  let r = 0;
  return i;
  function i(f) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(f), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(f) {
    return Ve(f) ? (e.consume(f), a) : u(f);
  }
  function a(f) {
    return f === 43 || f === 45 || f === 46 || Ae(f) ? (r = 1, l(f)) : u(f);
  }
  function l(f) {
    return f === 58 ? (e.consume(f), r = 0, s) : (f === 43 || f === 45 || f === 46 || Ae(f)) && r++ < 32 ? (e.consume(f), l) : (r = 0, u(f));
  }
  function s(f) {
    return f === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(f), e.exit("autolinkMarker"), e.exit("autolink"), t) : f === null || f === 32 || f === 60 || vr(f) ? n(f) : (e.consume(f), s);
  }
  function u(f) {
    return f === 64 ? (e.consume(f), c) : hp(f) ? (e.consume(f), u) : n(f);
  }
  function c(f) {
    return Ae(f) ? p(f) : n(f);
  }
  function p(f) {
    return f === 46 ? (e.consume(f), r = 0, c) : f === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(f), e.exit("autolinkMarker"), e.exit("autolink"), t) : m(f);
  }
  function m(f) {
    if ((f === 45 || Ae(f)) && r++ < 63) {
      const T = f === 45 ? m : p;
      return e.consume(f), T;
    }
    return n(f);
  }
}
const Dn = {
  tokenize: jp,
  partial: !0
};
function jp(e, t, n) {
  return r;
  function r(o) {
    return ie(o) ? pe(e, i, "linePrefix")(o) : i(o);
  }
  function i(o) {
    return o === null || G(o) ? t(o) : n(o);
  }
}
const ba = {
  name: "blockQuote",
  tokenize: Ep,
  continuation: {
    tokenize: Cp
  },
  exit: Ap
};
function Ep(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    if (a === 62) {
      const l = r.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(a), e.exit("blockQuoteMarker"), o;
    }
    return n(a);
  }
  function o(a) {
    return ie(a) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(a), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(a));
  }
}
function Cp(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return ie(a) ? pe(
      e,
      o,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(a) : o(a);
  }
  function o(a) {
    return e.attempt(ba, t, n)(a);
  }
}
function Ap(e) {
  e.exit("blockQuote");
}
const xa = {
  name: "characterEscape",
  tokenize: Sp
};
function Sp(e, t, n) {
  return r;
  function r(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), i;
  }
  function i(o) {
    return mp(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(o);
  }
}
const no = document.createElement("i");
function Ur(e) {
  const t = "&" + e + ";";
  no.innerHTML = t;
  const n = no.textContent;
  return n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n;
}
const wa = {
  name: "characterReference",
  tokenize: Op
};
function Op(e, t, n) {
  const r = this;
  let i = 0, o, a;
  return l;
  function l(p) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(p), e.exit("characterReferenceMarker"), s;
  }
  function s(p) {
    return p === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(p), e.exit("characterReferenceMarkerNumeric"), u) : (e.enter("characterReferenceValue"), o = 31, a = Ae, c(p));
  }
  function u(p) {
    return p === 88 || p === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(p), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, a = gp, c) : (e.enter("characterReferenceValue"), o = 7, a = Tr, c(p));
  }
  function c(p) {
    if (p === 59 && i) {
      const m = e.exit("characterReferenceValue");
      return a === Ae && !Ur(r.sliceSerialize(m)) ? n(p) : (e.enter("characterReferenceMarker"), e.consume(p), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return a(p) && i++ < o ? (e.consume(p), c) : n(p);
  }
}
const ro = {
  tokenize: Lp,
  partial: !0
}, io = {
  name: "codeFenced",
  tokenize: zp,
  concrete: !0
};
function zp(e, t, n) {
  const r = this, i = {
    tokenize: U,
    partial: !0
  };
  let o = 0, a = 0, l;
  return s;
  function s(b) {
    return u(b);
  }
  function u(b) {
    const L = r.events[r.events.length - 1];
    return o = L && L[1].type === "linePrefix" ? L[2].sliceSerialize(L[1], !0).length : 0, l = b, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), c(b);
  }
  function c(b) {
    return b === l ? (a++, e.consume(b), c) : a < 3 ? n(b) : (e.exit("codeFencedFenceSequence"), ie(b) ? pe(e, p, "whitespace")(b) : p(b));
  }
  function p(b) {
    return b === null || G(b) ? (e.exit("codeFencedFence"), r.interrupt ? t(b) : e.check(ro, x, _)(b)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), m(b));
  }
  function m(b) {
    return b === null || G(b) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), p(b)) : ie(b) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), pe(e, f, "whitespace")(b)) : b === 96 && b === l ? n(b) : (e.consume(b), m);
  }
  function f(b) {
    return b === null || G(b) ? p(b) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), T(b));
  }
  function T(b) {
    return b === null || G(b) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), p(b)) : b === 96 && b === l ? n(b) : (e.consume(b), T);
  }
  function x(b) {
    return e.attempt(i, _, k)(b);
  }
  function k(b) {
    return e.enter("lineEnding"), e.consume(b), e.exit("lineEnding"), M;
  }
  function M(b) {
    return o > 0 && ie(b) ? pe(
      e,
      z,
      "linePrefix",
      o + 1
    )(b) : z(b);
  }
  function z(b) {
    return b === null || G(b) ? e.check(ro, x, _)(b) : (e.enter("codeFlowValue"), E(b));
  }
  function E(b) {
    return b === null || G(b) ? (e.exit("codeFlowValue"), z(b)) : (e.consume(b), E);
  }
  function _(b) {
    return e.exit("codeFenced"), t(b);
  }
  function U(b, L, $) {
    let W = 0;
    return K;
    function K(F) {
      return b.enter("lineEnding"), b.consume(F), b.exit("lineEnding"), A;
    }
    function A(F) {
      return b.enter("codeFencedFence"), ie(F) ? pe(
        b,
        w,
        "linePrefix",
        r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
      )(F) : w(F);
    }
    function w(F) {
      return F === l ? (b.enter("codeFencedFenceSequence"), j(F)) : $(F);
    }
    function j(F) {
      return F === l ? (W++, b.consume(F), j) : W >= a ? (b.exit("codeFencedFenceSequence"), ie(F) ? pe(b, O, "whitespace")(F) : O(F)) : $(F);
    }
    function O(F) {
      return F === null || G(F) ? (b.exit("codeFencedFence"), L(F)) : $(F);
    }
  }
}
function Lp(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return a === null ? n(a) : (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), o);
  }
  function o(a) {
    return r.parser.lazy[r.now().line] ? n(a) : t(a);
  }
}
const rr = {
  name: "codeIndented",
  tokenize: Fp
}, _p = {
  tokenize: Pp,
  partial: !0
};
function Fp(e, t, n) {
  const r = this;
  return i;
  function i(u) {
    return e.enter("codeIndented"), pe(e, o, "linePrefix", 4 + 1)(u);
  }
  function o(u) {
    const c = r.events[r.events.length - 1];
    return c && c[1].type === "linePrefix" && c[2].sliceSerialize(c[1], !0).length >= 4 ? a(u) : n(u);
  }
  function a(u) {
    return u === null ? s(u) : G(u) ? e.attempt(_p, a, s)(u) : (e.enter("codeFlowValue"), l(u));
  }
  function l(u) {
    return u === null || G(u) ? (e.exit("codeFlowValue"), a(u)) : (e.consume(u), l);
  }
  function s(u) {
    return e.exit("codeIndented"), t(u);
  }
}
function Pp(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return r.parser.lazy[r.now().line] ? n(a) : G(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), i) : pe(e, o, "linePrefix", 4 + 1)(a);
  }
  function o(a) {
    const l = r.events[r.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? t(a) : G(a) ? i(a) : n(a);
  }
}
const Rp = {
  name: "codeText",
  tokenize: Qp,
  resolve: Bp,
  previous: Up
};
function Bp(e) {
  let t = e.length - 4, n = 3, r, i;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    i === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (i = r) : (r === t || e[r][1].type === "lineEnding") && (e[i][1].type = "codeTextData", r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), t -= r - i - 2, r = i + 2), i = void 0);
  return e;
}
function Up(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function Qp(e, t, n) {
  let r = 0, i, o;
  return a;
  function a(p) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(p);
  }
  function l(p) {
    return p === 96 ? (e.consume(p), r++, l) : (e.exit("codeTextSequence"), s(p));
  }
  function s(p) {
    return p === null ? n(p) : p === 32 ? (e.enter("space"), e.consume(p), e.exit("space"), s) : p === 96 ? (o = e.enter("codeTextSequence"), i = 0, c(p)) : G(p) ? (e.enter("lineEnding"), e.consume(p), e.exit("lineEnding"), s) : (e.enter("codeTextData"), u(p));
  }
  function u(p) {
    return p === null || p === 32 || p === 96 || G(p) ? (e.exit("codeTextData"), s(p)) : (e.consume(p), u);
  }
  function c(p) {
    return p === 96 ? (e.consume(p), i++, c) : i === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(p)) : (o.type = "codeTextData", u(p));
  }
}
function va(e) {
  const t = {};
  let n = -1, r, i, o, a, l, s, u;
  for (; ++n < e.length; ) {
    for (; n in t; )
      n = t[n];
    if (r = e[n], n && r[1].type === "chunkFlow" && e[n - 1][1].type === "listItemPrefix" && (s = r[1]._tokenizer.events, o = 0, o < s.length && s[o][1].type === "lineEndingBlank" && (o += 2), o < s.length && s[o][1].type === "content"))
      for (; ++o < s.length && s[o][1].type !== "content"; )
        s[o][1].type === "chunkText" && (s[o][1]._isInFirstContentOfListItem = !0, o++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(t, Yp(e, n)), n = t[n], u = !0);
    else if (r[1]._container) {
      for (o = n, i = void 0; o-- && (a = e[o], a[1].type === "lineEnding" || a[1].type === "lineEndingBlank"); )
        a[0] === "enter" && (i && (e[i][1].type = "lineEndingBlank"), a[1].type = "lineEnding", i = o);
      i && (r[1].end = Object.assign({}, e[i][1].start), l = e.slice(i, n), l.unshift(r), Ge(e, i, n - i + 1, l));
    }
  }
  return !u;
}
function Yp(e, t) {
  const n = e[t][1], r = e[t][2];
  let i = t - 1;
  const o = [], a = n._tokenizer || r.parser[n.contentType](n.start), l = a.events, s = [], u = {};
  let c, p, m = -1, f = n, T = 0, x = 0;
  const k = [x];
  for (; f; ) {
    for (; e[++i][1] !== f; )
      ;
    o.push(i), f._tokenizer || (c = r.sliceStream(f), f.next || c.push(null), p && a.defineSkip(f.start), f._isInFirstContentOfListItem && (a._gfmTasklistFirstContentOfListItem = !0), a.write(c), f._isInFirstContentOfListItem && (a._gfmTasklistFirstContentOfListItem = void 0)), p = f, f = f.next;
  }
  for (f = n; ++m < l.length; )
    // Find a void token that includes a break.
    l[m][0] === "exit" && l[m - 1][0] === "enter" && l[m][1].type === l[m - 1][1].type && l[m][1].start.line !== l[m][1].end.line && (x = m + 1, k.push(x), f._tokenizer = void 0, f.previous = void 0, f = f.next);
  for (a.events = [], f ? (f._tokenizer = void 0, f.previous = void 0) : k.pop(), m = k.length; m--; ) {
    const M = l.slice(k[m], k[m + 1]), z = o.pop();
    s.unshift([z, z + M.length - 1]), Ge(e, z, 2, M);
  }
  for (m = -1; ++m < s.length; )
    u[T + s[m][0]] = T + s[m][1], T += s[m][1] - s[m][0] - 1;
  return u;
}
const Hp = {
  tokenize: Vp,
  resolve: qp
}, $p = {
  tokenize: Wp,
  partial: !0
};
function qp(e) {
  return va(e), e;
}
function Vp(e, t) {
  let n;
  return r;
  function r(l) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), i(l);
  }
  function i(l) {
    return l === null ? o(l) : G(l) ? e.check(
      $p,
      a,
      o
    )(l) : (e.consume(l), i);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), t(l);
  }
  function a(l) {
    return e.consume(l), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, i;
  }
}
function Wp(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), pe(e, o, "linePrefix");
  }
  function o(a) {
    if (a === null || G(a))
      return n(a);
    const l = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? t(a) : e.interrupt(r.parser.constructs.flow, n, t)(a);
  }
}
function Ta(e, t, n, r, i, o, a, l, s) {
  const u = s || Number.POSITIVE_INFINITY;
  let c = 0;
  return p;
  function p(M) {
    return M === 60 ? (e.enter(r), e.enter(i), e.enter(o), e.consume(M), e.exit(o), m) : M === null || M === 32 || M === 41 || vr(M) ? n(M) : (e.enter(r), e.enter(a), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), x(M));
  }
  function m(M) {
    return M === 62 ? (e.enter(o), e.consume(M), e.exit(o), e.exit(i), e.exit(r), t) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), f(M));
  }
  function f(M) {
    return M === 62 ? (e.exit("chunkString"), e.exit(l), m(M)) : M === null || M === 60 || G(M) ? n(M) : (e.consume(M), M === 92 ? T : f);
  }
  function T(M) {
    return M === 60 || M === 62 || M === 92 ? (e.consume(M), f) : f(M);
  }
  function x(M) {
    return !c && (M === null || M === 41 || Ie(M)) ? (e.exit("chunkString"), e.exit(l), e.exit(a), e.exit(r), t(M)) : c < u && M === 40 ? (e.consume(M), c++, x) : M === 41 ? (e.consume(M), c--, x) : M === null || M === 32 || M === 40 || vr(M) ? n(M) : (e.consume(M), M === 92 ? k : x);
  }
  function k(M) {
    return M === 40 || M === 41 || M === 92 ? (e.consume(M), x) : x(M);
  }
}
function Da(e, t, n, r, i, o) {
  const a = this;
  let l = 0, s;
  return u;
  function u(f) {
    return e.enter(r), e.enter(i), e.consume(f), e.exit(i), e.enter(o), c;
  }
  function c(f) {
    return l > 999 || f === null || f === 91 || f === 93 && !s || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    f === 94 && !l && "_hiddenFootnoteSupport" in a.parser.constructs ? n(f) : f === 93 ? (e.exit(o), e.enter(i), e.consume(f), e.exit(i), e.exit(r), t) : G(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), c) : (e.enter("chunkString", {
      contentType: "string"
    }), p(f));
  }
  function p(f) {
    return f === null || f === 91 || f === 93 || G(f) || l++ > 999 ? (e.exit("chunkString"), c(f)) : (e.consume(f), s || (s = !ie(f)), f === 92 ? m : p);
  }
  function m(f) {
    return f === 91 || f === 92 || f === 93 ? (e.consume(f), l++, p) : p(f);
  }
}
function Na(e, t, n, r, i, o) {
  let a;
  return l;
  function l(m) {
    return m === 34 || m === 39 || m === 40 ? (e.enter(r), e.enter(i), e.consume(m), e.exit(i), a = m === 40 ? 41 : m, s) : n(m);
  }
  function s(m) {
    return m === a ? (e.enter(i), e.consume(m), e.exit(i), e.exit(r), t) : (e.enter(o), u(m));
  }
  function u(m) {
    return m === a ? (e.exit(o), s(a)) : m === null ? n(m) : G(m) ? (e.enter("lineEnding"), e.consume(m), e.exit("lineEnding"), pe(e, u, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), c(m));
  }
  function c(m) {
    return m === a || m === null || G(m) ? (e.exit("chunkString"), u(m)) : (e.consume(m), m === 92 ? p : c);
  }
  function p(m) {
    return m === a || m === 92 ? (e.consume(m), c) : c(m);
  }
}
function Ht(e, t) {
  let n;
  return r;
  function r(i) {
    return G(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), n = !0, r) : ie(i) ? pe(
      e,
      r,
      n ? "linePrefix" : "lineSuffix"
    )(i) : t(i);
  }
}
function wt(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Gp = {
  name: "definition",
  tokenize: Xp
}, Zp = {
  tokenize: Kp,
  partial: !0
};
function Xp(e, t, n) {
  const r = this;
  let i;
  return o;
  function o(f) {
    return e.enter("definition"), a(f);
  }
  function a(f) {
    return Da.call(
      r,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(f);
  }
  function l(f) {
    return i = wt(
      r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
    ), f === 58 ? (e.enter("definitionMarker"), e.consume(f), e.exit("definitionMarker"), s) : n(f);
  }
  function s(f) {
    return Ie(f) ? Ht(e, u)(f) : u(f);
  }
  function u(f) {
    return Ta(
      e,
      c,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(f);
  }
  function c(f) {
    return e.attempt(Zp, p, p)(f);
  }
  function p(f) {
    return ie(f) ? pe(e, m, "whitespace")(f) : m(f);
  }
  function m(f) {
    return f === null || G(f) ? (e.exit("definition"), r.parser.defined.push(i), t(f)) : n(f);
  }
}
function Kp(e, t, n) {
  return r;
  function r(l) {
    return Ie(l) ? Ht(e, i)(l) : n(l);
  }
  function i(l) {
    return Na(
      e,
      o,
      n,
      "definitionTitle",
      "definitionTitleMarker",
      "definitionTitleString"
    )(l);
  }
  function o(l) {
    return ie(l) ? pe(e, a, "whitespace")(l) : a(l);
  }
  function a(l) {
    return l === null || G(l) ? t(l) : n(l);
  }
}
const Jp = {
  name: "hardBreakEscape",
  tokenize: ef
};
function ef(e, t, n) {
  return r;
  function r(o) {
    return e.enter("hardBreakEscape"), e.consume(o), i;
  }
  function i(o) {
    return G(o) ? (e.exit("hardBreakEscape"), t(o)) : n(o);
  }
}
const tf = {
  name: "headingAtx",
  tokenize: rf,
  resolve: nf
};
function nf(e, t) {
  let n = e.length - 2, r = 3, i, o;
  return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (i = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[n][1].end
  }, o = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, Ge(e, r, n - r + 1, [
    ["enter", i, t],
    ["enter", o, t],
    ["exit", o, t],
    ["exit", i, t]
  ])), e;
}
function rf(e, t, n) {
  let r = 0;
  return i;
  function i(c) {
    return e.enter("atxHeading"), o(c);
  }
  function o(c) {
    return e.enter("atxHeadingSequence"), a(c);
  }
  function a(c) {
    return c === 35 && r++ < 6 ? (e.consume(c), a) : c === null || Ie(c) ? (e.exit("atxHeadingSequence"), l(c)) : n(c);
  }
  function l(c) {
    return c === 35 ? (e.enter("atxHeadingSequence"), s(c)) : c === null || G(c) ? (e.exit("atxHeading"), t(c)) : ie(c) ? pe(e, l, "whitespace")(c) : (e.enter("atxHeadingText"), u(c));
  }
  function s(c) {
    return c === 35 ? (e.consume(c), s) : (e.exit("atxHeadingSequence"), l(c));
  }
  function u(c) {
    return c === null || c === 35 || Ie(c) ? (e.exit("atxHeadingText"), l(c)) : (e.consume(c), u);
  }
}
const of = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], oo = ["pre", "script", "style", "textarea"], af = {
  name: "htmlFlow",
  tokenize: cf,
  resolveTo: uf,
  concrete: !0
}, lf = {
  tokenize: ff,
  partial: !0
}, sf = {
  tokenize: pf,
  partial: !0
};
function uf(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function cf(e, t, n) {
  const r = this;
  let i, o, a, l, s;
  return u;
  function u(h) {
    return c(h);
  }
  function c(h) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(h), p;
  }
  function p(h) {
    return h === 33 ? (e.consume(h), m) : h === 47 ? (e.consume(h), o = !0, x) : h === 63 ? (e.consume(h), i = 3, r.interrupt ? t : g) : Ve(h) ? (e.consume(h), a = String.fromCharCode(h), k) : n(h);
  }
  function m(h) {
    return h === 45 ? (e.consume(h), i = 2, f) : h === 91 ? (e.consume(h), i = 5, l = 0, T) : Ve(h) ? (e.consume(h), i = 4, r.interrupt ? t : g) : n(h);
  }
  function f(h) {
    return h === 45 ? (e.consume(h), r.interrupt ? t : g) : n(h);
  }
  function T(h) {
    const ge = "CDATA[";
    return h === ge.charCodeAt(l++) ? (e.consume(h), l === ge.length ? r.interrupt ? t : w : T) : n(h);
  }
  function x(h) {
    return Ve(h) ? (e.consume(h), a = String.fromCharCode(h), k) : n(h);
  }
  function k(h) {
    if (h === null || h === 47 || h === 62 || Ie(h)) {
      const ge = h === 47, ke = a.toLowerCase();
      return !ge && !o && oo.includes(ke) ? (i = 1, r.interrupt ? t(h) : w(h)) : of.includes(a.toLowerCase()) ? (i = 6, ge ? (e.consume(h), M) : r.interrupt ? t(h) : w(h)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(h) : o ? z(h) : E(h));
    }
    return h === 45 || Ae(h) ? (e.consume(h), a += String.fromCharCode(h), k) : n(h);
  }
  function M(h) {
    return h === 62 ? (e.consume(h), r.interrupt ? t : w) : n(h);
  }
  function z(h) {
    return ie(h) ? (e.consume(h), z) : K(h);
  }
  function E(h) {
    return h === 47 ? (e.consume(h), K) : h === 58 || h === 95 || Ve(h) ? (e.consume(h), _) : ie(h) ? (e.consume(h), E) : K(h);
  }
  function _(h) {
    return h === 45 || h === 46 || h === 58 || h === 95 || Ae(h) ? (e.consume(h), _) : U(h);
  }
  function U(h) {
    return h === 61 ? (e.consume(h), b) : ie(h) ? (e.consume(h), U) : E(h);
  }
  function b(h) {
    return h === null || h === 60 || h === 61 || h === 62 || h === 96 ? n(h) : h === 34 || h === 39 ? (e.consume(h), s = h, L) : ie(h) ? (e.consume(h), b) : $(h);
  }
  function L(h) {
    return h === s ? (e.consume(h), s = null, W) : h === null || G(h) ? n(h) : (e.consume(h), L);
  }
  function $(h) {
    return h === null || h === 34 || h === 39 || h === 47 || h === 60 || h === 61 || h === 62 || h === 96 || Ie(h) ? U(h) : (e.consume(h), $);
  }
  function W(h) {
    return h === 47 || h === 62 || ie(h) ? E(h) : n(h);
  }
  function K(h) {
    return h === 62 ? (e.consume(h), A) : n(h);
  }
  function A(h) {
    return h === null || G(h) ? w(h) : ie(h) ? (e.consume(h), A) : n(h);
  }
  function w(h) {
    return h === 45 && i === 2 ? (e.consume(h), Q) : h === 60 && i === 1 ? (e.consume(h), V) : h === 62 && i === 4 ? (e.consume(h), he) : h === 63 && i === 3 ? (e.consume(h), g) : h === 93 && i === 5 ? (e.consume(h), X) : G(h) && (i === 6 || i === 7) ? (e.exit("htmlFlowData"), e.check(
      lf,
      Me,
      j
    )(h)) : h === null || G(h) ? (e.exit("htmlFlowData"), j(h)) : (e.consume(h), w);
  }
  function j(h) {
    return e.check(
      sf,
      O,
      Me
    )(h);
  }
  function O(h) {
    return e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), F;
  }
  function F(h) {
    return h === null || G(h) ? j(h) : (e.enter("htmlFlowData"), w(h));
  }
  function Q(h) {
    return h === 45 ? (e.consume(h), g) : w(h);
  }
  function V(h) {
    return h === 47 ? (e.consume(h), a = "", q) : w(h);
  }
  function q(h) {
    if (h === 62) {
      const ge = a.toLowerCase();
      return oo.includes(ge) ? (e.consume(h), he) : w(h);
    }
    return Ve(h) && a.length < 8 ? (e.consume(h), a += String.fromCharCode(h), q) : w(h);
  }
  function X(h) {
    return h === 93 ? (e.consume(h), g) : w(h);
  }
  function g(h) {
    return h === 62 ? (e.consume(h), he) : h === 45 && i === 2 ? (e.consume(h), g) : w(h);
  }
  function he(h) {
    return h === null || G(h) ? (e.exit("htmlFlowData"), Me(h)) : (e.consume(h), he);
  }
  function Me(h) {
    return e.exit("htmlFlow"), t(h);
  }
}
function pf(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return G(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), o) : n(a);
  }
  function o(a) {
    return r.parser.lazy[r.now().line] ? n(a) : t(a);
  }
}
function ff(e, t, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), e.attempt(Dn, t, n);
  }
}
const df = {
  name: "htmlText",
  tokenize: hf
};
function hf(e, t, n) {
  const r = this;
  let i, o, a;
  return l;
  function l(g) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(g), s;
  }
  function s(g) {
    return g === 33 ? (e.consume(g), u) : g === 47 ? (e.consume(g), U) : g === 63 ? (e.consume(g), E) : Ve(g) ? (e.consume(g), $) : n(g);
  }
  function u(g) {
    return g === 45 ? (e.consume(g), c) : g === 91 ? (e.consume(g), o = 0, T) : Ve(g) ? (e.consume(g), z) : n(g);
  }
  function c(g) {
    return g === 45 ? (e.consume(g), f) : n(g);
  }
  function p(g) {
    return g === null ? n(g) : g === 45 ? (e.consume(g), m) : G(g) ? (a = p, V(g)) : (e.consume(g), p);
  }
  function m(g) {
    return g === 45 ? (e.consume(g), f) : p(g);
  }
  function f(g) {
    return g === 62 ? Q(g) : g === 45 ? m(g) : p(g);
  }
  function T(g) {
    const he = "CDATA[";
    return g === he.charCodeAt(o++) ? (e.consume(g), o === he.length ? x : T) : n(g);
  }
  function x(g) {
    return g === null ? n(g) : g === 93 ? (e.consume(g), k) : G(g) ? (a = x, V(g)) : (e.consume(g), x);
  }
  function k(g) {
    return g === 93 ? (e.consume(g), M) : x(g);
  }
  function M(g) {
    return g === 62 ? Q(g) : g === 93 ? (e.consume(g), M) : x(g);
  }
  function z(g) {
    return g === null || g === 62 ? Q(g) : G(g) ? (a = z, V(g)) : (e.consume(g), z);
  }
  function E(g) {
    return g === null ? n(g) : g === 63 ? (e.consume(g), _) : G(g) ? (a = E, V(g)) : (e.consume(g), E);
  }
  function _(g) {
    return g === 62 ? Q(g) : E(g);
  }
  function U(g) {
    return Ve(g) ? (e.consume(g), b) : n(g);
  }
  function b(g) {
    return g === 45 || Ae(g) ? (e.consume(g), b) : L(g);
  }
  function L(g) {
    return G(g) ? (a = L, V(g)) : ie(g) ? (e.consume(g), L) : Q(g);
  }
  function $(g) {
    return g === 45 || Ae(g) ? (e.consume(g), $) : g === 47 || g === 62 || Ie(g) ? W(g) : n(g);
  }
  function W(g) {
    return g === 47 ? (e.consume(g), Q) : g === 58 || g === 95 || Ve(g) ? (e.consume(g), K) : G(g) ? (a = W, V(g)) : ie(g) ? (e.consume(g), W) : Q(g);
  }
  function K(g) {
    return g === 45 || g === 46 || g === 58 || g === 95 || Ae(g) ? (e.consume(g), K) : A(g);
  }
  function A(g) {
    return g === 61 ? (e.consume(g), w) : G(g) ? (a = A, V(g)) : ie(g) ? (e.consume(g), A) : W(g);
  }
  function w(g) {
    return g === null || g === 60 || g === 61 || g === 62 || g === 96 ? n(g) : g === 34 || g === 39 ? (e.consume(g), i = g, j) : G(g) ? (a = w, V(g)) : ie(g) ? (e.consume(g), w) : (e.consume(g), O);
  }
  function j(g) {
    return g === i ? (e.consume(g), i = void 0, F) : g === null ? n(g) : G(g) ? (a = j, V(g)) : (e.consume(g), j);
  }
  function O(g) {
    return g === null || g === 34 || g === 39 || g === 60 || g === 61 || g === 96 ? n(g) : g === 47 || g === 62 || Ie(g) ? W(g) : (e.consume(g), O);
  }
  function F(g) {
    return g === 47 || g === 62 || Ie(g) ? W(g) : n(g);
  }
  function Q(g) {
    return g === 62 ? (e.consume(g), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(g);
  }
  function V(g) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(g), e.exit("lineEnding"), q;
  }
  function q(g) {
    return ie(g) ? pe(
      e,
      X,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(g) : X(g);
  }
  function X(g) {
    return e.enter("htmlTextData"), a(g);
  }
}
const Qr = {
  name: "labelEnd",
  tokenize: xf,
  resolveTo: bf,
  resolveAll: Mf
}, gf = {
  tokenize: wf
}, mf = {
  tokenize: vf
}, yf = {
  tokenize: Tf
};
function Mf(e) {
  let t = -1;
  for (; ++t < e.length; ) {
    const n = e[t][1];
    (n.type === "labelImage" || n.type === "labelLink" || n.type === "labelEnd") && (e.splice(t + 1, n.type === "labelImage" ? 4 : 2), n.type = "data", t++);
  }
  return e;
}
function bf(e, t) {
  let n = e.length, r = 0, i, o, a, l;
  for (; n--; )
    if (i = e[n][1], o) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive)
        break;
      e[n][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (a) {
      if (e[n][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (o = n, i.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else
      i.type === "labelEnd" && (a = n);
  const s = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: Object.assign({}, e[o][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, u = {
    type: "label",
    start: Object.assign({}, e[o][1].start),
    end: Object.assign({}, e[a][1].end)
  }, c = {
    type: "labelText",
    start: Object.assign({}, e[o + r + 2][1].end),
    end: Object.assign({}, e[a - 2][1].start)
  };
  return l = [
    ["enter", s, t],
    ["enter", u, t]
  ], l = Fe(l, e.slice(o + 1, o + r + 3)), l = Fe(l, [["enter", c, t]]), l = Fe(
    l,
    Br(
      t.parser.constructs.insideSpan.null,
      e.slice(o + r + 4, a - 3),
      t
    )
  ), l = Fe(l, [
    ["exit", c, t],
    e[a - 2],
    e[a - 1],
    ["exit", u, t]
  ]), l = Fe(l, e.slice(a + 1)), l = Fe(l, [["exit", s, t]]), Ge(e, o, e.length, l), e;
}
function xf(e, t, n) {
  const r = this;
  let i = r.events.length, o, a;
  for (; i--; )
    if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
      o = r.events[i][1];
      break;
    }
  return l;
  function l(m) {
    return o ? o._inactive ? p(m) : (a = r.parser.defined.includes(
      wt(
        r.sliceSerialize({
          start: o.end,
          end: r.now()
        })
      )
    ), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(m), e.exit("labelMarker"), e.exit("labelEnd"), s) : n(m);
  }
  function s(m) {
    return m === 40 ? e.attempt(
      gf,
      c,
      a ? c : p
    )(m) : m === 91 ? e.attempt(
      mf,
      c,
      a ? u : p
    )(m) : a ? c(m) : p(m);
  }
  function u(m) {
    return e.attempt(
      yf,
      c,
      p
    )(m);
  }
  function c(m) {
    return t(m);
  }
  function p(m) {
    return o._balanced = !0, n(m);
  }
}
function wf(e, t, n) {
  return r;
  function r(p) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(p), e.exit("resourceMarker"), i;
  }
  function i(p) {
    return Ie(p) ? Ht(e, o)(p) : o(p);
  }
  function o(p) {
    return p === 41 ? c(p) : Ta(
      e,
      a,
      l,
      "resourceDestination",
      "resourceDestinationLiteral",
      "resourceDestinationLiteralMarker",
      "resourceDestinationRaw",
      "resourceDestinationString",
      32
    )(p);
  }
  function a(p) {
    return Ie(p) ? Ht(e, s)(p) : c(p);
  }
  function l(p) {
    return n(p);
  }
  function s(p) {
    return p === 34 || p === 39 || p === 40 ? Na(
      e,
      u,
      n,
      "resourceTitle",
      "resourceTitleMarker",
      "resourceTitleString"
    )(p) : c(p);
  }
  function u(p) {
    return Ie(p) ? Ht(e, c)(p) : c(p);
  }
  function c(p) {
    return p === 41 ? (e.enter("resourceMarker"), e.consume(p), e.exit("resourceMarker"), e.exit("resource"), t) : n(p);
  }
}
function vf(e, t, n) {
  const r = this;
  return i;
  function i(l) {
    return Da.call(
      r,
      e,
      o,
      a,
      "reference",
      "referenceMarker",
      "referenceString"
    )(l);
  }
  function o(l) {
    return r.parser.defined.includes(
      wt(
        r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
      )
    ) ? t(l) : n(l);
  }
  function a(l) {
    return n(l);
  }
}
function Tf(e, t, n) {
  return r;
  function r(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), i;
  }
  function i(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), t) : n(o);
  }
}
const Df = {
  name: "labelStartImage",
  tokenize: Nf,
  resolveAll: Qr.resolveAll
};
function Nf(e, t, n) {
  const r = this;
  return i;
  function i(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), a) : n(l);
  }
  function a(l) {
    return l === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(l) : t(l);
  }
}
const If = {
  name: "labelStartLink",
  tokenize: kf,
  resolveAll: Qr.resolveAll
};
function kf(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(a), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(a) {
    return a === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(a) : t(a);
  }
}
const ir = {
  name: "lineEnding",
  tokenize: jf
};
function jf(e, t) {
  return n;
  function n(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), pe(e, t, "linePrefix");
  }
}
const fn = {
  name: "thematicBreak",
  tokenize: Ef
};
function Ef(e, t, n) {
  let r = 0, i;
  return o;
  function o(u) {
    return e.enter("thematicBreak"), a(u);
  }
  function a(u) {
    return i = u, l(u);
  }
  function l(u) {
    return u === i ? (e.enter("thematicBreakSequence"), s(u)) : r >= 3 && (u === null || G(u)) ? (e.exit("thematicBreak"), t(u)) : n(u);
  }
  function s(u) {
    return u === i ? (e.consume(u), r++, s) : (e.exit("thematicBreakSequence"), ie(u) ? pe(e, l, "whitespace")(u) : l(u));
  }
}
const De = {
  name: "list",
  tokenize: Sf,
  continuation: {
    tokenize: Of
  },
  exit: Lf
}, Cf = {
  tokenize: _f,
  partial: !0
}, Af = {
  tokenize: zf,
  partial: !0
};
function Sf(e, t, n) {
  const r = this, i = r.events[r.events.length - 1];
  let o = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, a = 0;
  return l;
  function l(f) {
    const T = r.containerState.type || (f === 42 || f === 43 || f === 45 ? "listUnordered" : "listOrdered");
    if (T === "listUnordered" ? !r.containerState.marker || f === r.containerState.marker : Tr(f)) {
      if (r.containerState.type || (r.containerState.type = T, e.enter(T, {
        _container: !0
      })), T === "listUnordered")
        return e.enter("listItemPrefix"), f === 42 || f === 45 ? e.check(fn, n, u)(f) : u(f);
      if (!r.interrupt || f === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), s(f);
    }
    return n(f);
  }
  function s(f) {
    return Tr(f) && ++a < 10 ? (e.consume(f), s) : (!r.interrupt || a < 2) && (r.containerState.marker ? f === r.containerState.marker : f === 41 || f === 46) ? (e.exit("listItemValue"), u(f)) : n(f);
  }
  function u(f) {
    return e.enter("listItemMarker"), e.consume(f), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || f, e.check(
      Dn,
      // Can’t be empty when interrupting.
      r.interrupt ? n : c,
      e.attempt(
        Cf,
        m,
        p
      )
    );
  }
  function c(f) {
    return r.containerState.initialBlankLine = !0, o++, m(f);
  }
  function p(f) {
    return ie(f) ? (e.enter("listItemPrefixWhitespace"), e.consume(f), e.exit("listItemPrefixWhitespace"), m) : n(f);
  }
  function m(f) {
    return r.containerState.size = o + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(f);
  }
}
function Of(e, t, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(Dn, i, o);
  function i(l) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, pe(
      e,
      t,
      "listItemIndent",
      r.containerState.size + 1
    )(l);
  }
  function o(l) {
    return r.containerState.furtherBlankLines || !ie(l) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, a(l)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(Af, t, a)(l));
  }
  function a(l) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, pe(
      e,
      e.attempt(De, t, n),
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(l);
  }
}
function zf(e, t, n) {
  const r = this;
  return pe(
    e,
    i,
    "listItemIndent",
    r.containerState.size + 1
  );
  function i(o) {
    const a = r.events[r.events.length - 1];
    return a && a[1].type === "listItemIndent" && a[2].sliceSerialize(a[1], !0).length === r.containerState.size ? t(o) : n(o);
  }
}
function Lf(e) {
  e.exit(this.containerState.type);
}
function _f(e, t, n) {
  const r = this;
  return pe(
    e,
    i,
    "listItemPrefixWhitespace",
    r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4 + 1
  );
  function i(o) {
    const a = r.events[r.events.length - 1];
    return !ie(o) && a && a[1].type === "listItemPrefixWhitespace" ? t(o) : n(o);
  }
}
const ao = {
  name: "setextUnderline",
  tokenize: Pf,
  resolveTo: Ff
};
function Ff(e, t) {
  let n = e.length, r, i, o;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        r = n;
        break;
      }
      e[n][1].type === "paragraph" && (i = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !o && e[n][1].type === "definition" && (o = n);
  const a = {
    type: "setextHeading",
    start: Object.assign({}, e[i][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  };
  return e[i][1].type = "setextHeadingText", o ? (e.splice(i, 0, ["enter", a, t]), e.splice(o + 1, 0, ["exit", e[r][1], t]), e[r][1].end = Object.assign({}, e[o][1].end)) : e[r][1] = a, e.push(["exit", a, t]), e;
}
function Pf(e, t, n) {
  const r = this;
  let i;
  return o;
  function o(u) {
    let c = r.events.length, p;
    for (; c--; )
      if (r.events[c][1].type !== "lineEnding" && r.events[c][1].type !== "linePrefix" && r.events[c][1].type !== "content") {
        p = r.events[c][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || p) ? (e.enter("setextHeadingLine"), i = u, a(u)) : n(u);
  }
  function a(u) {
    return e.enter("setextHeadingLineSequence"), l(u);
  }
  function l(u) {
    return u === i ? (e.consume(u), l) : (e.exit("setextHeadingLineSequence"), ie(u) ? pe(e, s, "lineSuffix")(u) : s(u));
  }
  function s(u) {
    return u === null || G(u) ? (e.exit("setextHeadingLine"), t(u)) : n(u);
  }
}
const Rf = {
  tokenize: Bf
};
function Bf(e) {
  const t = this, n = e.attempt(
    // Try to parse a blank line.
    Dn,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(
      this.parser.constructs.flowInitial,
      i,
      pe(
        e,
        e.attempt(
          this.parser.constructs.flow,
          i,
          e.attempt(Hp, i)
        ),
        "linePrefix"
      )
    )
  );
  return n;
  function r(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const Uf = {
  resolveAll: ka()
}, Qf = Ia("string"), Yf = Ia("text");
function Ia(e) {
  return {
    tokenize: t,
    resolveAll: ka(
      e === "text" ? Hf : void 0
    )
  };
  function t(n) {
    const r = this, i = this.parser.constructs[e], o = n.attempt(i, a, l);
    return a;
    function a(c) {
      return u(c) ? o(c) : l(c);
    }
    function l(c) {
      if (c === null) {
        n.consume(c);
        return;
      }
      return n.enter("data"), n.consume(c), s;
    }
    function s(c) {
      return u(c) ? (n.exit("data"), o(c)) : (n.consume(c), s);
    }
    function u(c) {
      if (c === null)
        return !0;
      const p = i[c];
      let m = -1;
      if (p)
        for (; ++m < p.length; ) {
          const f = p[m];
          if (!f.previous || f.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function ka(e) {
  return t;
  function t(n, r) {
    let i = -1, o;
    for (; ++i <= n.length; )
      o === void 0 ? n[i] && n[i][1].type === "data" && (o = i, i++) : (!n[i] || n[i][1].type !== "data") && (i !== o + 2 && (n[o][1].end = n[i - 1][1].end, n.splice(o + 2, i - o - 2), i = o + 2), o = void 0);
    return e ? e(n, r) : n;
  }
}
function Hf(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const r = e[n - 1][1], i = t.sliceStream(r);
      let o = i.length, a = -1, l = 0, s;
      for (; o--; ) {
        const u = i[o];
        if (typeof u == "string") {
          for (a = u.length; u.charCodeAt(a - 1) === 32; )
            l++, a--;
          if (a)
            break;
          a = -1;
        } else if (u === -2)
          s = !0, l++;
        else if (u !== -1) {
          o++;
          break;
        }
      }
      if (l) {
        const u = {
          type: n === e.length || s || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: r.end.line,
            column: r.end.column - l,
            offset: r.end.offset - l,
            _index: r.start._index + o,
            _bufferIndex: o ? a : r.start._bufferIndex + a
          },
          end: Object.assign({}, r.end)
        };
        r.end = Object.assign({}, u.start), r.start.offset === r.end.offset ? Object.assign(r, u) : (e.splice(
          n,
          0,
          ["enter", u, t],
          ["exit", u, t]
        ), n += 2);
      }
      n++;
    }
  return e;
}
function $f(e, t, n) {
  let r = Object.assign(
    n ? Object.assign({}, n) : {
      line: 1,
      column: 1,
      offset: 0
    },
    {
      _index: 0,
      _bufferIndex: -1
    }
  );
  const i = {}, o = [];
  let a = [], l = [];
  const s = {
    consume: z,
    enter: E,
    exit: _,
    attempt: L(U),
    check: L(b),
    interrupt: L(b, {
      interrupt: !0
    })
  }, u = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser: e,
    sliceStream: f,
    sliceSerialize: m,
    now: T,
    defineSkip: x,
    write: p
  };
  let c = t.tokenize.call(u, s);
  return t.resolveAll && o.push(t), u;
  function p(A) {
    return a = Fe(a, A), k(), a[a.length - 1] !== null ? [] : ($(t, 0), u.events = Br(o, u.events, u), u.events);
  }
  function m(A, w) {
    return Vf(f(A), w);
  }
  function f(A) {
    return qf(a, A);
  }
  function T() {
    const { line: A, column: w, offset: j, _index: O, _bufferIndex: F } = r;
    return {
      line: A,
      column: w,
      offset: j,
      _index: O,
      _bufferIndex: F
    };
  }
  function x(A) {
    i[A.line] = A.column, K();
  }
  function k() {
    let A;
    for (; r._index < a.length; ) {
      const w = a[r._index];
      if (typeof w == "string")
        for (A = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === A && r._bufferIndex < w.length; )
          M(w.charCodeAt(r._bufferIndex));
      else
        M(w);
    }
  }
  function M(A) {
    c = c(A);
  }
  function z(A) {
    G(A) ? (r.line++, r.column = 1, r.offset += A === -3 ? 2 : 1, K()) : A !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === a[r._index].length && (r._bufferIndex = -1, r._index++)), u.previous = A;
  }
  function E(A, w) {
    const j = w || {};
    return j.type = A, j.start = T(), u.events.push(["enter", j, u]), l.push(j), j;
  }
  function _(A) {
    const w = l.pop();
    return w.end = T(), u.events.push(["exit", w, u]), w;
  }
  function U(A, w) {
    $(A, w.from);
  }
  function b(A, w) {
    w.restore();
  }
  function L(A, w) {
    return j;
    function j(O, F, Q) {
      let V, q, X, g;
      return Array.isArray(O) ? Me(O) : "tokenize" in O ? (
        // @ts-expect-error Looks like a construct.
        Me([O])
      ) : he(O);
      function he(re) {
        return we;
        function we(ve) {
          const Ue = ve !== null && re[ve], ze = ve !== null && re.null, Xe = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Ue) ? Ue : Ue ? [Ue] : [],
            ...Array.isArray(ze) ? ze : ze ? [ze] : []
          ];
          return Me(Xe)(ve);
        }
      }
      function Me(re) {
        return V = re, q = 0, re.length === 0 ? Q : h(re[q]);
      }
      function h(re) {
        return we;
        function we(ve) {
          return g = W(), X = re, re.partial || (u.currentConstruct = re), re.name && u.parser.constructs.disable.null.includes(re.name) ? ke() : re.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            w ? Object.assign(Object.create(u), w) : u,
            s,
            ge,
            ke
          )(ve);
        }
      }
      function ge(re) {
        return A(X, g), F;
      }
      function ke(re) {
        return g.restore(), ++q < V.length ? h(V[q]) : Q;
      }
    }
  }
  function $(A, w) {
    A.resolveAll && !o.includes(A) && o.push(A), A.resolve && Ge(
      u.events,
      w,
      u.events.length - w,
      A.resolve(u.events.slice(w), u)
    ), A.resolveTo && (u.events = A.resolveTo(u.events, u));
  }
  function W() {
    const A = T(), w = u.previous, j = u.currentConstruct, O = u.events.length, F = Array.from(l);
    return {
      restore: Q,
      from: O
    };
    function Q() {
      r = A, u.previous = w, u.currentConstruct = j, u.events.length = O, l = F, K();
    }
  }
  function K() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
function qf(e, t) {
  const n = t.start._index, r = t.start._bufferIndex, i = t.end._index, o = t.end._bufferIndex;
  let a;
  if (n === i)
    a = [e[n].slice(r, o)];
  else {
    if (a = e.slice(n, i), r > -1) {
      const l = a[0];
      typeof l == "string" ? a[0] = l.slice(r) : a.shift();
    }
    o > 0 && a.push(e[i].slice(0, o));
  }
  return a;
}
function Vf(e, t) {
  let n = -1;
  const r = [];
  let i;
  for (; ++n < e.length; ) {
    const o = e[n];
    let a;
    if (typeof o == "string")
      a = o;
    else
      switch (o) {
        case -5: {
          a = "\r";
          break;
        }
        case -4: {
          a = `
`;
          break;
        }
        case -3: {
          a = `\r
`;
          break;
        }
        case -2: {
          a = t ? " " : "	";
          break;
        }
        case -1: {
          if (!t && i)
            continue;
          a = " ";
          break;
        }
        default:
          a = String.fromCharCode(o);
      }
    i = o === -2, r.push(a);
  }
  return r.join("");
}
const Wf = {
  42: De,
  43: De,
  45: De,
  48: De,
  49: De,
  50: De,
  51: De,
  52: De,
  53: De,
  54: De,
  55: De,
  56: De,
  57: De,
  62: ba
}, Gf = {
  91: Gp
}, Zf = {
  [-2]: rr,
  [-1]: rr,
  32: rr
}, Xf = {
  35: tf,
  42: fn,
  45: [ao, fn],
  60: af,
  61: ao,
  95: fn,
  96: io,
  126: io
}, Kf = {
  38: wa,
  92: xa
}, Jf = {
  [-5]: ir,
  [-4]: ir,
  [-3]: ir,
  33: Df,
  38: wa,
  42: Dr,
  60: [Ip, df],
  91: If,
  92: [Jp, xa],
  93: Qr,
  95: Dr,
  96: Rp
}, ed = {
  null: [Dr, Uf]
}, td = {
  null: [42, 95]
}, nd = {
  null: []
}, rd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: td,
  contentInitial: Gf,
  disable: nd,
  document: Wf,
  flow: Xf,
  flowInitial: Zf,
  insideSpan: ed,
  string: Kf,
  text: Jf
}, Symbol.toStringTag, { value: "Module" }));
function id(e) {
  const n = (
    /** @type {FullNormalizedExtension} */
    cp([rd, ...(e || {}).extensions || []])
  ), r = {
    defined: [],
    lazy: {},
    constructs: n,
    content: i(bp),
    document: i(wp),
    flow: i(Rf),
    string: i(Qf),
    text: i(Yf)
  };
  return r;
  function i(o) {
    return a;
    function a(l) {
      return $f(r, o, l);
    }
  }
}
const lo = /[\0\t\n\r]/g;
function od() {
  let e = 1, t = "", n = !0, r;
  return i;
  function i(o, a, l) {
    const s = [];
    let u, c, p, m, f;
    for (o = t + o.toString(a), p = 0, t = "", n && (o.charCodeAt(0) === 65279 && p++, n = void 0); p < o.length; ) {
      if (lo.lastIndex = p, u = lo.exec(o), m = u && u.index !== void 0 ? u.index : o.length, f = o.charCodeAt(m), !u) {
        t = o.slice(p);
        break;
      }
      if (f === 10 && p === m && r)
        s.push(-3), r = void 0;
      else
        switch (r && (s.push(-5), r = void 0), p < m && (s.push(o.slice(p, m)), e += m - p), f) {
          case 0: {
            s.push(65533), e++;
            break;
          }
          case 9: {
            for (c = Math.ceil(e / 4) * 4, s.push(-2); e++ < c; )
              s.push(-1);
            break;
          }
          case 10: {
            s.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      p = m + 1;
    }
    return l && (r && s.push(-5), t && s.push(t), s.push(null)), s;
  }
}
function ad(e) {
  for (; !va(e); )
    ;
  return e;
}
function ja(e, t) {
  const n = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || (n & 65535) === 65535 || (n & 65535) === 65534 || // Out of range
    n > 1114111 ? "�" : String.fromCharCode(n)
  );
}
const ld = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function sd(e) {
  return e.replace(ld, ud);
}
function ud(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === 35) {
    const i = n.charCodeAt(1), o = i === 120 || i === 88;
    return ja(n.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return Ur(n) || e;
}
const Ea = {}.hasOwnProperty, cd = (
  /**
   * @type {(
   *   ((value: Value, encoding: Encoding, options?: Options | null | undefined) => Root) &
   *   ((value: Value, options?: Options | null | undefined) => Root)
   * )}
   */
  /**
   * @param {Value} value
   * @param {Encoding | Options | null | undefined} [encoding]
   * @param {Options | null | undefined} [options]
   * @returns {Root}
   */
  function(e, t, n) {
    return typeof t != "string" && (n = t, t = void 0), pd(n)(
      ad(
        id(n).document().write(od()(e, t, !0))
      )
    );
  }
);
function pd(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: l(R),
      autolinkProtocol: A,
      autolinkEmail: A,
      atxHeading: l(Ke),
      blockQuote: l(Xe),
      characterEscape: A,
      characterReference: A,
      codeFenced: l(at),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: l(at, s),
      codeText: l(kt, s),
      codeTextData: A,
      data: A,
      codeFlowValue: A,
      definition: l(jt),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: l(Et),
      hardBreakEscape: l(mt),
      hardBreakTrailing: l(mt),
      htmlFlow: l(lt, s),
      htmlFlowData: A,
      htmlText: l(lt, s),
      htmlTextData: A,
      image: l(yt),
      label: s,
      link: l(R),
      listItem: l(me),
      listItemValue: T,
      listOrdered: l(ee, f),
      listUnordered: l(ee),
      paragraph: l(le),
      reference: ke,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: l(Ke),
      strong: l(Qe),
      thematicBreak: l(Mt)
    },
    exit: {
      atxHeading: c(),
      atxHeadingSequence: L,
      autolink: c(),
      autolinkEmail: ze,
      autolinkProtocol: Ue,
      blockQuote: c(),
      characterEscapeValue: w,
      characterReferenceMarkerHexadecimal: we,
      characterReferenceMarkerNumeric: we,
      characterReferenceValue: ve,
      codeFenced: c(z),
      codeFencedFence: M,
      codeFencedFenceInfo: x,
      codeFencedFenceMeta: k,
      codeFlowValue: w,
      codeIndented: c(E),
      codeText: c(V),
      codeTextData: w,
      data: w,
      definition: c(),
      definitionDestinationString: b,
      definitionLabelString: _,
      definitionTitleString: U,
      emphasis: c(),
      hardBreakEscape: c(O),
      hardBreakTrailing: c(O),
      htmlFlow: c(F),
      htmlFlowData: w,
      htmlText: c(Q),
      htmlTextData: w,
      image: c(X),
      label: he,
      labelText: g,
      lineEnding: j,
      link: c(q),
      listItem: c(),
      listOrdered: c(),
      listUnordered: c(),
      paragraph: c(),
      referenceString: re,
      resourceDestinationString: Me,
      resourceTitleString: h,
      resource: ge,
      setextHeading: c(K),
      setextHeadingLineSequence: W,
      setextHeadingText: $,
      strong: c(),
      thematicBreak: c()
    }
  };
  Ca(t, (e || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(I) {
    let S = {
      type: "root",
      children: []
    };
    const Y = {
      stack: [S],
      tokenStack: [],
      config: t,
      enter: u,
      exit: p,
      buffer: s,
      resume: m,
      setData: o,
      getData: a
    }, J = [];
    let oe = -1;
    for (; ++oe < I.length; )
      if (I[oe][1].type === "listOrdered" || I[oe][1].type === "listUnordered")
        if (I[oe][0] === "enter")
          J.push(oe);
        else {
          const Te = J.pop();
          oe = i(I, Te, oe);
        }
    for (oe = -1; ++oe < I.length; ) {
      const Te = t[I[oe][0]];
      Ea.call(Te, I[oe][1].type) && Te[I[oe][1].type].call(
        Object.assign(
          {
            sliceSerialize: I[oe][2].sliceSerialize
          },
          Y
        ),
        I[oe][1]
      );
    }
    if (Y.tokenStack.length > 0) {
      const Te = Y.tokenStack[Y.tokenStack.length - 1];
      (Te[1] || so).call(Y, void 0, Te[0]);
    }
    for (S.position = {
      start: Je(
        I.length > 0 ? I[0][1].start : {
          line: 1,
          column: 1,
          offset: 0
        }
      ),
      end: Je(
        I.length > 0 ? I[I.length - 2][1].end : {
          line: 1,
          column: 1,
          offset: 0
        }
      )
    }, oe = -1; ++oe < t.transforms.length; )
      S = t.transforms[oe](S) || S;
    return S;
  }
  function i(I, S, Y) {
    let J = S - 1, oe = -1, Te = !1, Ye, He, st, je;
    for (; ++J <= Y; ) {
      const ue = I[J];
      if (ue[1].type === "listUnordered" || ue[1].type === "listOrdered" || ue[1].type === "blockQuote" ? (ue[0] === "enter" ? oe++ : oe--, je = void 0) : ue[1].type === "lineEndingBlank" ? ue[0] === "enter" && (Ye && !je && !oe && !st && (st = J), je = void 0) : ue[1].type === "linePrefix" || ue[1].type === "listItemValue" || ue[1].type === "listItemMarker" || ue[1].type === "listItemPrefix" || ue[1].type === "listItemPrefixWhitespace" || (je = void 0), !oe && ue[0] === "enter" && ue[1].type === "listItemPrefix" || oe === -1 && ue[0] === "exit" && (ue[1].type === "listUnordered" || ue[1].type === "listOrdered")) {
        if (Ye) {
          let Ct = J;
          for (He = void 0; Ct--; ) {
            const Le = I[Ct];
            if (Le[1].type === "lineEnding" || Le[1].type === "lineEndingBlank") {
              if (Le[0] === "exit")
                continue;
              He && (I[He][1].type = "lineEndingBlank", Te = !0), Le[1].type = "lineEnding", He = Ct;
            } else if (!(Le[1].type === "linePrefix" || Le[1].type === "blockQuotePrefix" || Le[1].type === "blockQuotePrefixWhitespace" || Le[1].type === "blockQuoteMarker" || Le[1].type === "listItemIndent"))
              break;
          }
          st && (!He || st < He) && (Ye._spread = !0), Ye.end = Object.assign(
            {},
            He ? I[He][1].start : ue[1].end
          ), I.splice(He || J, 0, ["exit", Ye, ue[2]]), J++, Y++;
        }
        ue[1].type === "listItemPrefix" && (Ye = {
          type: "listItem",
          _spread: !1,
          start: Object.assign({}, ue[1].start),
          // @ts-expect-error: we’ll add `end` in a second.
          end: void 0
        }, I.splice(J, 0, ["enter", Ye, ue[2]]), J++, Y++, st = void 0, je = !0);
      }
    }
    return I[S][1]._spread = Te, Y;
  }
  function o(I, S) {
    n[I] = S;
  }
  function a(I) {
    return n[I];
  }
  function l(I, S) {
    return Y;
    function Y(J) {
      u.call(this, I(J), J), S && S.call(this, J);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function u(I, S, Y) {
    return this.stack[this.stack.length - 1].children.push(I), this.stack.push(I), this.tokenStack.push([S, Y]), I.position = {
      start: Je(S.start)
    }, I;
  }
  function c(I) {
    return S;
    function S(Y) {
      I && I.call(this, Y), p.call(this, Y);
    }
  }
  function p(I, S) {
    const Y = this.stack.pop(), J = this.tokenStack.pop();
    if (J)
      J[0].type !== I.type && (S ? S.call(this, I, J[0]) : (J[1] || so).call(this, I, J[0]));
    else
      throw new Error(
        "Cannot close `" + I.type + "` (" + Yt({
          start: I.start,
          end: I.end
        }) + "): it’s not open"
      );
    return Y.position.end = Je(I.end), Y;
  }
  function m() {
    return sp(this.stack.pop());
  }
  function f() {
    o("expectingFirstListItemValue", !0);
  }
  function T(I) {
    if (a("expectingFirstListItemValue")) {
      const S = this.stack[this.stack.length - 2];
      S.start = Number.parseInt(this.sliceSerialize(I), 10), o("expectingFirstListItemValue");
    }
  }
  function x() {
    const I = this.resume(), S = this.stack[this.stack.length - 1];
    S.lang = I;
  }
  function k() {
    const I = this.resume(), S = this.stack[this.stack.length - 1];
    S.meta = I;
  }
  function M() {
    a("flowCodeInside") || (this.buffer(), o("flowCodeInside", !0));
  }
  function z() {
    const I = this.resume(), S = this.stack[this.stack.length - 1];
    S.value = I.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), o("flowCodeInside");
  }
  function E() {
    const I = this.resume(), S = this.stack[this.stack.length - 1];
    S.value = I.replace(/(\r?\n|\r)$/g, "");
  }
  function _(I) {
    const S = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.label = S, Y.identifier = wt(
      this.sliceSerialize(I)
    ).toLowerCase();
  }
  function U() {
    const I = this.resume(), S = this.stack[this.stack.length - 1];
    S.title = I;
  }
  function b() {
    const I = this.resume(), S = this.stack[this.stack.length - 1];
    S.url = I;
  }
  function L(I) {
    const S = this.stack[this.stack.length - 1];
    if (!S.depth) {
      const Y = this.sliceSerialize(I).length;
      S.depth = Y;
    }
  }
  function $() {
    o("setextHeadingSlurpLineEnding", !0);
  }
  function W(I) {
    const S = this.stack[this.stack.length - 1];
    S.depth = this.sliceSerialize(I).charCodeAt(0) === 61 ? 1 : 2;
  }
  function K() {
    o("setextHeadingSlurpLineEnding");
  }
  function A(I) {
    const S = this.stack[this.stack.length - 1];
    let Y = S.children[S.children.length - 1];
    (!Y || Y.type !== "text") && (Y = $e(), Y.position = {
      start: Je(I.start)
    }, S.children.push(Y)), this.stack.push(Y);
  }
  function w(I) {
    const S = this.stack.pop();
    S.value += this.sliceSerialize(I), S.position.end = Je(I.end);
  }
  function j(I) {
    const S = this.stack[this.stack.length - 1];
    if (a("atHardBreak")) {
      const Y = S.children[S.children.length - 1];
      Y.position.end = Je(I.end), o("atHardBreak");
      return;
    }
    !a("setextHeadingSlurpLineEnding") && t.canContainEols.includes(S.type) && (A.call(this, I), w.call(this, I));
  }
  function O() {
    o("atHardBreak", !0);
  }
  function F() {
    const I = this.resume(), S = this.stack[this.stack.length - 1];
    S.value = I;
  }
  function Q() {
    const I = this.resume(), S = this.stack[this.stack.length - 1];
    S.value = I;
  }
  function V() {
    const I = this.resume(), S = this.stack[this.stack.length - 1];
    S.value = I;
  }
  function q() {
    const I = this.stack[this.stack.length - 1];
    if (a("inReference")) {
      const S = a("referenceType") || "shortcut";
      I.type += "Reference", I.referenceType = S, delete I.url, delete I.title;
    } else
      delete I.identifier, delete I.label;
    o("referenceType");
  }
  function X() {
    const I = this.stack[this.stack.length - 1];
    if (a("inReference")) {
      const S = a("referenceType") || "shortcut";
      I.type += "Reference", I.referenceType = S, delete I.url, delete I.title;
    } else
      delete I.identifier, delete I.label;
    o("referenceType");
  }
  function g(I) {
    const S = this.sliceSerialize(I), Y = this.stack[this.stack.length - 2];
    Y.label = sd(S), Y.identifier = wt(S).toLowerCase();
  }
  function he() {
    const I = this.stack[this.stack.length - 1], S = this.resume(), Y = this.stack[this.stack.length - 1];
    if (o("inReference", !0), Y.type === "link") {
      const J = I.children;
      Y.children = J;
    } else
      Y.alt = S;
  }
  function Me() {
    const I = this.resume(), S = this.stack[this.stack.length - 1];
    S.url = I;
  }
  function h() {
    const I = this.resume(), S = this.stack[this.stack.length - 1];
    S.title = I;
  }
  function ge() {
    o("inReference");
  }
  function ke() {
    o("referenceType", "collapsed");
  }
  function re(I) {
    const S = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.label = S, Y.identifier = wt(
      this.sliceSerialize(I)
    ).toLowerCase(), o("referenceType", "full");
  }
  function we(I) {
    o("characterReferenceType", I.type);
  }
  function ve(I) {
    const S = this.sliceSerialize(I), Y = a("characterReferenceType");
    let J;
    Y ? (J = ja(
      S,
      Y === "characterReferenceMarkerNumeric" ? 10 : 16
    ), o("characterReferenceType")) : J = Ur(S);
    const oe = this.stack.pop();
    oe.value += J, oe.position.end = Je(I.end);
  }
  function Ue(I) {
    w.call(this, I);
    const S = this.stack[this.stack.length - 1];
    S.url = this.sliceSerialize(I);
  }
  function ze(I) {
    w.call(this, I);
    const S = this.stack[this.stack.length - 1];
    S.url = "mailto:" + this.sliceSerialize(I);
  }
  function Xe() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function at() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function kt() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function jt() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Et() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function Ke() {
    return {
      type: "heading",
      depth: void 0,
      children: []
    };
  }
  function mt() {
    return {
      type: "break"
    };
  }
  function lt() {
    return {
      type: "html",
      value: ""
    };
  }
  function yt() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function R() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function ee(I) {
    return {
      type: "list",
      ordered: I.type === "listOrdered",
      start: null,
      spread: I._spread,
      children: []
    };
  }
  function me(I) {
    return {
      type: "listItem",
      spread: I._spread,
      checked: null,
      children: []
    };
  }
  function le() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function Qe() {
    return {
      type: "strong",
      children: []
    };
  }
  function $e() {
    return {
      type: "text",
      value: ""
    };
  }
  function Mt() {
    return {
      type: "thematicBreak"
    };
  }
}
function Je(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function Ca(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const r = t[n];
    Array.isArray(r) ? Ca(e, r) : fd(e, r);
  }
}
function fd(e, t) {
  let n;
  for (n in t)
    if (Ea.call(t, n)) {
      if (n === "canContainEols") {
        const r = t[n];
        r && e[n].push(...r);
      } else if (n === "transforms") {
        const r = t[n];
        r && e[n].push(...r);
      } else if (n === "enter" || n === "exit") {
        const r = t[n];
        r && Object.assign(e[n], r);
      }
    }
}
function so(e, t) {
  throw e ? new Error(
    "Cannot close `" + e.type + "` (" + Yt({
      start: e.start,
      end: e.end
    }) + "): a different token (`" + t.type + "`, " + Yt({
      start: t.start,
      end: t.end
    }) + ") is open"
  ) : new Error(
    "Cannot close document, a token (`" + t.type + "`, " + Yt({
      start: t.start,
      end: t.end
    }) + ") is still open"
  );
}
function dd(e) {
  Object.assign(this, { Parser: (n) => {
    const r = (
      /** @type {Options} */
      this.data("settings")
    );
    return cd(
      n,
      Object.assign({}, r, e, {
        // Note: these options are not in the readme.
        // The goal is for them to be set by plugins on `data` instead of being
        // passed by users.
        extensions: this.data("micromarkExtensions") || [],
        mdastExtensions: this.data("fromMarkdownExtensions") || []
      })
    );
  } });
}
function hd(e, t) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function gd(e, t) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, n), [e.applyData(t, n), { type: "text", value: `
` }];
}
function md(e, t) {
  const n = t.value ? t.value + `
` : "", r = t.lang ? t.lang.match(/^[^ \t]+(?=[ \t]|$)/) : null, i = {};
  r && (i.className = ["language-" + r]);
  let o = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: n }]
  };
  return t.meta && (o.data = { meta: t.meta }), e.patch(t, o), o = e.applyData(t, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, e.patch(t, o), o;
}
function yd(e, t) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Md(e, t) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Nt(e) {
  const t = [];
  let n = -1, r = 0, i = 0;
  for (; ++n < e.length; ) {
    const o = e.charCodeAt(n);
    let a = "";
    if (o === 37 && Ae(e.charCodeAt(n + 1)) && Ae(e.charCodeAt(n + 2)))
      i = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (a = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(n + 1);
      o < 56320 && l > 56319 && l < 57344 ? (a = String.fromCharCode(o, l), i = 1) : a = "�";
    } else
      a = String.fromCharCode(o);
    a && (t.push(e.slice(r, n), encodeURIComponent(a)), r = n + i + 1, a = ""), i && (n += i, i = 0);
  }
  return t.join("") + e.slice(r);
}
function Aa(e, t) {
  const n = String(t.identifier).toUpperCase(), r = Nt(n.toLowerCase()), i = e.footnoteOrder.indexOf(n);
  let o;
  i === -1 ? (e.footnoteOrder.push(n), e.footnoteCounts[n] = 1, o = e.footnoteOrder.length) : (e.footnoteCounts[n]++, o = i + 1);
  const a = e.footnoteCounts[n], l = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + e.clobberPrefix + "fn-" + r,
      id: e.clobberPrefix + "fnref-" + r + (a > 1 ? "-" + a : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(o) }]
  };
  e.patch(t, l);
  const s = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [l]
  };
  return e.patch(t, s), e.applyData(t, s);
}
function bd(e, t) {
  const n = e.footnoteById;
  let r = 1;
  for (; r in n; )
    r++;
  const i = String(r);
  return n[i] = {
    type: "footnoteDefinition",
    identifier: i,
    children: [{ type: "paragraph", children: t.children }],
    position: t.position
  }, Aa(e, {
    type: "footnoteReference",
    identifier: i,
    position: t.position
  });
}
function xd(e, t) {
  const n = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function wd(e, t) {
  if (e.dangerous) {
    const n = { type: "raw", value: t.value };
    return e.patch(t, n), e.applyData(t, n);
  }
  return null;
}
function Sa(e, t) {
  const n = t.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return { type: "text", value: "![" + t.alt + r };
  const i = e.all(t), o = i[0];
  o && o.type === "text" ? o.value = "[" + o.value : i.unshift({ type: "text", value: "[" });
  const a = i[i.length - 1];
  return a && a.type === "text" ? a.value += r : i.push({ type: "text", value: r }), i;
}
function vd(e, t) {
  const n = e.definition(t.identifier);
  if (!n)
    return Sa(e, t);
  const r = { src: Nt(n.url || ""), alt: t.alt };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(t, i), e.applyData(t, i);
}
function Td(e, t) {
  const n = { src: Nt(t.url) };
  t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = { type: "element", tagName: "img", properties: n, children: [] };
  return e.patch(t, r), e.applyData(t, r);
}
function Dd(e, t) {
  const n = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, n);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return e.patch(t, r), e.applyData(t, r);
}
function Nd(e, t) {
  const n = e.definition(t.identifier);
  if (!n)
    return Sa(e, t);
  const r = { href: Nt(n.url || "") };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(t)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function Id(e, t) {
  const n = { href: Nt(t.url) };
  t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: n,
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function kd(e, t, n) {
  const r = e.all(t), i = n ? jd(n) : Oa(t), o = {}, a = [];
  if (typeof t.checked == "boolean") {
    const c = r[0];
    let p;
    c && c.type === "element" && c.tagName === "p" ? p = c : (p = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(p)), p.children.length > 0 && p.children.unshift({ type: "text", value: " " }), p.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < r.length; ) {
    const c = r[l];
    (i || l !== 0 || c.type !== "element" || c.tagName !== "p") && a.push({ type: "text", value: `
` }), c.type === "element" && c.tagName === "p" && !i ? a.push(...c.children) : a.push(c);
  }
  const s = r[r.length - 1];
  s && (i || s.type !== "element" || s.tagName !== "p") && a.push({ type: "text", value: `
` });
  const u = { type: "element", tagName: "li", properties: o, children: a };
  return e.patch(t, u), e.applyData(t, u);
}
function jd(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const n = e.children;
    let r = -1;
    for (; !t && ++r < n.length; )
      t = Oa(n[r]);
  }
  return t;
}
function Oa(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function Ed(e, t) {
  const n = {}, r = e.all(t);
  let i = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++i < r.length; ) {
    const a = r[i];
    if (a.type === "element" && a.tagName === "li" && a.properties && Array.isArray(a.properties.className) && a.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: n,
    children: e.wrap(r, !0)
  };
  return e.patch(t, o), e.applyData(t, o);
}
function Cd(e, t) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Ad(e, t) {
  const n = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, n), e.applyData(t, n);
}
function Sd(e, t) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const Yr = za("start"), Hr = za("end");
function Od(e) {
  return { start: Yr(e), end: Hr(e) };
}
function za(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    return {
      // @ts-expect-error: in practice, null is allowed.
      line: r.line || null,
      // @ts-expect-error: in practice, null is allowed.
      column: r.column || null,
      // @ts-expect-error: in practice, null is allowed.
      offset: r.offset > -1 ? r.offset : null
    };
  }
}
function zd(e, t) {
  const n = e.all(t), r = n.shift(), i = [];
  if (r) {
    const a = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(t.children[0], a), i.push(a);
  }
  if (n.length > 0) {
    const a = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(n, !0)
    }, l = Yr(t.children[1]), s = Hr(t.children[t.children.length - 1]);
    l.line && s.line && (a.position = { start: l, end: s }), i.push(a);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(i, !0)
  };
  return e.patch(t, o), e.applyData(t, o);
}
function Ld(e, t, n) {
  const r = n ? n.children : void 0, o = (r ? r.indexOf(t) : 1) === 0 ? "th" : "td", a = n && n.type === "table" ? n.align : void 0, l = a ? a.length : t.children.length;
  let s = -1;
  const u = [];
  for (; ++s < l; ) {
    const p = t.children[s], m = {}, f = a ? a[s] : void 0;
    f && (m.align = f);
    let T = { type: "element", tagName: o, properties: m, children: [] };
    p && (T.children = e.all(p), e.patch(p, T), T = e.applyData(t, T)), u.push(T);
  }
  const c = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(u, !0)
  };
  return e.patch(t, c), e.applyData(t, c);
}
function _d(e, t) {
  const n = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const uo = 9, co = 32;
function Fd(e) {
  const t = String(e), n = /\r?\n|\r/g;
  let r = n.exec(t), i = 0;
  const o = [];
  for (; r; )
    o.push(
      po(t.slice(i, r.index), i > 0, !0),
      r[0]
    ), i = r.index + r[0].length, r = n.exec(t);
  return o.push(po(t.slice(i), i > 0, !1)), o.join("");
}
function po(e, t, n) {
  let r = 0, i = e.length;
  if (t) {
    let o = e.codePointAt(r);
    for (; o === uo || o === co; )
      r++, o = e.codePointAt(r);
  }
  if (n) {
    let o = e.codePointAt(i - 1);
    for (; o === uo || o === co; )
      i--, o = e.codePointAt(i - 1);
  }
  return i > r ? e.slice(r, i) : "";
}
function Pd(e, t) {
  const n = { type: "text", value: Fd(String(t.value)) };
  return e.patch(t, n), e.applyData(t, n);
}
function Rd(e, t) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, n), e.applyData(t, n);
}
const Bd = {
  blockquote: hd,
  break: gd,
  code: md,
  delete: yd,
  emphasis: Md,
  footnoteReference: Aa,
  footnote: bd,
  heading: xd,
  html: wd,
  imageReference: vd,
  image: Td,
  inlineCode: Dd,
  linkReference: Nd,
  link: Id,
  listItem: kd,
  list: Ed,
  paragraph: Cd,
  root: Ad,
  strong: Sd,
  table: zd,
  tableCell: _d,
  tableRow: Ld,
  text: Pd,
  thematicBreak: Rd,
  toml: an,
  yaml: an,
  definition: an,
  footnoteDefinition: an
};
function an() {
  return null;
}
const La = (
  /**
   * @type {(
   *   (<Kind extends Node>(test: PredicateTest<Kind>) => AssertPredicate<Kind>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {AssertAnything}
   */
  function(e) {
    if (e == null)
      return Hd;
    if (typeof e == "string")
      return Yd(e);
    if (typeof e == "object")
      return Array.isArray(e) ? Ud(e) : Qd(e);
    if (typeof e == "function")
      return Nn(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function Ud(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = La(e[n]);
  return Nn(r);
  function r(...i) {
    let o = -1;
    for (; ++o < t.length; )
      if (t[o].call(this, ...i))
        return !0;
    return !1;
  }
}
function Qd(e) {
  return Nn(t);
  function t(n) {
    let r;
    for (r in e)
      if (n[r] !== e[r])
        return !1;
    return !0;
  }
}
function Yd(e) {
  return Nn(t);
  function t(n) {
    return n && n.type === e;
  }
}
function Nn(e) {
  return t;
  function t(n, ...r) {
    return !!(n && typeof n == "object" && "type" in n && e.call(this, n, ...r));
  }
}
function Hd() {
  return !0;
}
const $d = !0, fo = !1, qd = "skip", Vd = (
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */
  /**
   * @param {Node} tree
   * @param {Test} test
   * @param {Visitor<Node>} visitor
   * @param {boolean | null | undefined} [reverse]
   * @returns {void}
   */
  function(e, t, n, r) {
    typeof t == "function" && typeof n != "function" && (r = n, n = t, t = null);
    const i = La(t), o = r ? -1 : 1;
    a(e, void 0, [])();
    function a(l, s, u) {
      const c = l && typeof l == "object" ? l : {};
      if (typeof c.type == "string") {
        const m = (
          // `hast`
          typeof c.tagName == "string" ? c.tagName : (
            // `xast`
            typeof c.name == "string" ? c.name : void 0
          )
        );
        Object.defineProperty(p, "name", {
          value: "node (" + (l.type + (m ? "<" + m + ">" : "")) + ")"
        });
      }
      return p;
      function p() {
        let m = [], f, T, x;
        if ((!t || i(l, s, u[u.length - 1] || null)) && (m = Wd(n(l, u)), m[0] === fo))
          return m;
        if (l.children && m[0] !== qd)
          for (T = (r ? l.children.length : -1) + o, x = u.concat(l); T > -1 && T < l.children.length; ) {
            if (f = a(l.children[T], T, x)(), f[0] === fo)
              return f;
            T = typeof f[1] == "number" ? f[1] : T + o;
          }
        return m;
      }
    }
  }
);
function Wd(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [$d, e] : [e];
}
const $r = (
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */
  /**
   * @param {Node} tree
   * @param {Test} test
   * @param {Visitor} visitor
   * @param {boolean | null | undefined} [reverse]
   * @returns {void}
   */
  function(e, t, n, r) {
    typeof t == "function" && typeof n != "function" && (r = n, n = t, t = null), Vd(e, t, i, r);
    function i(o, a) {
      const l = a[a.length - 1];
      return n(
        o,
        l ? l.children.indexOf(o) : null,
        l
      );
    }
  }
);
function Gd(e) {
  return !e || !e.position || !e.position.start || !e.position.start.line || !e.position.start.column || !e.position.end || !e.position.end.line || !e.position.end.column;
}
const ho = {}.hasOwnProperty;
function Zd(e) {
  const t = /* @__PURE__ */ Object.create(null);
  if (!e || !e.type)
    throw new Error("mdast-util-definitions expected node");
  return $r(e, "definition", (r) => {
    const i = go(r.identifier);
    i && !ho.call(t, i) && (t[i] = r);
  }), n;
  function n(r) {
    const i = go(r);
    return i && ho.call(t, i) ? t[i] : null;
  }
}
function go(e) {
  return String(e || "").toUpperCase();
}
const xn = {}.hasOwnProperty;
function Xd(e, t) {
  const n = t || {}, r = n.allowDangerousHtml || !1, i = {};
  return a.dangerous = r, a.clobberPrefix = n.clobberPrefix === void 0 || n.clobberPrefix === null ? "user-content-" : n.clobberPrefix, a.footnoteLabel = n.footnoteLabel || "Footnotes", a.footnoteLabelTagName = n.footnoteLabelTagName || "h2", a.footnoteLabelProperties = n.footnoteLabelProperties || {
    className: ["sr-only"]
  }, a.footnoteBackLabel = n.footnoteBackLabel || "Back to content", a.unknownHandler = n.unknownHandler, a.passThrough = n.passThrough, a.handlers = { ...Bd, ...n.handlers }, a.definition = Zd(e), a.footnoteById = i, a.footnoteOrder = [], a.footnoteCounts = {}, a.patch = Kd, a.applyData = Jd, a.one = l, a.all = s, a.wrap = th, a.augment = o, $r(e, "footnoteDefinition", (u) => {
    const c = String(u.identifier).toUpperCase();
    xn.call(i, c) || (i[c] = u);
  }), a;
  function o(u, c) {
    if (u && "data" in u && u.data) {
      const p = u.data;
      p.hName && (c.type !== "element" && (c = {
        type: "element",
        tagName: "",
        properties: {},
        children: []
      }), c.tagName = p.hName), c.type === "element" && p.hProperties && (c.properties = { ...c.properties, ...p.hProperties }), "children" in c && c.children && p.hChildren && (c.children = p.hChildren);
    }
    if (u) {
      const p = "type" in u ? u : { position: u };
      Gd(p) || (c.position = { start: Yr(p), end: Hr(p) });
    }
    return c;
  }
  function a(u, c, p, m) {
    return Array.isArray(p) && (m = p, p = {}), o(u, {
      type: "element",
      tagName: c,
      properties: p || {},
      children: m || []
    });
  }
  function l(u, c) {
    return _a(a, u, c);
  }
  function s(u) {
    return qr(a, u);
  }
}
function Kd(e, t) {
  e.position && (t.position = Od(e));
}
function Jd(e, t) {
  let n = t;
  if (e && e.data) {
    const r = e.data.hName, i = e.data.hChildren, o = e.data.hProperties;
    typeof r == "string" && (n.type === "element" ? n.tagName = r : n = {
      type: "element",
      tagName: r,
      properties: {},
      children: []
    }), n.type === "element" && o && (n.properties = { ...n.properties, ...o }), "children" in n && n.children && i !== null && i !== void 0 && (n.children = i);
  }
  return n;
}
function _a(e, t, n) {
  const r = t && t.type;
  if (!r)
    throw new Error("Expected node, got `" + t + "`");
  return xn.call(e.handlers, r) ? e.handlers[r](e, t, n) : e.passThrough && e.passThrough.includes(r) ? "children" in t ? { ...t, children: qr(e, t) } : t : e.unknownHandler ? e.unknownHandler(e, t, n) : eh(e, t);
}
function qr(e, t) {
  const n = [];
  if ("children" in t) {
    const r = t.children;
    let i = -1;
    for (; ++i < r.length; ) {
      const o = _a(e, r[i], t);
      if (o) {
        if (i && r[i - 1].type === "break" && (!Array.isArray(o) && o.type === "text" && (o.value = o.value.replace(/^\s+/, "")), !Array.isArray(o) && o.type === "element")) {
          const a = o.children[0];
          a && a.type === "text" && (a.value = a.value.replace(/^\s+/, ""));
        }
        Array.isArray(o) ? n.push(...o) : n.push(o);
      }
    }
  }
  return n;
}
function eh(e, t) {
  const n = t.data || {}, r = "value" in t && !(xn.call(n, "hProperties") || xn.call(n, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: qr(e, t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function th(e, t) {
  const n = [];
  let r = -1;
  for (t && n.push({ type: "text", value: `
` }); ++r < e.length; )
    r && n.push({ type: "text", value: `
` }), n.push(e[r]);
  return t && e.length > 0 && n.push({ type: "text", value: `
` }), n;
}
function nh(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.footnoteOrder.length; ) {
    const r = e.footnoteById[e.footnoteOrder[n]];
    if (!r)
      continue;
    const i = e.all(r), o = String(r.identifier).toUpperCase(), a = Nt(o.toLowerCase());
    let l = 0;
    const s = [];
    for (; ++l <= e.footnoteCounts[o]; ) {
      const p = {
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + e.clobberPrefix + "fnref-" + a + (l > 1 ? "-" + l : ""),
          dataFootnoteBackref: !0,
          className: ["data-footnote-backref"],
          ariaLabel: e.footnoteBackLabel
        },
        children: [{ type: "text", value: "↩" }]
      };
      l > 1 && p.children.push({
        type: "element",
        tagName: "sup",
        children: [{ type: "text", value: String(l) }]
      }), s.length > 0 && s.push({ type: "text", value: " " }), s.push(p);
    }
    const u = i[i.length - 1];
    if (u && u.type === "element" && u.tagName === "p") {
      const p = u.children[u.children.length - 1];
      p && p.type === "text" ? p.value += " " : u.children.push({ type: "text", value: " " }), u.children.push(...s);
    } else
      i.push(...s);
    const c = {
      type: "element",
      tagName: "li",
      properties: { id: e.clobberPrefix + "fn-" + a },
      children: e.wrap(i, !0)
    };
    e.patch(r, c), t.push(c);
  }
  if (t.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: e.footnoteLabelTagName,
          properties: {
            // To do: use structured clone.
            ...JSON.parse(JSON.stringify(e.footnoteLabelProperties)),
            id: "footnote-label"
          },
          children: [{ type: "text", value: e.footnoteLabel }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(t, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
function Fa(e, t) {
  const n = Xd(e, t), r = n.one(e, null), i = nh(n);
  return i && r.children.push({ type: "text", value: `
` }, i), Array.isArray(r) ? { type: "root", children: r } : r;
}
const rh = (
  /** @type {(import('unified').Plugin<[Processor, Options?]|[null|undefined, Options?]|[Options]|[], MdastRoot>)} */
  function(e, t) {
    return e && "run" in e ? oh(e, t) : ah(e || t);
  }
), ih = rh;
function oh(e, t) {
  return (n, r, i) => {
    e.run(Fa(n, t), r, (o) => {
      i(o);
    });
  };
}
function ah(e) {
  return (t) => Fa(t, e);
}
class Gt {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(t, n, r) {
    this.property = t, this.normal = n, r && (this.space = r);
  }
}
Gt.prototype.property = {};
Gt.prototype.normal = {};
Gt.prototype.space = null;
function Pa(e, t) {
  const n = {}, r = {};
  let i = -1;
  for (; ++i < e.length; )
    Object.assign(n, e[i].property), Object.assign(r, e[i].normal);
  return new Gt(n, r, t);
}
function Nr(e) {
  return e.toLowerCase();
}
class Re {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(t, n) {
    this.property = t, this.attribute = n;
  }
}
Re.prototype.space = null;
Re.prototype.boolean = !1;
Re.prototype.booleanish = !1;
Re.prototype.overloadedBoolean = !1;
Re.prototype.number = !1;
Re.prototype.commaSeparated = !1;
Re.prototype.spaceSeparated = !1;
Re.prototype.commaOrSpaceSeparated = !1;
Re.prototype.mustUseProperty = !1;
Re.prototype.defined = !1;
let lh = 0;
const Z = gt(), be = gt(), Ra = gt(), C = gt(), ce = gt(), vt = gt(), Ce = gt();
function gt() {
  return 2 ** ++lh;
}
const Ir = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Z,
  booleanish: be,
  commaOrSpaceSeparated: Ce,
  commaSeparated: vt,
  number: C,
  overloadedBoolean: Ra,
  spaceSeparated: ce
}, Symbol.toStringTag, { value: "Module" })), or = Object.keys(Ir);
class Vr extends Re {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(t, n, r, i) {
    let o = -1;
    if (super(t, n), mo(this, "space", i), typeof r == "number")
      for (; ++o < or.length; ) {
        const a = or[o];
        mo(this, or[o], (r & Ir[a]) === Ir[a]);
      }
  }
}
Vr.prototype.defined = !0;
function mo(e, t, n) {
  n && (e[t] = n);
}
const sh = {}.hasOwnProperty;
function It(e) {
  const t = {}, n = {};
  let r;
  for (r in e.properties)
    if (sh.call(e.properties, r)) {
      const i = e.properties[r], o = new Vr(
        r,
        e.transform(e.attributes || {}, r),
        i,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(r) && (o.mustUseProperty = !0), t[r] = o, n[Nr(r)] = r, n[Nr(o.attribute)] = r;
    }
  return new Gt(t, n, e.space);
}
const Ba = It({
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), Ua = It({
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function Qa(e, t) {
  return t in e ? e[t] : t;
}
function Ya(e, t) {
  return Qa(e, t.toLowerCase());
}
const Ha = It({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: Ya,
  properties: { xmlns: null, xmlnsXLink: null }
}), $a = It({
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: be,
    ariaAutoComplete: null,
    ariaBusy: be,
    ariaChecked: be,
    ariaColCount: C,
    ariaColIndex: C,
    ariaColSpan: C,
    ariaControls: ce,
    ariaCurrent: null,
    ariaDescribedBy: ce,
    ariaDetails: null,
    ariaDisabled: be,
    ariaDropEffect: ce,
    ariaErrorMessage: null,
    ariaExpanded: be,
    ariaFlowTo: ce,
    ariaGrabbed: be,
    ariaHasPopup: null,
    ariaHidden: be,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: ce,
    ariaLevel: C,
    ariaLive: null,
    ariaModal: be,
    ariaMultiLine: be,
    ariaMultiSelectable: be,
    ariaOrientation: null,
    ariaOwns: ce,
    ariaPlaceholder: null,
    ariaPosInSet: C,
    ariaPressed: be,
    ariaReadOnly: be,
    ariaRelevant: null,
    ariaRequired: be,
    ariaRoleDescription: ce,
    ariaRowCount: C,
    ariaRowIndex: C,
    ariaRowSpan: C,
    ariaSelected: be,
    ariaSetSize: C,
    ariaSort: null,
    ariaValueMax: C,
    ariaValueMin: C,
    ariaValueNow: C,
    ariaValueText: null,
    role: null
  }
}), uh = It({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: Ya,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: vt,
    acceptCharset: ce,
    accessKey: ce,
    action: null,
    allow: null,
    allowFullScreen: Z,
    allowPaymentRequest: Z,
    allowUserMedia: Z,
    alt: null,
    as: null,
    async: Z,
    autoCapitalize: null,
    autoComplete: ce,
    autoFocus: Z,
    autoPlay: Z,
    blocking: ce,
    capture: null,
    charSet: null,
    checked: Z,
    cite: null,
    className: ce,
    cols: C,
    colSpan: null,
    content: null,
    contentEditable: be,
    controls: Z,
    controlsList: ce,
    coords: C | vt,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Z,
    defer: Z,
    dir: null,
    dirName: null,
    disabled: Z,
    download: Ra,
    draggable: be,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Z,
    formTarget: null,
    headers: ce,
    height: C,
    hidden: Z,
    high: C,
    href: null,
    hrefLang: null,
    htmlFor: ce,
    httpEquiv: ce,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Z,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Z,
    itemId: null,
    itemProp: ce,
    itemRef: ce,
    itemScope: Z,
    itemType: ce,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Z,
    low: C,
    manifest: null,
    max: null,
    maxLength: C,
    media: null,
    method: null,
    min: null,
    minLength: C,
    multiple: Z,
    muted: Z,
    name: null,
    nonce: null,
    noModule: Z,
    noValidate: Z,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Z,
    optimum: C,
    pattern: null,
    ping: ce,
    placeholder: null,
    playsInline: Z,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Z,
    referrerPolicy: null,
    rel: ce,
    required: Z,
    reversed: Z,
    rows: C,
    rowSpan: C,
    sandbox: ce,
    scope: null,
    scoped: Z,
    seamless: Z,
    selected: Z,
    shadowRootDelegatesFocus: Z,
    shadowRootMode: null,
    shape: null,
    size: C,
    sizes: null,
    slot: null,
    span: C,
    spellCheck: be,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: C,
    step: null,
    style: null,
    tabIndex: C,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Z,
    useMap: null,
    value: be,
    width: C,
    wrap: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: ce,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: C,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: C,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Z,
    // Lists. Use CSS to reduce space between items instead
    declare: Z,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: C,
    // `<img>` and `<object>`
    leftMargin: C,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: C,
    // `<body>`
    marginWidth: C,
    // `<body>`
    noResize: Z,
    // `<frame>`
    noHref: Z,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Z,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Z,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: C,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: be,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: C,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: C,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Z,
    disableRemotePlayback: Z,
    prefix: null,
    property: null,
    results: C,
    security: null,
    unselectable: null
  }
}), ch = It({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: Qa,
  properties: {
    about: Ce,
    accentHeight: C,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: C,
    amplitude: C,
    arabicForm: null,
    ascent: C,
    attributeName: null,
    attributeType: null,
    azimuth: C,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: C,
    by: null,
    calcMode: null,
    capHeight: C,
    className: ce,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: C,
    diffuseConstant: C,
    direction: null,
    display: null,
    dur: null,
    divisor: C,
    dominantBaseline: null,
    download: Z,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: C,
    enableBackground: null,
    end: null,
    event: null,
    exponent: C,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: C,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: vt,
    g2: vt,
    glyphName: vt,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: C,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: C,
    horizOriginX: C,
    horizOriginY: C,
    id: null,
    ideographic: C,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: C,
    k: C,
    k1: C,
    k2: C,
    k3: C,
    k4: C,
    kernelMatrix: Ce,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: C,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: C,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: C,
    overlineThickness: C,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: C,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: ce,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: C,
    pointsAtY: C,
    pointsAtZ: C,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Ce,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Ce,
    rev: Ce,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Ce,
    requiredFeatures: Ce,
    requiredFonts: Ce,
    requiredFormats: Ce,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: C,
    specularExponent: C,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: C,
    strikethroughThickness: C,
    string: null,
    stroke: null,
    strokeDashArray: Ce,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: C,
    strokeOpacity: C,
    strokeWidth: null,
    style: null,
    surfaceScale: C,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Ce,
    tabIndex: C,
    tableValues: null,
    target: null,
    targetX: C,
    targetY: C,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Ce,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: C,
    underlineThickness: C,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: C,
    values: null,
    vAlphabetic: C,
    vMathematical: C,
    vectorEffect: null,
    vHanging: C,
    vIdeographic: C,
    version: null,
    vertAdvY: C,
    vertOriginX: C,
    vertOriginY: C,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: C,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), ph = /^data[-\w.:]+$/i, yo = /-[a-z]/g, fh = /[A-Z]/g;
function dh(e, t) {
  const n = Nr(t);
  let r = t, i = Re;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && ph.test(t)) {
    if (t.charAt(4) === "-") {
      const o = t.slice(5).replace(yo, gh);
      r = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = t.slice(4);
      if (!yo.test(o)) {
        let a = o.replace(fh, hh);
        a.charAt(0) !== "-" && (a = "-" + a), t = "data" + a;
      }
    }
    i = Vr;
  }
  return new i(r, t);
}
function hh(e) {
  return "-" + e.toLowerCase();
}
function gh(e) {
  return e.charAt(1).toUpperCase();
}
const Mo = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, mh = Pa([Ua, Ba, Ha, $a, uh], "html"), yh = Pa([Ua, Ba, Ha, $a, ch], "svg");
function Mh(e) {
  if (e.allowedElements && e.disallowedElements)
    throw new TypeError(
      "Only one of `allowedElements` and `disallowedElements` should be defined"
    );
  if (e.allowedElements || e.disallowedElements || e.allowElement)
    return (t) => {
      $r(t, "element", (n, r, i) => {
        const o = (
          /** @type {Element|Root} */
          i
        );
        let a;
        if (e.allowedElements ? a = !e.allowedElements.includes(n.tagName) : e.disallowedElements && (a = e.disallowedElements.includes(n.tagName)), !a && e.allowElement && typeof r == "number" && (a = !e.allowElement(n, r, o)), a && typeof r == "number")
          return e.unwrapDisallowed && n.children ? o.children.splice(r, 1, ...n.children) : o.children.splice(r, 1), r;
      });
    };
}
var qa = { exports: {} }, ae = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wr = Symbol.for("react.element"), Gr = Symbol.for("react.portal"), In = Symbol.for("react.fragment"), kn = Symbol.for("react.strict_mode"), jn = Symbol.for("react.profiler"), En = Symbol.for("react.provider"), Cn = Symbol.for("react.context"), bh = Symbol.for("react.server_context"), An = Symbol.for("react.forward_ref"), Sn = Symbol.for("react.suspense"), On = Symbol.for("react.suspense_list"), zn = Symbol.for("react.memo"), Ln = Symbol.for("react.lazy"), xh = Symbol.for("react.offscreen"), Va;
Va = Symbol.for("react.module.reference");
function Be(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case Wr:
        switch (e = e.type, e) {
          case In:
          case jn:
          case kn:
          case Sn:
          case On:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case bh:
              case Cn:
              case An:
              case Ln:
              case zn:
              case En:
                return e;
              default:
                return t;
            }
        }
      case Gr:
        return t;
    }
  }
}
ae.ContextConsumer = Cn;
ae.ContextProvider = En;
ae.Element = Wr;
ae.ForwardRef = An;
ae.Fragment = In;
ae.Lazy = Ln;
ae.Memo = zn;
ae.Portal = Gr;
ae.Profiler = jn;
ae.StrictMode = kn;
ae.Suspense = Sn;
ae.SuspenseList = On;
ae.isAsyncMode = function() {
  return !1;
};
ae.isConcurrentMode = function() {
  return !1;
};
ae.isContextConsumer = function(e) {
  return Be(e) === Cn;
};
ae.isContextProvider = function(e) {
  return Be(e) === En;
};
ae.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === Wr;
};
ae.isForwardRef = function(e) {
  return Be(e) === An;
};
ae.isFragment = function(e) {
  return Be(e) === In;
};
ae.isLazy = function(e) {
  return Be(e) === Ln;
};
ae.isMemo = function(e) {
  return Be(e) === zn;
};
ae.isPortal = function(e) {
  return Be(e) === Gr;
};
ae.isProfiler = function(e) {
  return Be(e) === jn;
};
ae.isStrictMode = function(e) {
  return Be(e) === kn;
};
ae.isSuspense = function(e) {
  return Be(e) === Sn;
};
ae.isSuspenseList = function(e) {
  return Be(e) === On;
};
ae.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === In || e === jn || e === kn || e === Sn || e === On || e === xh || typeof e == "object" && e !== null && (e.$$typeof === Ln || e.$$typeof === zn || e.$$typeof === En || e.$$typeof === Cn || e.$$typeof === An || e.$$typeof === Va || e.getModuleId !== void 0);
};
ae.typeOf = Be;
qa.exports = ae;
var wh = qa.exports;
const vh = /* @__PURE__ */ rt(wh);
function Th(e) {
  const t = (
    // @ts-expect-error looks like a node.
    e && typeof e == "object" && e.type === "text" ? (
      // @ts-expect-error looks like a text.
      e.value || ""
    ) : e
  );
  return typeof t == "string" && t.replace(/[ \t\n\f\r]/g, "") === "";
}
function Dh(e) {
  return e.join(" ").trim();
}
function Nh(e, t) {
  const n = t || {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
var Zr = { exports: {} }, bo = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, Ih = /\n/g, kh = /^\s*/, jh = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, Eh = /^:\s*/, Ch = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, Ah = /^[;\s]*/, Sh = /^\s+|\s+$/g, Oh = `
`, xo = "/", wo = "*", ft = "", zh = "comment", Lh = "declaration", _h = function(e, t) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e)
    return [];
  t = t || {};
  var n = 1, r = 1;
  function i(T) {
    var x = T.match(Ih);
    x && (n += x.length);
    var k = T.lastIndexOf(Oh);
    r = ~k ? T.length - k : r + T.length;
  }
  function o() {
    var T = { line: n, column: r };
    return function(x) {
      return x.position = new a(T), u(), x;
    };
  }
  function a(T) {
    this.start = T, this.end = { line: n, column: r }, this.source = t.source;
  }
  a.prototype.content = e;
  function l(T) {
    var x = new Error(
      t.source + ":" + n + ":" + r + ": " + T
    );
    if (x.reason = T, x.filename = t.source, x.line = n, x.column = r, x.source = e, !t.silent)
      throw x;
  }
  function s(T) {
    var x = T.exec(e);
    if (x) {
      var k = x[0];
      return i(k), e = e.slice(k.length), x;
    }
  }
  function u() {
    s(kh);
  }
  function c(T) {
    var x;
    for (T = T || []; x = p(); )
      x !== !1 && T.push(x);
    return T;
  }
  function p() {
    var T = o();
    if (!(xo != e.charAt(0) || wo != e.charAt(1))) {
      for (var x = 2; ft != e.charAt(x) && (wo != e.charAt(x) || xo != e.charAt(x + 1)); )
        ++x;
      if (x += 2, ft === e.charAt(x - 1))
        return l("End of comment missing");
      var k = e.slice(2, x - 2);
      return r += 2, i(k), e = e.slice(x), r += 2, T({
        type: zh,
        comment: k
      });
    }
  }
  function m() {
    var T = o(), x = s(jh);
    if (x) {
      if (p(), !s(Eh))
        return l("property missing ':'");
      var k = s(Ch), M = T({
        type: Lh,
        property: vo(x[0].replace(bo, ft)),
        value: k ? vo(k[0].replace(bo, ft)) : ft
      });
      return s(Ah), M;
    }
  }
  function f() {
    var T = [];
    c(T);
    for (var x; x = m(); )
      x !== !1 && (T.push(x), c(T));
    return T;
  }
  return u(), f();
};
function vo(e) {
  return e ? e.replace(Sh, ft) : ft;
}
var Fh = _h;
function Wa(e, t) {
  var n = null;
  if (!e || typeof e != "string")
    return n;
  for (var r, i = Fh(e), o = typeof t == "function", a, l, s = 0, u = i.length; s < u; s++)
    r = i[s], a = r.property, l = r.value, o ? t(a, l, r) : l && (n || (n = {}), n[a] = l);
  return n;
}
Zr.exports = Wa;
Zr.exports.default = Wa;
var Ph = Zr.exports;
const Rh = /* @__PURE__ */ rt(Ph), kr = {}.hasOwnProperty, Bh = /* @__PURE__ */ new Set(["table", "thead", "tbody", "tfoot", "tr"]);
function Ga(e, t) {
  const n = [];
  let r = -1, i;
  for (; ++r < t.children.length; )
    i = t.children[r], i.type === "element" ? n.push(Uh(e, i, r, t)) : i.type === "text" ? (t.type !== "element" || !Bh.has(t.tagName) || !Th(i)) && n.push(i.value) : i.type === "raw" && !e.options.skipHtml && n.push(i.value);
  return n;
}
function Uh(e, t, n, r) {
  const i = e.options, o = i.transformLinkUri === void 0 ? Uc : i.transformLinkUri, a = e.schema, l = t.tagName, s = {};
  let u = a, c;
  if (a.space === "html" && l === "svg" && (u = yh, e.schema = u), t.properties)
    for (c in t.properties)
      kr.call(t.properties, c) && Yh(s, c, t.properties[c], e);
  (l === "ol" || l === "ul") && e.listDepth++;
  const p = Ga(e, t);
  (l === "ol" || l === "ul") && e.listDepth--, e.schema = a;
  const m = t.position || {
    start: { line: null, column: null, offset: null },
    end: { line: null, column: null, offset: null }
  }, f = i.components && kr.call(i.components, l) ? i.components[l] : l, T = typeof f == "string" || f === tt.Fragment;
  if (!vh.isValidElementType(f))
    throw new TypeError(
      `Component for name \`${l}\` not defined or is not renderable`
    );
  if (s.key = n, l === "a" && i.linkTarget && (s.target = typeof i.linkTarget == "function" ? i.linkTarget(
    String(s.href || ""),
    t.children,
    typeof s.title == "string" ? s.title : null
  ) : i.linkTarget), l === "a" && o && (s.href = o(
    String(s.href || ""),
    t.children,
    typeof s.title == "string" ? s.title : null
  )), !T && l === "code" && r.type === "element" && r.tagName !== "pre" && (s.inline = !0), !T && (l === "h1" || l === "h2" || l === "h3" || l === "h4" || l === "h5" || l === "h6") && (s.level = Number.parseInt(l.charAt(1), 10)), l === "img" && i.transformImageUri && (s.src = i.transformImageUri(
    String(s.src || ""),
    String(s.alt || ""),
    typeof s.title == "string" ? s.title : null
  )), !T && l === "li" && r.type === "element") {
    const x = Qh(t);
    s.checked = x && x.properties ? !!x.properties.checked : null, s.index = ar(r, t), s.ordered = r.tagName === "ol";
  }
  return !T && (l === "ol" || l === "ul") && (s.ordered = l === "ol", s.depth = e.listDepth), (l === "td" || l === "th") && (s.align && (s.style || (s.style = {}), s.style.textAlign = s.align, delete s.align), T || (s.isHeader = l === "th")), !T && l === "tr" && r.type === "element" && (s.isHeader = r.tagName === "thead"), i.sourcePos && (s["data-sourcepos"] = qh(m)), !T && i.rawSourcePos && (s.sourcePosition = t.position), !T && i.includeElementIndex && (s.index = ar(r, t), s.siblingCount = ar(r)), T || (s.node = t), p.length > 0 ? tt.createElement(f, s, p) : tt.createElement(f, s);
}
function Qh(e) {
  let t = -1;
  for (; ++t < e.children.length; ) {
    const n = e.children[t];
    if (n.type === "element" && n.tagName === "input")
      return n;
  }
  return null;
}
function ar(e, t) {
  let n = -1, r = 0;
  for (; ++n < e.children.length && e.children[n] !== t; )
    e.children[n].type === "element" && r++;
  return r;
}
function Yh(e, t, n, r) {
  const i = dh(r.schema, t);
  let o = n;
  o == null || o !== o || (Array.isArray(o) && (o = i.commaSeparated ? Nh(o) : Dh(o)), i.property === "style" && typeof o == "string" && (o = Hh(o)), i.space && i.property ? e[kr.call(Mo, i.property) ? Mo[i.property] : i.property] = o : i.attribute && (e[i.attribute] = o));
}
function Hh(e) {
  const t = {};
  try {
    Rh(e, n);
  } catch {
  }
  return t;
  function n(r, i) {
    const o = r.slice(0, 4) === "-ms-" ? `ms-${r.slice(4)}` : r;
    t[o.replace(/-([a-z])/g, $h)] = i;
  }
}
function $h(e, t) {
  return t.toUpperCase();
}
function qh(e) {
  return [
    e.start.line,
    ":",
    e.start.column,
    "-",
    e.end.line,
    ":",
    e.end.column
  ].map(String).join("");
}
const To = {}.hasOwnProperty, Vh = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", ln = {
  plugins: { to: "remarkPlugins", id: "change-plugins-to-remarkplugins" },
  renderers: { to: "components", id: "change-renderers-to-components" },
  astPlugins: { id: "remove-buggy-html-in-markdown-parser" },
  allowDangerousHtml: { id: "remove-buggy-html-in-markdown-parser" },
  escapeHtml: { id: "remove-buggy-html-in-markdown-parser" },
  source: { to: "children", id: "change-source-to-children" },
  allowNode: {
    to: "allowElement",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  allowedTypes: {
    to: "allowedElements",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  disallowedTypes: {
    to: "disallowedElements",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  includeNodeIndex: {
    to: "includeElementIndex",
    id: "change-includenodeindex-to-includeelementindex"
  }
};
function Xr(e) {
  for (const o in ln)
    if (To.call(ln, o) && To.call(e, o)) {
      const a = ln[o];
      console.warn(
        `[react-markdown] Warning: please ${a.to ? `use \`${a.to}\` instead of` : "remove"} \`${o}\` (see <${Vh}#${a.id}> for more info)`
      ), delete ln[o];
    }
  const t = rp().use(dd).use(e.remarkPlugins || []).use(ih, {
    ...e.remarkRehypeOptions,
    allowDangerousHtml: !0
  }).use(e.rehypePlugins || []).use(Mh, e), n = new ha();
  typeof e.children == "string" ? n.value = e.children : e.children !== void 0 && e.children !== null && console.warn(
    `[react-markdown] Warning: please pass a string as \`children\` (not: \`${e.children}\`)`
  );
  const r = t.runSync(t.parse(n), n);
  if (r.type !== "root")
    throw new TypeError("Expected a `root` node");
  let i = tt.createElement(
    tt.Fragment,
    {},
    Ga({ options: e, schema: mh, listDepth: 0 }, r)
  );
  return e.className && (i = tt.createElement("div", { className: e.className }, i)), i;
}
Xr.propTypes = {
  // Core options:
  children: N.string,
  // Layout options:
  className: N.string,
  // Filter options:
  allowElement: N.func,
  allowedElements: N.arrayOf(N.string),
  disallowedElements: N.arrayOf(N.string),
  unwrapDisallowed: N.bool,
  // Plugin options:
  remarkPlugins: N.arrayOf(
    N.oneOfType([
      N.object,
      N.func,
      N.arrayOf(
        N.oneOfType([
          N.bool,
          N.string,
          N.object,
          N.func,
          N.arrayOf(
            // prettier-ignore
            // type-coverage:ignore-next-line
            N.any
          )
        ])
      )
    ])
  ),
  rehypePlugins: N.arrayOf(
    N.oneOfType([
      N.object,
      N.func,
      N.arrayOf(
        N.oneOfType([
          N.bool,
          N.string,
          N.object,
          N.func,
          N.arrayOf(
            // prettier-ignore
            // type-coverage:ignore-next-line
            N.any
          )
        ])
      )
    ])
  ),
  // Transform options:
  sourcePos: N.bool,
  rawSourcePos: N.bool,
  skipHtml: N.bool,
  includeElementIndex: N.bool,
  transformLinkUri: N.oneOfType([N.func, N.bool]),
  linkTarget: N.oneOfType([N.func, N.string]),
  transformImageUri: N.func,
  components: N.object
};
const Za = () => {
  var s, u, c;
  const { conversationScreen: e, xpertKey: t } = Se(Oe), n = `${t}-maintenance-banner`, [r, i] = ye(
    Ne.get(n) === void 0
  ), o = /* @__PURE__ */ new Date(), a = new Date(
    (s = e == null ? void 0 : e.maintenanceBanner) == null ? void 0 : s.endDateTime
  );
  if (!((u = e == null ? void 0 : e.maintenanceBanner) != null && u.enabled) || !((c = e == null ? void 0 : e.maintenanceBanner) != null && c.text) || o > a || !r)
    return null;
  const l = () => {
    Ne.set(n, "1", { expires: 1 }), i(!1);
  };
  return /* @__PURE__ */ v.jsxs(
    "div",
    {
      role: "alert",
      "aria-live": "assertive",
      className: "xpert-chatbot-popup__chatbot-maintenance-banner",
      "data-testid": "maintenance-banner",
      children: [
        /* @__PURE__ */ v.jsxs("div", { className: "xpert-chatbot-popup__chatbot-maintenance-banner__header", children: [
          /* @__PURE__ */ v.jsx(
            nt,
            {
              icon: "material-symbols:warning",
              style: { fontSize: "1.5rem" },
              color: "#eed202"
            }
          ),
          /* @__PURE__ */ v.jsx("strong", { children: e.maintenanceBanner.header }),
          /* @__PURE__ */ v.jsx(
            "button",
            {
              className: "xpert-chatbot-popup__chatbot-maintenance-banner__close-btn",
              "aria-label": "Close maintenance banner",
              onClick: l,
              children: /* @__PURE__ */ v.jsx(
                nt,
                {
                  icon: "material-symbols:close",
                  alt: "Close Xpert dialog",
                  style: { fontSize: "1.4rem" }
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ v.jsx("div", { className: "xpert-chatbot-popup__chatbot-maintenance-banner__body", children: /* @__PURE__ */ v.jsx("div", { className: "xpert-chatbot-popup__chatbot-maintenance-banner__text", children: /* @__PURE__ */ v.jsx(Xr, { linkTarget: "_blank", children: e.maintenanceBanner.text }) }) })
      ]
    }
  );
};
Za.displayName = "MaintenanceBanner";
const Wh = Za;
function Kr({
  containerStyle: e,
  handleChange: t,
  handleInput: n,
  handleKeyDown: r,
  handleSend: i,
  hasError: o,
  hasXpertMessages: a,
  inputRef: l,
  loading: s,
  userInput: u
}) {
  const { primaryColor: c } = Se(Oe);
  return xe(() => {
    var p;
    (o || a) && ((p = l.current) == null || p.focus());
  }, [a, o, l]), /* @__PURE__ */ v.jsxs("div", { className: "xpert-chatbot-popup__input--group", style: e, children: [
    /* @__PURE__ */ v.jsx(
      "textarea",
      {
        disabled: s,
        value: u,
        ref: l,
        onInput: n,
        onChange: t,
        placeholder: "Write a message",
        cols: "5",
        rows: "1",
        maxLength: "150",
        onKeyDown: r,
        style: {
          outlineColor: c,
          width: "100%",
          minHeight: "3.25rem",
          borderRadius: "1rem",
          padding: "12.5px 45px 12.5px 12.5px",
          fontFamily: "inherit",
          fontSize: "1rem",
          // required to avoid IOS mobile scaling when input is focused
          fontWeight: "300",
          lineHeight: "1.56rem",
          boxSizing: "border-box",
          resize: "none"
        }
      }
    ),
    /* @__PURE__ */ v.jsx(
      "button",
      {
        disabled: s,
        className: "xpert-chatbot-popup__input--send-btn",
        onClick: (p) => {
          p.preventDefault(), i(u);
        },
        "aria-label": "Send message",
        children: /* @__PURE__ */ v.jsx(nt, { icon: "material-symbols:send", style: { fontSize: "1.75rem" } })
      }
    )
  ] });
}
Kr.propTypes = {
  containerStyle: N.shape(),
  handleChange: N.func.isRequired,
  handleInput: N.func.isRequired,
  handleKeyDown: N.func.isRequired,
  handleSend: N.func.isRequired,
  hasError: N.bool,
  hasXpertMessages: N.bool,
  inputRef: N.shape({ current: N.instanceOf(Object) }).isRequired,
  loading: N.bool.isRequired,
  userInput: N.string.isRequired
};
Kr.defaultProps = {
  containerStyle: void 0,
  hasError: !1,
  hasXpertMessages: !1
};
function Xa({ message: e, id: t, onFeedbackThumbSelection: n }) {
  return /* @__PURE__ */ v.jsxs("div", { className: "xpert-chatbot-popup__feedback", children: [
    /* @__PURE__ */ v.jsx(
      "button",
      {
        className: `xpert-chatbot-popup__feedback--btn-up
              ${e.feedbackThumbType === "UP" ? "xpert-chatbot-popup__feedback--btn-up-selected" : ""}`,
        onClick: () => n(t, "UP"),
        "aria-label": "I like this response",
        children: /* @__PURE__ */ v.jsx(
          nt,
          {
            className: "xpert-chatbot-popup__feedback--btn-up-icon",
            icon: e.feedbackThumbType === "UP" ? "material-symbols:thumb-up" : "material-symbols:thumb-up-outline"
          }
        )
      }
    ),
    /* @__PURE__ */ v.jsx(
      "button",
      {
        style: { marginLeft: "-0.7rem" },
        className: `xpert-chatbot-popup__feedback--btn-down 
              ${e.feedbackThumbType === "DOWN" ? "xpert-chatbot-popup__feedback--btn-down-selected" : ""}`,
        onClick: () => n(t, "DOWN"),
        "aria-label": "I do not like this response",
        children: /* @__PURE__ */ v.jsx(
          nt,
          {
            className: "xpert-chatbot-popup__feedback--btn-down-icon",
            icon: e.feedbackThumbType === "DOWN" ? "material-symbols:thumb-down" : "material-symbols:thumb-down-outline"
          }
        )
      }
    )
  ] });
}
Xa.propTypes = {
  id: N.number.isRequired,
  message: N.shape().isRequired,
  onFeedbackThumbSelection: N.func.isRequired
};
const Gh = (e) => {
  Array.from(e.entries()).forEach((n) => {
    const r = n[0], i = n[1];
    r.toLocaleLowerCase().startsWith("utm_") && e.delete(r, i);
  });
}, Zh = (e) => {
  e.delete("linked_from", "xpert_chat"), e.append("linked_from", "xpert_chat");
};
function Xh(e) {
  const t = new URL(e), n = t.host;
  if (n == null ? void 0 : n.includes("edx.org")) {
    const i = t.searchParams;
    Gh(i), Zh(i), t.search = i;
  }
  return t.toString();
}
const Kh = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiPjxwYXRoIGQ9Ik00NDAtMTIwdi04MGgzMjB2LTI4NHEwLTExNy04MS41LTE5OC41VDQ4MC03NjRxLTExNyAwLTE5OC41IDgxLjVUMjAwLTQ4NHYyNDRoLTQwcS0zMyAwLTU2LjUtMjMuNVQ4MC0zMjB2LTgwcTAtMjEgMTAuNS0zOS41VDEyMC00NjlsMy01M3E4LTY4IDM5LjUtMTI2dDc5LTEwMXE0Ny41LTQzIDEwOS02N1Q0ODAtODQwcTY4IDAgMTI5IDI0dDEwOSA2Ni41UTc2Ni03MDcgNzk3LTY0OXQ0MCAxMjZsMyA1MnExOSA5IDI5LjUgMjd0MTAuNSAzOHY5MnEwIDIwLTEwLjUgMzhUODQwLTI0OXY0OXEwIDMzLTIzLjUgNTYuNVQ3NjAtMTIwSDQ0MFptLTgwLTI4MHEtMTcgMC0yOC41LTExLjVUMzIwLTQ0MHEwLTE3IDExLjUtMjguNVQzNjAtNDgwcTE3IDAgMjguNSAxMS41VDQwMC00NDBxMCAxNy0xMS41IDI4LjVUMzYwLTQwMFptMjQwIDBxLTE3IDAtMjguNS0xMS41VDU2MC00NDBxMC0xNyAxMS41LTI4LjVUNjAwLTQ4MHExNyAwIDI4LjUgMTEuNVQ2NDAtNDQwcTAgMTctMTEuNSAyOC41VDYwMC00MDBabS0zNTktNjJxLTctMTA2IDY0LTE4MnQxNzctNzZxODkgMCAxNTYuNSA1Ni41VDcyMC01MTlxLTkxLTEtMTY3LjUtNDlUNDM1LTY5OHEtMTYgODAtNjcuNSAxNDIuNVQyNDEtNDYyWiIvPjwvc3ZnPg==";
function _n({
  submitEvent: e,
  setLiveChatOpen: t,
  isTestUser: n,
  enableLiveChatMessage: r,
  containerStyle: i,
  buttonClassName: o,
  text: a,
  userTrackingName: l
}) {
  const [s, u] = ye(!0), { primaryColor: c, xpertKey: p, userTracking: m, conversationScreen: f } = Se(Oe), T = Tt(
    (M) => {
      var z, E, _, U;
      ((z = M == null ? void 0 : M.data) == null ? void 0 : z.who) === "customer" && (!(window != null && window.OnetrustActiveGroups) || (E = window == null ? void 0 : window.OnetrustActiveGroups) != null && E.includes("C0003")) && Ne.set(`${p}-live-chat-open`, 1, {
        expires: 1,
        path: "/"
      }), ((_ = M == null ? void 0 : M.data) == null ? void 0 : _.type) === "connection" && ((U = M == null ? void 0 : M.data) == null ? void 0 : U.state) === "disconnected" && Ne.remove(`${p}-live-chat-open`);
    },
    [p]
  ), x = Tt(
    (M) => {
      var z, E, _, U;
      ((z = M == null ? void 0 : M.data) == null ? void 0 : z.type) === "unhide" && ((E = M == null ? void 0 : M.data) == null ? void 0 : E.reason) === "pop-out" && t(!0), ((_ = M == null ? void 0 : M.data) == null ? void 0 : _.type) === "open" && ((U = M == null ? void 0 : M.data) == null ? void 0 : U.chatState) === !0 && t(!0);
    },
    [t]
  );
  xe(() => {
    let M, z;
    return f.liveChat.enabled && (window.Five9ChatPlugin || (M = document.createElement("script"), M.type = "text/javascript", M.src = f.liveChat.sourceCode, M.async = !0, M.onload = () => {
      window.Five9ChatPlugin(f.liveChat.options);
    }, document.body.appendChild(M)), window.addEventListener("message", T), window.addEventListener("message", x), z = setTimeout(() => {
      u(!1);
    }, 3e3)), () => {
      f.liveChat.enabled && (window.removeEventListener("message", T), window.removeEventListener("message", x), clearTimeout(z));
    };
  }, [
    f.liveChat.enabled,
    f.liveChat.options,
    f.liveChat.sourceCode,
    T,
    x
  ]);
  const k = () => {
    e({
      name: `${m.prefix}.bi.xpert.chatbot.popup.live.chat.${l}`,
      payload: {
        category: "2u",
        label: "xpert-chatbot",
        isTestUser: n
      }
    }), t(!0), window.f9_postMessage({ type: "toggle" });
  };
  return /* @__PURE__ */ v.jsxs("div", { title: "Talk to a live agent at anytime.", style: i, children: [
    s && r && /* @__PURE__ */ v.jsxs("div", { className: "xpert-chatbot-popup__live-chat--message", children: [
      /* @__PURE__ */ v.jsx(
        "div",
        {
          style: { backgroundColor: c },
          className: "xpert-chatbot-popup__live-chat--message-border"
        }
      ),
      /* @__PURE__ */ v.jsx("div", { children: "Talk to a live agent at anytime." })
    ] }),
    /* @__PURE__ */ v.jsxs(
      "button",
      {
        type: "button",
        onClick: k,
        "aria-label": "Open live chat window",
        style: { position: "relative" },
        className: o,
        children: [
          /* @__PURE__ */ v.jsx(
            "img",
            {
              height: "24px",
              width: "24px",
              src: Kh,
              alt: "Open live chat window icon"
            }
          ),
          a && /* @__PURE__ */ v.jsx("span", { style: { marginLeft: "0.675rem" }, children: a })
        ]
      }
    )
  ] });
}
_n.propTypes = {
  submitEvent: N.func,
  setLiveChatOpen: N.func,
  isTestUser: N.bool,
  enableLiveChatMessage: N.bool,
  containerStyle: N.shape(),
  buttonClassName: N.string,
  text: N.string,
  userTrackingName: N.string
};
_n.defaultProps = {
  submitEvent: null,
  setLiveChatOpen: null,
  isTestUser: !1,
  enableLiveChatMessage: !0,
  containerStyle: null,
  buttonClassName: null,
  text: null,
  userTrackingName: "clicked"
};
const Jh = "Sure, I can get you to someone who can help.", Fn = ({
  index: e,
  message: t,
  isNormalSize: n,
  onFeedbackThumbSelection: r,
  messageRef: i,
  handleMessageLinkClicked: o,
  submitEvent: a,
  setLiveChatOpen: l,
  isTestUser: s
}) => /* @__PURE__ */ v.jsx(
  "section",
  {
    "aria-label": "The bot said",
    className: "xpert-chatbot-popup__bubble--group",
    ref: i,
    children: /* @__PURE__ */ v.jsxs("div", { className: "xpert-chatbot-popup__bubble--group-inner", children: [
      /* @__PURE__ */ v.jsx(
        "div",
        {
          "data-testid": "message-container",
          className: "xpert-chatbot-popup__bubble--assistant",
          style: { maxWidth: n ? "85%" : "67%" },
          children: t.liveAgent ? /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
            /* @__PURE__ */ v.jsx("div", { children: Jh }),
            /* @__PURE__ */ v.jsx(
              _n,
              {
                submitEvent: a,
                setLiveChatOpen: l,
                isTestUser: s,
                enableLiveChatMessage: !1,
                buttonClassName: "xpert-chatbot-popup__bubble--assistant-live-chat",
                text: "Chat with us",
                userTrackingName: "assistant.response.clicked"
              }
            )
          ] }) : /* @__PURE__ */ v.jsx(
            Xr,
            {
              components: {
                a: (u) => (
                  // eslint-disable-next-line jsx-a11y/interactive-supports-focus
                  /* @__PURE__ */ v.jsx(
                    "a",
                    {
                      ...u,
                      role: "link",
                      onClick: o,
                      onKeyDown: void 0,
                      children: u.children
                    }
                  )
                )
              },
              linkTarget: "_blank",
              transformLinkUri: Xh,
              children: t.content
            }
          )
        }
      ),
      t.disableFeedback ? null : /* @__PURE__ */ v.jsx(
        Xa,
        {
          id: e,
          message: t,
          onFeedbackThumbSelection: r
        }
      )
    ] })
  }
);
Fn.propTypes = {
  index: N.number.isRequired,
  message: N.shape().isRequired,
  onFeedbackThumbSelection: N.func.isRequired,
  isNormalSize: N.bool.isRequired,
  messageRef: N.shape({ current: N.instanceOf(Element) }),
  handleMessageLinkClicked: N.func,
  submitEvent: N.func,
  setLiveChatOpen: N.func,
  isTestUser: N.bool
};
Fn.defaultProps = {
  submitEvent: null,
  setLiveChatOpen: null,
  isTestUser: !1
};
Fn.displayName = "AssistantMessageBubble";
const eg = Fn, Ka = () => {
  const { disclaimer: e } = Se(Oe), t = We(null);
  return xe(() => {
    var n;
    (n = t == null ? void 0 : t.current) == null || n.focus();
  }, []), /* @__PURE__ */ v.jsxs(
    "div",
    {
      ref: t,
      tabIndex: -1,
      role: "alert",
      "aria-live": "assertive",
      className: "xpert-chatbot-popup__conversations_disclaimer--text",
      children: [
        /* @__PURE__ */ v.jsx("span", { children: e.text }),
        /* @__PURE__ */ v.jsxs("span", { style: { marginLeft: "0.1875rem" }, children: [
          /* @__PURE__ */ v.jsx(
            "a",
            {
              href: e.privacyPolicyLink,
              target: "_blank",
              rel: "noopener noreferrer",
              className: "xpert-chatbot-popup__conversations_disclaimer--text__link",
              children: "privacy policy"
            }
          ),
          "."
        ] })
      ]
    }
  );
};
Ka.displayName = "ConversationScreenDisclaimer";
const tg = Ka, Jr = ({ loading: e, onPromptClick: t }) => {
  var i;
  const { primaryColor: n, conversationScreen: r } = Se(Oe);
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx("div", { style: { fontWeight: 700, fontSize: "0.75rem" }, children: "Some things I can help you with" }),
    (i = r.prompts) == null ? void 0 : i.map((o) => {
      var a;
      return /* @__PURE__ */ v.jsx(
        "button",
        {
          className: "xpert-chatbot-popup__bubble--prompt",
          style: {
            fontWeight: "500",
            backgroundColor: n,
            border: "none",
            outline: "none",
            ...(a = r.userMessageBubble) == null ? void 0 : a.style
          },
          onClick: () => !e && t(o.text),
          children: o.text
        },
        o.id
      );
    })
  ] });
};
Jr.propTypes = {
  loading: N.bool.isRequired,
  onPromptClick: N.func.isRequired
};
Jr.displayName = "PromptList";
const ng = Jr, ei = ({ message: e, isNormalSize: t }) => /* @__PURE__ */ v.jsx("div", { role: "status", className: "xpert-chatbot-popup__bubble--group", children: /* @__PURE__ */ v.jsx("div", { className: "xpert-chatbot-popup__bubble--group-inner", children: /* @__PURE__ */ v.jsx(
  "div",
  {
    "data-testid": "message-container",
    className: "xpert-chatbot-popup__bubble--assistant",
    style: { maxWidth: t ? "85%" : "67%" },
    children: e
  }
) }) });
ei.propTypes = {
  message: N.string.isRequired,
  isNormalSize: N.bool.isRequired
};
ei.displayName = "SystemMessageBubble";
const rg = ei, ti = ({ content: e, isNormalSize: t }) => {
  var i;
  const { primaryColor: n, conversationScreen: r } = Se(Oe);
  return /* @__PURE__ */ v.jsx(
    "section",
    {
      "aria-label": "The user said",
      className: "xpert-chatbot-popup__bubble--user",
      style: {
        backgroundColor: n,
        maxWidth: t ? "85%" : "67%",
        ...(i = r.userMessageBubble) == null ? void 0 : i.style
      },
      children: e
    }
  );
};
ti.propTypes = {
  content: N.string.isRequired,
  isNormalSize: N.bool.isRequired
};
ti.displayName = "UserMessageBubble";
const ig = ti, Pn = ({
  messages: e,
  loading: t,
  isNormalSize: n,
  onFeedbackThumbSelection: r,
  onPromptClick: i,
  handleMessageLinkClicked: o,
  submitEvent: a,
  setLiveChatOpen: l,
  isTestUser: s
}) => {
  const { conversationScreen: u } = Se(Oe), { prompts: c, systemMessage: p } = u, m = We(null);
  return xe(() => {
    var f;
    (f = m.current) == null || f.scrollIntoView({
      behavior: "instant",
      block: "start"
    });
  }, [e.length]), /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx(tg, {}),
    (c == null ? void 0 : c.length) > 0 && /* @__PURE__ */ v.jsx(ng, { loading: t, onPromptClick: i }),
    p && /* @__PURE__ */ v.jsx(
      rg,
      {
        message: p,
        isNormalSize: n
      }
    ),
    /* @__PURE__ */ v.jsx(
      "section",
      {
        id: "chat-content",
        "aria-live": "polite",
        "aria-relevant": "additions",
        "aria-atomic": "false",
        "aria-label": "Chat conversation",
        "aria-busy": t,
        style: { display: "flex", flexDirection: "column" },
        children: e.map(
          (f, T) => f.role === "assistant" ? /* @__PURE__ */ v.jsx(
            eg,
            {
              index: T,
              message: f,
              isNormalSize: n,
              onFeedbackThumbSelection: r,
              messageRef: m,
              handleMessageLinkClicked: o,
              submitEvent: a,
              setLiveChatOpen: l,
              isTestUser: s
            },
            `${f.role}-${T}`
          ) : /* @__PURE__ */ v.jsx(
            ig,
            {
              content: f.content,
              isNormalSize: n
            },
            `${f.role}-${f.timestamp || T}`
          )
        )
      }
    )
  ] });
};
Pn.propTypes = {
  messages: N.arrayOf(
    N.shape({
      role: N.oneOf(["assistant", "user"]).isRequired,
      content: N.string.isRequired,
      liveAgent: N.bool.isRequired
    })
  ),
  loading: N.bool.isRequired,
  isNormalSize: N.bool,
  onFeedbackThumbSelection: N.func.isRequired,
  onPromptClick: N.func,
  handleMessageLinkClicked: N.func,
  submitEvent: N.func,
  setLiveChatOpen: N.func,
  isTestUser: N.bool
};
Pn.defaultProps = {
  messages: [],
  isNormalSize: !0,
  submitEvent: null,
  setLiveChatOpen: null,
  isTestUser: !1
};
Pn.displayName = "ConversationsMessages";
const og = Pn;
function Ja({ disableScroll: e }) {
  const t = We(null);
  return xe(() => {
    var n;
    e || (n = t.current) == null || n.scrollIntoView({
      behavior: "smooth",
      block: "end"
    });
  }, [e]), /* @__PURE__ */ v.jsx(
    "div",
    {
      "aria-label": "Loading messages",
      ref: t,
      role: "alert",
      className: "xpert_chatbot__loader__wrapper",
      children: /* @__PURE__ */ v.jsxs("div", { className: "xpert_chatbot__loader__ellipsis", children: [
        /* @__PURE__ */ v.jsx("div", { className: "xpert_chatbot__loader__ellipsis-bullets--first" }),
        /* @__PURE__ */ v.jsx("div", { className: "xpert_chatbot__loader__ellipsis-bullets--second" }),
        /* @__PURE__ */ v.jsx("div", { className: "xpert_chatbot__loader__ellipsis-bullets--third" })
      ] })
    }
  );
}
Ja.propTypes = {
  disableScroll: N.bool
};
const ag = () => {
  const e = We(null);
  return xe(() => {
    var t;
    (t = e.current) == null || t.scrollIntoView({
      behavior: "instant"
    });
  }, []), /* @__PURE__ */ v.jsxs(
    "div",
    {
      role: "alert",
      style: {
        maxWidth: "18.375rem",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#eae6e5",
        borderRadius: "0.375rem",
        marginBottom: "5rem",
        boxShadow: "0 0.0625rem 0.125rem rgba(0, 0, 0, 0.2)",
        overflow: "hidden"
      },
      "aria-describedby": "Oops! Something went wrong. Try again later.",
      ref: e,
      children: [
        /* @__PURE__ */ v.jsx(
          nt,
          {
            icon: "material-symbols:thunderstorm",
            style: {
              height: "54px",
              width: "54px",
              alignSelf: "center",
              marginTop: "2rem",
              marginBottom: "2rem",
              color: "#454545"
            }
          }
        ),
        /* @__PURE__ */ v.jsxs(
          "div",
          {
            style: {
              backgroundColor: "white",
              display: "flex",
              flexDirection: "column",
              padding: "0 1.5rem 1.5rem",
              textAlign: "center"
            },
            children: [
              /* @__PURE__ */ v.jsx(
                "span",
                {
                  style: { margin: "1.5rem 0", fontWeight: "bold", fontSize: "18px" },
                  children: "Oops! Something went wrong"
                }
              ),
              /* @__PURE__ */ v.jsx("span", { style: { marginBottom: "1.5rem", color: "red" }, children: "Please try again later." })
            ]
          }
        )
      ]
    }
  );
}, lr = ag;
function el({
  children: e,
  cookieName: t,
  onClick: n = () => null,
  onClose: r = () => null,
  showMessage: i = !1,
  style: o = {}
}) {
  var T;
  const { proactiveMessage: a } = Se(Oe), [l, s] = ye(!0), [u, c] = ye(!1), p = l && (!(window != null && window.OnetrustActiveGroups) || ((T = window == null ? void 0 : window.OnetrustActiveGroups) == null ? void 0 : T.includes("C0003"))) && Ne.get(t) === void 0;
  xe(() => {
    var x;
    (x = window == null ? void 0 : window.OneTrust) == null || x.OnConsentChanged(() => {
      var k;
      !((k = window == null ? void 0 : window.OnetrustActiveGroups) != null && k.includes("C0003")) && Ne.get(t) !== void 0 && Ne.remove(t);
    });
  }, [t]), xe(() => {
    var x;
    i || (!(window != null && window.OnetrustActiveGroups) || (x = window == null ? void 0 : window.OnetrustActiveGroups) != null && x.includes("C0003")) && f(t, 1, 1);
  }, [t, i]), xe(() => {
    if (a.enabled && a.delayMs > 0) {
      const x = setTimeout(() => {
        c(!0);
      }, a.delayMs);
      return () => clearTimeout(x);
    } else
      c(!0);
  }, [a.delayMs, a.enabled]);
  const m = () => {
    var x;
    s(!1), (!(window != null && window.OnetrustActiveGroups) || (x = window == null ? void 0 : window.OnetrustActiveGroups) != null && x.includes("C0003")) && f(t, 1, 1), r();
  }, f = (x, k, M) => {
    const z = {
      expires: M,
      path: "/"
    };
    Ne.set(x, k, z);
  };
  return !u || !p ? null : /* @__PURE__ */ v.jsx("div", { children: /* @__PURE__ */ v.jsxs(
    "div",
    {
      role: "alertdialog",
      className: "xpert_chatbot__proactive-message",
      style: o,
      children: [
        /* @__PURE__ */ v.jsx("div", { children: /* @__PURE__ */ v.jsx(
          "button",
          {
            className: "xpert_chatbot__proactive-message__container",
            onClick: n,
            "aria-label": a.text,
            type: "button",
            children: /* @__PURE__ */ v.jsx("div", { className: "xpert_chatbot__proactive-message__text", children: e })
          }
        ) }),
        /* @__PURE__ */ v.jsx("div", { children: /* @__PURE__ */ v.jsx(
          "button",
          {
            className: "xpert_chatbot__proactive-message__close",
            onClick: m,
            "aria-label": "Close proactive message",
            type: "button",
            children: /* @__PURE__ */ v.jsx(
              nt,
              {
                style: {
                  color: "#000000",
                  fontSize: "1.25rem",
                  borderRadius: "100px"
                },
                icon: "carbon:close",
                alt: "Close proactive message"
              }
            )
          }
        ) })
      ]
    }
  ) });
}
el.propTypes = {
  children: N.node.isRequired,
  cookieName: N.string.isRequired,
  onClick: N.func,
  onClose: N.func,
  showMessage: N.bool,
  style: N.shape()
};
function lg(e, t, n) {
  const r = Tt(
    (i) => {
      const { data: o } = i || {}, { chatState: a, show: l, type: s } = o || {};
      (s === "openForm" && l === !1 || s === "open" && a === !1) && n(!1);
    },
    [n]
  );
  xe(() => (e && window.addEventListener("message", r), () => {
    window.removeEventListener("message", r);
  }), [e, r]), xe(() => {
    let i;
    return e && (i = document.createElement("style"), document.head.appendChild(i), ((a) => {
      i.innerHTML = `
            #five9OpenChatButton {
              bottom: 0.625rem !important;
              position: fixed !important;
              right: 0.4375rem !important;
              ${a}
  
              @media (max-width: 61.9375rem) {
                  display: none !important;
              }
            }
        `;
    })(t ? "" : "display: none !important;")), () => {
      i && document.head.removeChild(i);
    };
  }, [e, t]);
}
function sg(e) {
  const [t, n] = ye(null);
  return xe(() => {
    try {
      (() => {
        var i, o, a;
        (i = window.experiments) != null && i[e] ? (console.log("Chatbot - Optimizely experiment variation exist"), n(
          (a = (o = window.experiments) == null ? void 0 : o[e]) == null ? void 0 : a.variation
        )) : (console.log(
          "Chatbot - Optimizely experiment variation does not exist"
        ), window.experiments = window.experiments || {}, window.experiments[e] = {}, window.experiments[e].handleLoaded = () => {
          var l, s;
          /* istanbul ignore next @preserve */
          n(
            (s = (l = window.experiments) == null ? void 0 : l[e]) == null ? void 0 : s.variation
          );
        });
      })();
    } catch (r) {
      /* istanbul ignore next @preserve */
      console.error(r.message);
    }
    return () => {
      var r, i;
      window.experiments = {}, (i = (r = window == null ? void 0 : window.optimizely) == null ? void 0 : r.push) == null || i.call(r, { type: "activate" });
    };
  }, [e]), console.log(
    `Chatbot - Optimizely experimentVariation: ${t}`
  ), t;
}
function ug(e) {
  xe(() => {
    e();
    const t = () => document.visibilityState === "visible" && e();
    return document.addEventListener("visibilitychange", t), () => {
      document.removeEventListener("visibilitychange", t);
    };
  }, [e]);
}
function cg(e, t) {
  if (!(e instanceof Date && t instanceof Date))
    throw new Error(
      `Both start and end must be valid Date objects: start=${e} end=${t}`
    );
  return (t.getTime() - e.getTime()) / 1e3;
}
function pg(e) {
  const t = /\[(.+)\]\(([^ ]+)( "(.+)")?\)/gm, n = e.match(t);
  return (n == null ? void 0 : n.length) || 0;
}
function fg(e) {
  return new TextEncoder().encode(e).length;
}
const dg = 991, hg = [];
function ni({ submitEventExternal: e }) {
  var lt, yt;
  const {
    chatApi: t,
    conversationScreen: n,
    launchButton: r,
    proactiveMessage: i,
    userTracking: o,
    webExperimentation: a,
    xpertKey: l
  } = Se(Oe), s = it(dg), [, u] = ye(!1), [, c] = ye(!1), [p, m] = ye(hg), [f, T] = ye(!1), [x, k] = ye(!1), [M, z] = ye(!1), [E, _] = ye(""), [U, b] = ye(!1), [L, $] = ye(!0), [W, K] = ye(!1), [A, w] = ye(!1), [j, O] = ye(!1), F = We(null), Q = We(null), V = We(null), q = Ne.get(`${l}-test`) === "1";
  lg(
    n.liveChat.enabled,
    M,
    z
  );
  const X = Tt(
    ({ name: R, payload: ee }) => {
      const me = So(o == null ? void 0 : o.payloadParams, ee);
      e ? e({ name: R, payload: me }) : V.current.track(
        // TODO: this is untestable - create a custom hook to get submit event function.
        R,
        me
      );
    },
    [e, o.payloadParams]
  ), g = Tt(async () => {
    if (window != null && window.OnetrustActiveGroups && window.OnetrustActiveGroups.split(",").includes("C0003"))
      try {
        const R = Ne.get(
          `${l}-conversation-history-id`
        );
        if (!R)
          return;
        T(!0);
        const ee = await fetch(
          `${t.endpoint}/xpert-chat/${R}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json"
            }
          }
        );
        if (ee.status === 404) {
          Ne.remove(`${l}-conversation-history-id`);
          return;
        }
        if (!ee.ok)
          throw new lr(`HTTPError: ${ee.status} ${ee.statusText}`);
        const me = await ee.json();
        m(
          me.map((le) => ({
            ...le,
            disableFeedback: !0
          }))
        ), w(!0), O(!0);
      } catch (R) {
        console.error(R);
      } finally {
        T(!1);
      }
  }, [l, t.endpoint]);
  ug(g), xe(() => {
    let R, ee;
    return o.enabled && (R = setInterval(() => {
      var le;
      console.log("Chatbot - Finding Segment"), (le = window.analytics) != null && le.track && (console.log("Chatbot - Segment found"), V.current = window.analytics, clearInterval(R), clearTimeout(ee), u(!0));
    }, 1e3), ee = setTimeout(() => {
      clearInterval(R);
    }, 6e4)), () => {
      clearInterval(R), clearTimeout(ee);
    };
  }, [o.enabled, o.prefix]), xe(() => {
    let R, ee;
    return R = setInterval(() => {
      a.enabled && (console.log("Chatbot - Finding Optimizely"), window.optimizely && window.experiments && (console.log("Chatbot - Optimizely found"), clearInterval(R), clearTimeout(ee), c(!0)));
    }, 1e3), ee = setTimeout(() => {
      clearInterval(R);
    }, 6e4), () => {
      clearInterval(R), clearTimeout(ee);
    };
  }, [a.enabled, a.experimentName]);
  const he = (R) => {
    var ee, me;
    (ee = R == null ? void 0 : R.target) != null && ee.href && X({
      name: `${o.prefix}.bi.xpert.chatbot.popup.chat.message.link.clicked`,
      payload: {
        category: "2u",
        label: "xpert-chatbot",
        link: (me = R == null ? void 0 : R.target) == null ? void 0 : me.href,
        isTestUser: q
      }
    });
  }, Me = sg(
    a.experimentName
  );
  if (a.enabled && !a.experimentName && !q)
    return a.enabled && !a.experimentName && console.log(
      `Chatbot - Experiment not setup: ${l}, ${Me}, ${window.optimizely}`
    ), q || console.log(`Chatbot - Test user not setup: ${l}, ${q}`), null;
  if (o.prefix && !((lt = V == null ? void 0 : V.current) != null && lt.track) && !e)
    return console.log(`Chatbot - Segment not setup: ${l}`), null;
  const h = () => {
    _(""), Q.current.value = "", Q.current.style.height = "auto";
  }, ge = (R, ee) => {
    X({
      name: `${o.prefix}.bi.xpert.chatbot.popup.chat.message.response`,
      payload: {
        category: "2u",
        label: "xpert-chatbot",
        linkCount: pg(R),
        apiResponseMessage: R,
        isTestUser: q,
        conversationHistoryId: ee
      }
    });
  }, ke = ({
    conversationSize: R,
    userInputMessage: ee,
    apiResponseMessage: me,
    elapsedSeconds: le,
    conversationByteSize: Qe
  }) => {
    X({
      name: `${o.prefix}.bi.xpert.chatbot.popup.chat.message.elapsed.seconds`,
      payload: {
        category: "2u",
        label: "xpert-chatbot",
        isTestUser: q,
        conversationSize: R,
        userInputMessage: ee,
        apiResponseMessage: me,
        elapsedSeconds: le,
        conversationByteSize: Qe
      }
    });
  }, re = async (R) => {
    try {
      if (R.trim().length === 0)
        return;
      const ee = /* @__PURE__ */ new Date();
      O(!1), b(!1);
      const me = p.filter((J) => J.role === "user").length + 1;
      X({
        name: `${o.prefix}.bi.xpert.chatbot.popup.chat.message.sent`,
        payload: {
          category: "2u",
          label: "xpert-chatbot",
          totalUserInputMessagesSent: me,
          userInputMessage: R,
          isTestUser: q
        }
      }), h();
      let le = Ne.get(`${l}-conversation-history-id`) || "";
      !le && n.conversationHistory.enabled ? m([
        {
          role: "user",
          content: R
        }
      ]) : m([
        ...p,
        {
          role: "user",
          content: R
        }
      ]), T(!0);
      const Qe = [
        ...p,
        {
          role: "user",
          content: R
        }
      ].map((J) => ({
        role: J.role,
        content: J.content
      })), $e = await fetch(t.endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Conversation-History-Id": le
        },
        body: JSON.stringify({
          message_list: Qe,
          ...t.payloadParams
        })
      });
      if (!$e.ok)
        throw new lr(`HTTPError: ${$e.status} ${$e.statusText}`);
      le = $e.headers.get("Conversation-History-Id"), le && Ne.set(
        `${l}-conversation-history-id`,
        le,
        { expires: 1 }
      );
      const Mt = await $e.json(), I = Mt.content, S = Mt.live_agent;
      ge(I, le);
      const Y = /* @__PURE__ */ new Date();
      ke({
        conversationByteSize: fg(JSON.stringify(Qe)),
        conversationSize: p.length + 2,
        userInputMessage: R,
        apiResponseMessage: I,
        elapsedSeconds: cg(ee, Y)
      }), m((J) => [
        ...J,
        {
          role: "assistant",
          content: I,
          liveAgent: S,
          createdAt: /* @__PURE__ */ new Date()
        }
      ]), w(!1), T(!1), h(), O(!0);
    } catch (ee) {
      T(!1), h(), b(!0), console.error(ee);
    }
  }, we = () => {
    z(!1), k(!0), X({
      name: `${o.prefix}.bi.xpert.chatbot.action.button.clicked`,
      payload: {
        category: "2u",
        label: "xpert-chatbot",
        isTestUser: q
      }
    });
  }, ve = (R) => {
    X({
      name: `${o.prefix}.bi.xpert.chatbot.${R ? "normal" : "expand"}.size.button.clicked`,
      payload: {
        category: "2u",
        label: "xpert-chatbot",
        isTestUser: q
      }
    }), $(R);
  }, Ue = () => {
    k(!0), X({
      name: `${o.prefix}.bi.xpert.chatbot.proactive.message.clicked`,
      payload: {
        category: "2u",
        label: "xpert-chatbot",
        isTestUser: q
      }
    });
  }, ze = () => {
    X({
      name: `${o.prefix}.bi.xpert.chatbot.proactive.message.closed`,
      payload: {
        category: "2u",
        label: "xpert-chatbot",
        isTestUser: q
      }
    });
  }, Xe = () => {
    k(!1), K(!1), X({
      name: `${o.prefix}.bi.xpert.chatbot.popup.chat.minimized`,
      payload: {
        category: "2u",
        label: "xpert-chatbot",
        isTestUser: q
      }
    });
  }, at = () => {
    var R;
    /* istanbul ignore next @preserve */
    Q.current && (Q.current.style.height = "auto", Q.current.style.height = `${Math.min(
      (R = Q.current) == null ? void 0 : R.scrollHeight,
      120
    )}px`);
  }, kt = (R) => {
    _(R.target.value);
  }, jt = (R) => {
    R.key === "Enter" && E.trim() === "" || R.key === "Enter" && !R.shiftKey && (R.preventDefault(), re(E));
  }, Et = (R, ee = "") => {
    const me = p.map((le, Qe) => R === Qe ? (X({
      name: `${o.prefix}.bi.xpert.chatbot.feedback.thumbs.${ee.toLowerCase()}.clicked`,
      payload: {
        category: "2u",
        label: "xpert-chatbot",
        userInputMessage: p[R - 1],
        apiResponseMessageIndex: R,
        apiResponseMessage: p[R],
        isTestUser: q
      }
    }), {
      ...le,
      feedbackThumbType: ee
    }) : le);
    m(me), w(!1);
  }, Ke = ((yt = r.animatedGraduate) == null ? void 0 : yt.enabled) && a.enabled && Me === "A", mt = i.enabled ? Ke ? s ? i.style.mobile.animatedGraduateExperiment : i.style.animatedGraduateExperiment : s ? i.style.mobile : i.style : null;
  return (
    // do not remove this class as it's needed to turn off chatbot
    /* @__PURE__ */ v.jsxs("div", { className: "xpert_chatbot", children: [
      i.enabled && /* @__PURE__ */ v.jsx(
        el,
        {
          showMessage: !x,
          style: mt,
          onClose: ze,
          onClick: Ue,
          cookieName: `${l}-proactive-message-xpert-chatbot`,
          children: /* @__PURE__ */ v.jsx("div", { className: "xpert-chatbot-proactive-message", children: /* @__PURE__ */ v.jsxs("div", { className: "xpert-chatbot-proactive-message__text", children: [
            i.textPrefix && /* @__PURE__ */ v.jsx(
              "span",
              {
                style: {
                  paddingRight: i.showEmoji ? "0" : "0.3rem"
                },
                children: i.textPrefix
              }
            ),
            i.showEmoji && /* @__PURE__ */ v.jsx(
              "span",
              {
                role: "img",
                "aria-label": "Hand wave emoji",
                className: "xpert-chatbot-proactive-message__wave",
                style: {
                  padding: i.textPrefix ? "0 0.3rem" : "0 0.3rem 0 0"
                },
                children: "👋"
              }
            ),
            /* @__PURE__ */ v.jsx("span", { children: i.text })
          ] }) })
        }
      ),
      Ke && /* @__PURE__ */ v.jsx(
        Ps,
        {
          handleFloatingActionButtonClick: we
        }
      ),
      !Ke && /* @__PURE__ */ v.jsx(
        zs,
        {
          handleFloatingActionButtonClick: we
        }
      ),
      /* @__PURE__ */ v.jsx(Us, {}),
      x && !M && /* @__PURE__ */ v.jsx(Ar, { isNormalSize: L, isMounted: W, children: /* @__PURE__ */ v.jsx(
        "div",
        {
          ref: F,
          style: { display: "flex", flexDirection: "column", height: "100%" },
          "aria-label": "XPERT Chatbot Popup",
          role: "dialog",
          children: /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
            /* @__PURE__ */ v.jsx(
              fa,
              {
                onClose: Xe,
                isMounted: W,
                isNormalSize: L,
                setIsMounted: K,
                setIsNormalSize: ve
              }
            ),
            /* @__PURE__ */ v.jsxs(
              "div",
              {
                style: {
                  padding: "0 1.5rem",
                  overflow: "auto",
                  overscrollBehavior: "contain",
                  position: "relative"
                },
                children: [
                  /* @__PURE__ */ v.jsx(
                    og,
                    {
                      messages: p,
                      loading: f,
                      isNormalSize: s || L,
                      onFeedbackThumbSelection: Et,
                      onPromptClick: re,
                      handleMessageLinkClicked: he,
                      submitEvent: X,
                      setLiveChatOpen: z,
                      isTestUser: q
                    }
                  ),
                  f && /* @__PURE__ */ v.jsx(Ja, { disableScroll: A }),
                  U && /* @__PURE__ */ v.jsx(lr, {})
                ]
              }
            ),
            /* @__PURE__ */ v.jsx(Wh, {}),
            /* @__PURE__ */ v.jsxs("div", { style: { marginTop: "auto", display: "flex" }, children: [
              n.liveChat.enabled && /* @__PURE__ */ v.jsx(
                _n,
                {
                  submitEvent: X,
                  setLiveChatOpen: z,
                  isTestUser: q,
                  containerStyle: { margin: "auto -1rem auto 1rem" },
                  buttonClassName: "xpert-chatbot-popup__live-chat--btn-outline"
                }
              ),
              /* @__PURE__ */ v.jsx("div", { style: { width: "100%" }, children: /* @__PURE__ */ v.jsx(
                Kr,
                {
                  inputRef: Q,
                  loading: f,
                  hasXpertMessages: j,
                  hasError: U,
                  userInput: E,
                  handleSend: re,
                  handleInput: at,
                  handleChange: kt,
                  handleKeyDown: jt
                }
              ) })
            ] })
          ] })
        }
      ) })
    ] })
  );
}
ni.propTypes = {
  submitEventExternal: N.func
};
ni.defaultProps = {
  submitEventExternal: null
};
const tl = ({ children: e, configurations: t = {}, xpertKey: n = null }) => {
  const r = {
    configurations: t,
    xpertKey: n
  };
  return /* @__PURE__ */ v.jsx(zo, { ...r, children: e });
};
tl.propTypes = {
  children: N.element,
  configurations: N.object,
  xpertKey: N.string
};
function gg({ configurations: e = {}, key: t, submitEventExternal: n, xpertKey: r }) {
  return /* @__PURE__ */ v.jsx(
    tl,
    {
      xpertKey: r,
      configurations: e,
      children: /* @__PURE__ */ v.jsx(ni, { submitEventExternal: n })
    },
    t
  );
}
gg.propTypes = {
  configurations: N.object,
  key: N.string,
  submitEventExternal: N.func,
  xpertKey: N.string.isRequired
};
export {
  gg as Chatbot,
  os as EDXConfig,
  as as EmersonSpeechConfig,
  ls as GetSmarterConfig,
  ss as degreesCanvasSupportConfig,
  us as degreesMoodleSupportConfig
};
